// Auto-generated: French UI string → phrases key
export const PHRASE_KEYS = {
  " — choisir un canton ci-dessus pour importer les taux standards.": "p_94b2469b02",
  " — cliquer une ligne pour affecter en un clic. Recliquer le tag pour désarmer.": "p_7ffc24cf4f",
  " — définir le dernier mois clôturé (Réglages).": "p_1bec15a303",
  " — exclus du périmètre analytique (ni capacité, ni charge).": "p_96dc3d9f92",
  " — manuel (saisie libre)": "p_e20be5029d",
  " — puis cliquer les lignes à affecter": "p_2cfc4d34ca",
  " — réel via les contrats. La planification commence en {{month}} {{startYear}}.": "p_a7483f2d5a",
  " — répartie sur la capacité pratique (Σ TR).": "p_7d298418d3",
  " — spécifique au groupe (gardée dans son groupe).": "p_39db06c773",
  " : les lignes existantes sont mises à jour, les nouvelles ajoutées, ": "p_9728798581",
  " : Rev @ STD = Σ std × billable · Price = Σh × (tarif effectif − std) = réalisation vs prix standard. Somme = Billed.": "p_2376acd24d",
  " : Volume = Δh × tarif PY · Price = Σh_cy × Δtarif · Mix = bascule entre employés · Scope = arrivées − départs. · ": "p_8dd91c521e",
  " ?\nLes fériés cantonaux actuels seront remplacés (manuels conservés).": "p_0177954edc",
  " · {{amount}} depuis le 31.12": "p_0bd9dd9797",
  " · {{count}} sélectionné(s)": "p_3f3b890cfe",
  " · {{margin}} % du CA": "p_a6a2a022a7",
  " · {{pct}} % du CA net (12 m)": "p_6373b1e2e4",
  " · écart {{sign}}{{pts}} pt ≈ {{amount}}": "p_f8a913c06d",
  " · estimé": "p_b838eeca7f",
  " · filtrés sur {{count}}": "p_6aca80257c",
  " · impact EBIT ≈ {{amount}} sur 12 mois": "p_7923e427f3",
  " · marge moyenne {{year}} : {{margin}} %": "p_ee7da10c03",
  " · moyenne {{year}} : {{amount}} · {{pct}}": "p_1d221afa7d",
  " · moyenne {{year}} : {{pct}} %": "p_7d3618e7d0",
  " · moyenne {{year}} : {{ratio}}×": "p_82ceee9952",
  " · N−1": "p_e61c67b180",
  " · Palestre": "p_fec4699de6",
  " · prix ": "p_8901ac1c7f",
  " · projeté": "p_00b14e9616",
  " · réf 1,3×": "p_126fe6ee85",
  " · runway {{months}} mois avant épuisement de la trésorerie": "p_a5461bc0ce",
  " · valable toutes années": "p_4aa47ac07d",
  " » ?": "p_26a24e6170",
  " (&lt; 2)": "p_9c43c54169",
  " (1 pt = {{amount}})": "p_bcef64e6a3",
  " (cible 100 %)": "p_0d3a5d013c",
  " (projeté)": "p_e890843ec7",
  " (sinon : ajoutés)": "p_139ee047ff",
  " (un CA total). Le ": "p_828e0c4134",
  " (un prix/h) ou ": "p_100eb51d65",
  " = saisie · clic pour éditer)": "p_373e510f12",
  " active": "p_f7ea7110cc",
  " actives": "p_bfed4bee21",
  " ce groupe en un coup. Les colonnes de coût (salaire, charges sociales, indemnités…) sont": "p_5ddc84a1b9",
  " ce groupe en un coup. Les colonnes de coût (salaire, charges sociales, indemnités…) sont gérées dans le module People.": "p_9e1c36bad9",
  " Clique sur « Recharger » pour importer les fériés cantonaux.": "p_a14f8ec8a2",
  " disponible (TR)": "p_ee4b94fdba",
  " du tenant, un onglet par table : RH (People, Contracts, Annual extras, LPP, hours, calendrier), TD-ABC (pools, personnes, temps, capacité, charges indirectes/sociales, overhead, profitabilité, key figures P&L), Trésorerie (scénarios + lignes), charges/paramètres et valeurs clés. Seuls les onglets présents sont traités. Mise à jour ": "p_93f3baa1a5",
  " et une cellule vide ne remplace jamais une valeur existante.": "p_4fa2d6e6a9",
  " facturé sur ": "p_c2715b54c0",
  " gérées dans le module People.": "p_082c79885a",
  " j ouvr.": "p_dbecd91447",
  " non créé pour ce tenant.": "p_4a8769c043",
  " pers.": "p_098a183750",
  " personnes": "p_39997fa751",
  " puis clique un groupe ci-dessus pour armer un pinceau — chaque clic sur une ligne affecte": "p_080b8365bb",
  " puis clique un groupe ci-dessus pour armer un pinceau — chaque clic sur une ligne affecte ce groupe en un coup. Les colonnes de coût (salaire, charges sociales, indemnités…) sont gérées dans le module People.": "p_311df302f4",
  " regroupe au rapport.": "p_b2480314ed",
  " rien n'est supprimé": "p_9cb563e10f",
  " total — toutes années)": "p_03793e95de",
  "% NF": "p_bedc413989",
  "↳ Sur-production": "p_79e73acda6",
  "AAP, AANP, LAA complémentaire, indemnités journalières — part employeur": "p_d9c50273d6",
  "AVS / AI / APG, AC, allocations familiales, frais admin.": "p_48524730d7",
  "Analyse des marges": "p_4b5ec940f6",
  "Année antérieure": "p_f00d27fafc",
  "Assurances": "p_7011b97efb",
  "Assurances %": "p_f97e31919c",
  "Au 01.01": "p_ea5ee0a15c",
  "Base %": "p_6f0d3bb257",
  "Base taux horaire": "p_1149e8d5c1",
  "Contrats": "p_d35fbb3297",
  "Contrôle": "p_e988877e60",
  "Export incomplet : des onglets n’avaient pas fini de charger.": "p_4198d9b4f5",
  "Heures NF": "p_ce20c4f60b",
  "Heures TF": "p_218c01100a",
  "Heures TF moins heures allouées : zéro quand toute la production est ventilée": "p_5732db181f",
  "Heures facturables": "p_41dbdb689e",
  "Heures facturables (TF)": "p_386a358be5",
  "Heures facturables par activités / services": "p_3ebc2e41f7",
  "Heures indirectes (Gestion, Superv., Congés)": "p_a0718225e0",
  "Heures non facturables saisies dans « Heures affectées »": "p_62f5bc8430",
  "Masse chargée": "p_8861abc457",
  "Masse salariale chargée": "p_0b35ba24bd",
  "Mouvement": "p_a9f1bf195d",
  "Moyenne": "p_ef33304d4f",
  "Personne, groupe ou taux…": "p_ce92f5450c",
  "Prévoyance professionnelle, part employeur.": "p_dd4e83143f",
  "Rémunération": "p_55b7787a46",
  "Salaires chargés": "p_62f81c6818",
  "Simulation": "p_8e34943c35",
  "Sur-production": "p_1704e9a903",
  "Synthèse des effectifs": "p_42b25c148b",
  "Taux NF (% vs TO)": "p_d62040ba6e",
  "Taux TF (% vs TO)": "p_8b862c259a",
  "Temps NF": "p_6b0255b2e7",
  "Temps TF": "p_1cf6af1b8e",
  "Temps ouvert (TO)": "p_19a8ed6c53",
  "Total charges employeur": "p_5131396cbc",
  "Usage de la capacité": "p_5ec97dc6e8",
  "Vue": "p_09237dbacb",
  "affecté au-delà de la capacité": "p_c8a7e8322f",
  "interne · saisi": "p_af7c6a54b0",
  "présent, sans affectation": "p_148334f911",
  "vendu · saisi": "p_476a80944f",
  "– Saisir –": "p_6d180c5fef",
  "— (aucun)": "p_e29ab91c54",
  "— (effacer)": "p_7a1fb87b87",
  "— (inchangé)": "p_fdbef2ef40",
  "— (inchangée)": "p_05d6f1364f",
  "— (sans)": "p_582e1440a8",
  "— aucune (écriture à une patte, déséquilibre voulu) —": "p_c6c172e2f8",
  "— aucune / libre —": "p_6084625b53",
  "— canton {{canton}}": "p_0a7d700daf",
  "— clique les comptes pour les affecter.": "p_fc94f7e3c7",
  "— compte —": "p_6a8ce09471",
  "— Non affecté —": "p_e57d30aa45",
  "— non mappé —": "p_e947515ac9",
  "— planification personnel (charges dérivées des contrats / plan RH, recopiées sur les 12 mois à venir).": "p_3bd54fc091",
  "— planification possible dès": "p_d324e177bd",
  "— s/o": "p_010db2588e",
  ", masse / coût employeur / FTE.": "p_a7e0a82545",
  ". À chaque échéance, on paie les cotisations (salarié + employeur) accumulées depuis l'échéance précédente.": "p_9135a2feed",
  ". Saisis-les d'abord dans Input People → Charges sociales.": "p_bad3483302",
  ". Utiliser « + Ajouter un complément ».": "p_fe51aaac11",
  ". Utiliser « + Ajouter un frais ».": "p_2c1bbfd209",
  ". Utiliser « + Ajouter une indemnité ».": "p_317c49b7b5",
  "· Indemnité journalière :": "p_904468208d",
  "· par personne": "p_6b1d644668",
  "‹ Retour": "p_2f6ffb7abc",
  "({{count}} groupes)": "p_9c10d31c66",
  "(+) : encaissement / (−) : décaissement": "p_2abbd36a66",
  "(= date d'entrée)": "p_7f1e941c61",
  "(2ᵉ degré · quick ratio)": "p_f235252ace",
  "(annualisé)": "p_ed2eba6dbf",
  "(avant coût de financement)": "p_210c36976c",
  "(avec son plan comptable) pour les voir ici.": "p_654fccfc05",
  "(Bêta — en test)": "p_86a4995799",
  "(CHF par heure de capacité pratique TR)": "p_bd6e0069c4",
  "(CHF/h · total CHF)": "p_8933fdc49b",
  "(comparé)": "p_fe6c7ca125",
  "(copie)": "p_0792d698b9",
  "(coûts fixes cash)": "p_ec3b817357",
  "(cumulée)": "p_14d943f8e8",
  "(décimal)": "p_bba84b6175",
  "(défaut contrats)": "p_8fd073ce45",
  "(facturable + non-fact.) ÷ TR": "p_bcdfc9532e",
  "(fonds de roulement d'exploitation)": "p_17ae30976a",
  "(Indemnités payées + autres frais) ÷ TR": "p_50cf96b9aa",
  "(laisser vide pour effacer les notes)": "p_c49ed5641c",
  "(les charges sont déjà négatives → une marge s'écrit avec +). Un ratio :": "p_f81891c745",
  "(lignes de salaire).": "p_25b7281abb",
  "(mois de coûts fixes)": "p_53599c6288",
  "(mois précédant le début du plan). Seuls les comptes avec un solde sont listés. Cochez ceux à inclure et réglez le rythme de réalisation.": "p_1efd07c815",
  "(optionnel)": "p_6f73b2322a",
  "(People → Charges sociales).": "p_4c9f831009",
  "(réel + prév.)": "p_3c43b9fea4",
  "(réel + prév.) · total · vs": "p_822cb3c501",
  "(revenus vs charges · 12 mois glissants)": "p_82332a964f",
  "(saisonnalité N−1)": "p_6cf5d4500e",
  "(sans dept)": "p_d1f9d454e2",
  "(VA ÷ charges de personnel)": "p_6bda23e540",
  "(vide = effacer)": "p_6e86e1f04f",
  "(vide = en cours)": "p_baa81f2655",
  "(vide = inchangé)": "p_2347bdd50c",
  "(vide = inchangée)": "p_24f5503f02",
  "(vide = ouvert)": "p_cf4f072cd9",
  "{{count}} ligne(s) copiées depuis {{year}}": "p_b4a5fd1327",
  "{{count}} ligne(s) importées depuis {{canton}} pour {{year}}": "p_eafc54ea3a",
  "{{count}} mouvement{{s}} antérieur{{s}} à la clôture — <strong>ignoré{{s}}</strong> du calcul. À passer en contrat ou à supprimer ci-dessous.": "p_6ff12717fa",
  "{{count}} sélectionnée": "p_7a4ca9148e",
  "{{count}} sélectionnées": "p_d1a348c28a",
  "{{days}} j × {{hours}} h — dérivé du contrat": "p_6bc7b0c24d",
  "{{days}} j × {{hours}} h — dérivé du contrat (Vacation days × hours/day)": "p_bfb32c4b49",
  "{{days}} j × {{hours}} h — dérivé du contrat (Vacation days × taux × mois/12), se modifie dans Contracts": "p_ab2cb4967c",
  "{{n}} compte(s) à mapper": "p_093c64ccff",
  "{{n}} ligne(s) non classée(s)": "p_9d2ff48e51",
  "{{n}} non classé(s)": "p_39cf62f597",
  "{{n}} rapport(s) sélectionné(s)": "p_ed19991e9e",
  "{{pct}} % des facturables": "p_f236d0571b",
  "{{pct}} % du TO": "p_55e1a340db",
  "{{pct}} % du TO · {{pct2}} % du TR": "p_a98eeda077",
  "{{pct}} % du TR": "p_0a5242f5e0",
  "{{pct}}% annualisé": "p_5871f1bccb",
  "{{pct}}% du brut": "p_7c2d5141fe",
  "{{pct}}% du brut · avantages inclus": "p_810a37d2d1",
  "/ an": "p_b2ccb20667",
  "/ mois": "p_95e9be7f79",
  "/mois": "p_ba2c5ddd7e",
  "% appliqué au résultat avant impôts.": "p_031dbf5a2b",
  "% appliqué aux salaires + primes.": "p_2180c915cd",
  "% br.": "p_dad313316a",
  "% d'une autre ligne — montant dérivé d'une ligne de base (ex. charges sociales = 18 % des salaires).": "p_2000c70f01",
  "% d'une ligne": "p_9ae183b19f",
  "% de revenus": "p_0832706a69",
  "% des facturables": "p_c7b774f8ae",
  "% des salaires bruts": "p_132d376823",
  "% du CA": "p_df13a89a85",
  "% du CA net (12 m)": "p_0738ea5d9b",
  "% du CA net (réel)": "p_be457b933d",
  "% du sal. réf.": "p_00168fb157",
  "% du TO": "p_008e28fa14",
  "% du TR": "p_9bfb0206db",
  "% non réalisé": "p_e6bd731c8b",
  "% non-prod.": "p_9bc3ea0478",
  "% Résultat net": "p_e9dfe53d10",
  "% sur encaissement client final — saisie libre.": "p_bbb87b75e0",
  "% Valeur ajoutée": "p_7a9a480eea",
  "% vs N−1": "p_1f9a7f9f38",
  "← Accueil": "p_8a753db12f",
  "← Précédent": "p_3ec988c1b0",
  "→ {{amount}} fin {{year}}": "p_8feefdef2c",
  "↑ Importer JSON": "p_4b18bc5b97",
  "↓ Exporter JSON": "p_dff39a6853",
  "↺ défaut": "p_0475ab80bb",
  "↻ Ancrer sur le dernier mois clôturé (départ {{label}})": "p_b3e449bbf7",
  "↻ Depuis {{year}}": "p_3609a6618e",
  "↻ Tirer du bilan": "p_a5a3f79f95",
  "↻ Tirer du bilan ({{amount}})": "p_f6c6927ddc",
  "+ {{n}} poste(s) sans mouvement": "p_83e387fa35",
  "+ Ajouter": "p_daff7acf77",
  "+ Ajouter un collaborateur": "p_47a017b003",
  "+ Ajouter un complément": "p_b7b01f1d89",
  "+ Ajouter un contrat": "p_5b4ea4f2e0",
  "+ Ajouter un frais": "p_29dfdcd918",
  "+ Ajouter un groupe": "p_311eaa1b0f",
  "+ Ajouter un jeton": "p_50a416fc2a",
  "+ Ajouter une année": "p_ecce6d8981",
  "+ Ajouter une charge indirecte": "p_0be10260e2",
  "+ Ajouter une charge manuelle": "p_c1ca2f6bad",
  "+ Ajouter une indemnité": "p_b4d9342325",
  "+ Ajouter une ligne": "p_999d5dd736",
  "+ Ajouter une ligne de crédit": "p_9b188920b8",
  "+ Ajouter une ligne…": "p_d9b5a8f698",
  "+ Ajouter une personne": "p_d1b565f1d8",
  "+ Ajouter une prime": "p_dab524408d",
  "+ Ajouter une variation": "p_f134b6bdf0",
  "+ Ajustement salaires": "p_5a82ec9113",
  "+ Amortissements": "p_e24a199822",
  "+ Autres actifs circulants": "p_cc28406fdf",
  "+ Cession": "p_d8bdc2d283",
  "+ Créances-clients": "p_abf1f1b338",
  "+ Définir les groupes": "p_b9e1446f5c",
  "+ Financement": "p_0c4a1e0332",
  "+ Frais": "p_2dd39aa856",
  "+ Gestion entreprise réaffectée": "p_e98eb7869c",
  "+ Ligne calculée (%)": "p_03459e1071",
  "+ Ligne calculée (valeur)": "p_40eeb91f22",
  "+ ligne manuelle": "p_fc4805b808",
  "+ marchandises": "p_3c74266c3b",
  "+ Nouveau profil": "p_43d690afe1",
  "+ Nouvel actif": "p_2e71f91644",
  "+ Nouvelle": "p_c846929450",
  "+ Nouvelle écriture": "p_e6c165417c",
  "+ Plus d'informations": "p_296cb3c3c4",
  "+ Position": "p_f0ceca66be",
  "+ Position dès {{month}} {{year}}": "p_d653f2a2ef",
  "+ Rapport": "p_2e36279744",
  "+ Service": "p_629373b067",
  "+ Stocks": "p_8198accb93",
  "+ Supervision production réaffectée": "p_e347435a35",
  "+ Titre de bloc": "p_417c640905",
  "+ tranche": "p_6318d1bf6c",
  "+{{pct}}% vs brut · à date": "p_7a056076c6",
  "+{{pct}}% vs brut · indem. reçues exclues": "p_ccb7435c30",
  "± Variation BFRE": "p_9c5f91f40f",
  "<b>Manuel</b> — saisie directe : salaires nets mensuels, variation par mois, échéancier des charges sociales et taux.": "p_9b0a8934e1",
  "= 0 ✓": "p_643ff22007",
  "= Capacité (TR)": "p_45b6d60236",
  "↳ Capacité disponible (TR)": "p_4e1e99a7cc",
  "= Capacité inutilisée": "p_7d77d9d9a9",
  "= Capacité pratique (TR)": "p_bbf63c2af3",
  "= Charges de personnel à allouer": "p_2cc44aeda0",
  "= Coût capacité": "p_fe4f7174de",
  "= Coût employeur": "p_2c019b4923",
  "= Coût total du personnel": "p_4d6b4a6a6b",
  "= décaissement (passif).": "p_c43b446c45",
  "= encaissement (actif),": "p_38343b8083",
  "= EPT de capacité": "p_10dd061aa3",
  "= Salaire net": "p_024027c593",
  "= Salaires nets": "p_3df186c44c",
  "= stable": "p_e2000d7556",
  "↳ Temps ouvert (TO)": "p_1acb3db0a5",
  "= Total autres coûts": "p_d2967bafe2",
  "= Travail productif (LCR × TR)": "p_c369654252",
  "= Valeur ajoutée": "p_cfdec7070d",
  "− Absentéisme": "p_db91a6d5f7",
  "− Congés spéciaux": "p_1c3958a7af",
  "− Congés spéciaux (exclus)": "p_157c7e8a39",
  "− Corporate": "p_4e10065dfe",
  "− Heures TF": "p_06ffd7585d",
  "− NF client": "p_9b560b86ea",
  "− coûts variables": "p_b172e06f85",
  "− Dettes à court terme (DCT)": "p_f4a4f19dc6",
  "− Facturable": "p_820223df04",
  "− Gestion / Superv. / Congés sp.": "p_a97fe55ae1",
  "− Gestion entreprise": "p_b044c811f8",
  "− Masquer": "p_0b1a5a9c5e",
  "− Non-facturable": "p_cc356f183a",
  "− Réduction": "p_f4473dfdd7",
  "− Réduction dès {{month}} {{year}}": "p_b82b2511ff",
  "− Supervision": "p_e61a7cc437",
  "− Supervision production": "p_6a5943194c",
  "− Temps non productif déchargé": "p_086e3d357a",
  "− Vacances & congés": "p_b4f1246ae0",
  "≥ 0.2–0.3": "p_640a7d8847",
  "≥ 1.0": "p_0e32d806d8",
  "⊞ Tout ouvert": "p_f57597d309",
  "⊟ Synthétique": "p_ef9bd5ec2f",
  "⊡ Ouvert": "p_c5f7693dc5",
  "⎙ Imprimer / PDF": "p_540feb64a1",
  "▤ Visualiser le graphique": "p_e4cfb27ad6",
  "▲ Masquer le graphique": "p_1410c2f927",
  "⚑ Réel": "p_fc7ac8dd69",
  "⚠ Aucun revenu facturé. Saisis le montant facturé par employé dans la page Revenues.": "p_ea5ea77112",
  "⚠️ Calendrier non saisi pour {{year}} — prorata mensuel à plat (à défaut).": "p_9f323a9088",
  "✎ Édition": "p_709e7a0aff",
  "✏️ Éditer": "p_76143a4cc1",
  "✓ Ancré sur le dernier mois clôturé ({{label}})": "p_c6d0efcd16",
  "✓ Brush mode": "p_05023fa7d6",
  "✓ cohérent": "p_d635480a3f",
  "✓ Édition": "p_8e0fcdf659",
  "✓ investissement + financement dérivés du Bilan (nouvel actif / financement édités au Bilan)": "p_0d8048eb07",
  "✓ Mapping": "p_9293240647",
  "✓ Notes": "p_1913a2c289",
  "✕ Effacer": "p_5bb1136851",
  "✕ Fermer": "p_c1346c1267",
  "⟲ Réinitialiser": "p_ce6c96dcbb",
  "⟳ Chargement des données…": "p_c32047ceca",
  "⟳ Chargement…": "p_2250895275",
  "💡 Les taux de cotisations cantonales et d'assurances (AVS, AC, LPP, LAA…) sont gérés dans l'onglet": "p_afd5eaa167",
  "📋 Charger 18 charges par défaut": "p_274a278768",
  "📝 Notes": "p_94a2ce2644",
  "🖌 Brush mode": "p_86f75d274a",
  "🖌 Mode affectation": "p_8d5f7256b0",
  "🖌 Mode affectation · ON": "p_beb40b6e49",
  "🗂 Mapping": "p_7b7b673750",
  "🗑 Vider l'année": "p_025da9a2f1",
  "${H} mois": "p_9c9bbf6ce6",
  "1 mois · {{month}}": "p_b1275b2599",
  "1 versement": "p_ab4b7b8299",
  "1.5–2.0": "p_359adf1dbc",
  "100% (CHF/m)": "p_f4349aeb56",
  "12 cellules à 0, à remplir librement.": "p_0793669379",
  "12 mois": "p_3cbeea57e3",
  "12 mois glissants": "p_87ea112752",
  "12 mois glissants · base TTC": "p_2ac2f177e8",
  "12 mois glissants (au réel) · composantes → BFRE → liquidités": "p_bfa166a441",
  "12 mois glissants indisponibles — il faut l'historique mensuel de l'année précédente.": "p_dd63e98f78",
  "12 mois roulants": "p_bc4da8f777",
  "13 mois": "p_306f9afbd3",
  "13e / 14e": "p_2b94de7da5",
  "13ᵉ / 14ᵉ salaire (pondéré · contrats)": "p_4d133e59c2",
  "13e salaire": "p_290903c873",
  "13e salaire — 1er versement": "p_a503b26881",
  "13e salaire — 2e versement": "p_8a3bee259f",
  "13e salaire — mois de versement": "p_8df6978acf",
  "13e salaire — nombre de versements": "p_56a7aaac16",
  "13e salaire (14 salaires)": "p_c38de6541c",
  "13e versé en 1 fois.": "p_9631a0059a",
  "13e versé en 2 fois.": "p_a20112e744",
  "14e salaire": "p_6c3ac99b45",
  "14e salaire — mois de versement": "p_95054cecf6",
  "1ᵉ degré": "p_c2751ab5a2",
  "2 versements (scindé 50/50)": "p_bfa2e81d58",
  "2ᵉ degré": "p_814f280a5f",
  "2e versement du 13e": "p_ff1933567b",
  "3 niveaux · sourcé du Bilan + compte de résultat ·": "p_246a2eecf4",
  "30/40/30 sur 3 mois — total exact malgré arrondis": "p_0704052c7d",
  "3ᵉ degré": "p_37bf111a25",
  "9 lignes types PME services : Conseil, Forfait, Abonnement, Carnet d'heures, Licences, Outsourced, Hardware/Software, Commissions, Autres.": "p_bde2daa8a8",
  "À": "p_10738f8f89",
  "à ce jour": "p_dffcc75198",
  "À ce jour": "p_9ab7ccd1b7",
  "À classer ({{count}})": "p_7461a96aa7",
  "À classer ({{n}})": "p_4b7b872a08",
  "à date": "p_eca043d80b",
  "à date · cumul YTD": "p_c8dcfaa1bc",
  "à définir": "p_87edadcd2a",
  "À partir de": "p_c0fd7660f1",
  "À placer": "p_b5a7ce8891",
  "À surveiller": "p_2e8f415a2e",
  "Aa — Contenu": "p_64217f5dcc",
  "Aa — Titres": "p_614e2c19b0",
  "Abonnement / récurrent": "p_fd962dd8b2",
  "Absences": "p_0f9ec208bd",
  "Accent — ardoise (seul accent du chrome)": "p_c638d6b159",
  "Accent (nav active, onglet, liserés, graphe réel)": "p_7f928026bb",
  "Accent clair (prévisionnel / extrapolé)": "p_5f78d911f2",
  "Accent tint (fond figure-clé)": "p_fc6e3c48cc",
  "Accident (LAA)": "p_6df1dc19db",
  "accrual — salaires réels × taux": "p_d48cb39ff5",
  "Achats": "p_ee5b078c13",
  "Achats — charges directes (HT)": "p_d0493809a9",
  "Achats — coûts + autres charges (12 mois glissants)": "p_df1c88327e",
  "Achats & charges variables": "p_ef16e4e951",
  "Acomptes": "p_ec9078ffd4",
  "Acomptes clients": "p_07a1717518",
  "Acomptes clients (% du CA 12 mois)": "p_459a12b54d",
  "Acomptes paramétrables (ex. 30/40/30) — saisir total et jalons.": "p_2f52206455",
  "Acomptes paramétrables, ex. 30/40/30 sur trois jalons.": "p_5ba399d6ab",
  "actif": "p_232931936a",
  "Actif": "p_2eb75f8458",
  "Actif CT": "p_d26b164efd",
  "Actifs": "p_4fc3a98099",
  "Actifs circulants": "p_00fe58633a",
  "Actifs immobilisés": "p_1d87175ca6",
  "Actifs seulement": "p_e1e150b5c6",
  "Actions": "p_c3cd636a58",
  "Activer le mode affectation : cliquer un groupe ci-dessus pour armer, puis cliquer les lignes pour affecter en un clic": "p_bdd40696f8",
  "Activer le module {{label}}": "p_03902a7273",
  "Activez ou masquez des indicateurs via ⚙ · Cliquez un indicateur pour le détail.": "p_f59e63edd6",
  "Activez ou masquez les indicateurs": "p_066560e631",
  "Activité": "p_8fe12048b8",
  "Actuel": "p_8a432ab201",
  "Actuel :": "p_bc4061cf71",
  "Actuel : —": "p_9bc2270d82",
  "adéquation du capital": "p_01eb9e6ab8",
  "Affectation des charges indirectes": "p_3dae073287",
  "Affectation des personnes": "p_875e58bae8",
  "Affectation frais": "p_ee890e953a",
  "Affectation personnel": "p_8b334f7bf3",
  "Affectation Temps": "p_081e3a3ecd",
  "Affiché": "p_e0c89b3d66",
  "Afficher / masquer dans le compte de résultat": "p_d08452ab26",
  "Afficher les modes de planification par ligne (clic sur le badge = mode suivant)": "p_7b43d5ce91",
  "Afficher les modes…": "p_f74c45f0f7",
  "Agrégat": "p_0ccfe9077d",
  "Ajout (+)": "p_027162c91e",
  "Ajout…": "p_0baded33ec",
  "Ajoute d'abord des comptes (étape Comptes) pour les référencer.": "p_8c1d985589",
  "ajoutée": "p_ca03250401",
  "Ajouter": "p_87c57ed173",
  "Ajouter au BFRE": "p_c95f0293fb",
  "Ajouter d'abord un collaborateur": "p_e635b617ab",
  "ajouter ici": "p_fa01d7b37e",
  "Ajouter le collaborateur": "p_c70e4f8d00",
  "Ajouter les 18 lignes par défaut en plus ? (Les existantes ne seront pas supprimées.)": "p_58998dc12a",
  "Ajouter un collaborateur": "p_8a3ea1688c",
  "Ajouter un complément — ": "p_6bf37debda",
  "Ajouter un contrat": "p_08d8a5b532",
  "Ajouter un départ": "p_533070fbee",
  "Ajouter un frais — ": "p_f1b674d6e1",
  "Ajouter un jour": "p_063abf133d",
  "Ajouter un mémo": "p_bd5638dfcf",
  "Ajouter une embauche": "p_b0aa5a8ad4",
  "Ajouter une indemnité reçue — ": "p_c451eaa472",
  "Ajouter une ligne": "p_ba241fd4cb",
  "Ajustement": "p_4ab0326a6c",
  "Ajustements": "p_daa6d8eaa7",
  "Ajustements & Corrections": "p_c86ee33c9a",
  "Ajustements de salaires (embauche / départ / prime…)": "p_e7b2d4de7c",
  "Alerte": "p_672e2f601f",
  "Allocation familiale": "p_973cfa6e2b",
  "Alloué": "p_68d9cdafaa",
  "Amber (secondaire · ponctuel)": "p_52b312b603",
  "Amortissements & corrections de valeur": "p_6b5df34473",
  "Amortissements & provisions": "p_09f4847875",
  "an dernier, recalé sur le niveau réel de l": "p_8b916945e6",
  "Analyse": "p_28b6dc3117",
  "Analyse en cours…": "p_466456521f",
  "Ancrage ": "p_4186dfb0bf",
  "Année": "p_1f910d98d7",
  "Année {{year}} clôturée": "p_11c8dd5c51",
  "Année {{year}} déjà peuplée — supprimer d'abord pour pouvoir copier depuis {{fromYear}}": "p_c2d60eb207",
  "Année cible": "p_375da4aca6",
  "Année concernée par ce bilan :": "p_5dff367226",
  "Année concernée par ce compte de résultat :": "p_3e12efb102",
  "Année courante — 12 mois": "p_99282b7be4",
  "Année de départ": "p_770ada6805",
  "Année de travail": "p_cc5698d2dc",
  "Année déjà peuplée — supprime les lignes existantes pour pouvoir copier": "p_d36b69e602",
  "Année invalide.": "p_8fa313abb5",
  "Année maximale atteinte (2100).": "p_ffd88f10f1",
  "Année modifiable ligne par ligne (": "p_038ccb5898",
  "Année modifiable ligne par ligne (plusieurs années possibles).": "p_2a9629e300",
  "année partiellement renseignée → null sur les mois manquants": "p_92053398d0",
  "Année précédente": "p_cb0544033c",
  "Année sans réel — lecture en prévision.": "p_921172e1f3",
  "Année source": "p_49fbaed2da",
  "Année suivante": "p_ef7b69f4ee",
  "annualisé": "p_aace041e4e",
  "annuel": "p_ee608459fd",
  "Annuel": "p_11aad2fa53",
  "Annuel (source du CCR) et détail mensuel dans une seule vue. Décembre se cale sur l'annuel s'il est saisi.": "p_d23e191f56",
  "Annuler": "p_49ba329242",
  "ans": "p_84f99a5498",
  "aoû": "p_88cff0aa78",
  "Aoû": "p_39184c9361",
  "août": "p_cd7668c3d3",
  "Août": "p_460b6696b2",
  "Aperçu —": "p_b096e1bf8e",
  "Aperçu — Costing · ": "p_f70ff8a02b",
  "Aperçu — Coût de production": "p_90ff17bc45",
  "Aperçu — Coût horaire (CCR)": "p_09c39fd682",
  "Aperçu — People reports · ": "p_e6cbe1b2ae",
  "Aperçu — Planification du personnel": "p_f4fa682b91",
  "Aperçu — Planification du personnel · ": "p_48948b44f4",
  "Aperçu / impression PDF": "p_fd99781cec",
  "Aperçu / impression PDF (toutes les pages)": "p_eebf32e463",
  "Aperçu puis impression / PDF (A4 paysage). Plusieurs rapports = un document combiné.": "p_9523529957",
  "APG": "p_738de58cd8",
  "APG · maternité · acc. (info séparée, non déduite)": "p_6deef7c276",
  "APG, accident, RHT…": "p_66f6427de0",
  "Application…": "p_01a96ae5cb",
  "Applique aux {{count}} ligne(s) sélectionnée(s) pour {{year}}.": "p_7e825dc65a",
  "Applique les valeurs renseignées aux": "p_acef4b9896",
  "Appliquer": "p_a4d6613920",
  "Appliquer \"{{label}}\"": "p_32ed27efb0",
  "Appliquer à": "p_c4bf33e428",
  "Appliquer à {{count}}": "p_ac637d1baf",
  "Appliquez un profil saisonnier ou ajustez la courbe manuellement. Si vous changez uniquement la répartition mensuelle, veillez à figer le total": "p_66232ccc8e",
  "Armer ": "p_83b889a423",
  "arrivé": "p_c91a950272",
  "Arrivée prévue ": "p_2c3b8db598",
  "Arrivée prévue {{date}}": "p_dc72cb9d2c",
  "Arrivées": "p_7771863046",
  "Assistant": "p_8010d1f4d0",
  "Assistant Palestre": "p_487f9a6cbf",
  "Assurance maternité AMat": "p_7794b334d2",
  "Assurances (LPP / LAA / IJM)": "p_63014cb9b1",
  "assurances = masse annoncée × taux, en acomptes sur l'échéancier": "p_7a11e8e8e9",
  "Assurances supplémentaires": "p_98377b217f",
  "Astuce : affecter un groupe ressources, le salaire brut et l’EPT dans le tableau après création.": "p_3981eb6ace",
  "atteint en": "p_f6c55d0582",
  "au-dessus de 1,0×": "p_27e52ddabd",
  "Aucun — via ✎ (taux) / ⏻ (départ) sur la grille ci-dessous": "p_46cc937840",
  "Aucun bilan disponible pour": "p_ed9707a9a7",
  "Aucun bilan mensuel saisi — rien à tracer.": "p_3930e41144",
  "Aucun bilan mensuel saisi pour cette année — rien à tracer.": "p_e21e23d9d6",
  "Aucun bilan pour cette année.": "p_550e338d0c",
  "Aucun collaborateur ": "p_9d1e44ade5",
  "Aucun collaborateur pour cette entreprise.": "p_ad64b7aeb9",
  "Aucun complément pour ": "p_d9db9a64d6",
  "Aucun compte avec solde au": "p_894db23f7b",
  "Aucun compte avec un solde au": "p_d4d99c5573",
  "Aucun compte inclus — active le jeton BFRE sur une ligne d'actif circulant ou de dette à court terme.": "p_5900e7e0f9",
  "Aucun compte mappé sur cette ligne.": "p_a6ad663ed3",
  "Aucun contrat actif ce mois": "p_8b288e2314",
  "Aucun contrat pour l'instant.": "p_bb17de8dd4",
  "Aucun fichier sélectionné": "p_6e8285a386",
  "Aucun focus. Construisez-en un via « + Nouveau KPI » (analyses sur-mesure, sur mandat).": "p_61c1140d0b",
  "Aucun frais pour ": "p_2154c9f0c2",
  "Aucun groupe ressources — ajoutez-en un ci-dessous.": "p_883cb4dc9a",
  "Aucun jour saisi.": "p_c6ce2595c9",
  "Aucun mois clos pour {{year}} — définir le dernier mois clôturé (Réglages).": "p_f6b6fc0f33",
  "Aucun mois clos pour {{year}}.": "p_6f117b1ad3",
  "Aucun mois clôturé — rien à afficher.": "p_72b4005b68",
  "Aucun mois clôturé sur cette année.": "p_042302b865",
  "Aucun mois réel clos pour {{year}}. Définir le dernier mois clôturé du tenant (Réglages) pour activer la photo à date.": "p_9e200387a3",
  "Aucun mouvement dans la fenêtre. Clique": "p_e58ee5d5bc",
  "Aucun mouvement planifié.": "p_5441b4252a",
  "Aucun mouvement.": "p_2b7a375a44",
  "Aucun poste. Cherche un agrégat, un compte ou un sous-total ci-dessus.": "p_321809eea6",
  "Aucun rapport sélectionné": "p_8eaac61a79",
  "Aucun rapport sur cette page.": "p_5da82d8b1c",
  "Aucun résultat pour ce filtre.": "p_2005b97d7b",
  "Aucun scénario de trésorerie pour cette année — rien à projeter.": "p_87cd95bea6",
  "Aucun scénario de trésorerie pour cette année.": "p_b93e04c1cc",
  "Aucun service — ajoutes-en un.": "p_c8a4e54af9",
  "Aucun service.": "p_93e1a77f1f",
  "Aucun signal d'alerte sur le dernier mois clôturé.": "p_c9a4f1798d",
  "Aucun taux LPP saisi pour cette personne — taux par défaut tenant appliqué. À renseigner dans hr_lpp_rates.": "p_4134710752",
  "Aucune année saisie. Crée la première année avec « + Nouvelle ».": "p_2aa5f0f02a",
  "Aucune assurance pour": "p_89e9c47057",
  "Aucune charge sociale saisie pour": "p_76349ec2d7",
  "Aucune donnée": "p_434e548814",
  "Aucune donnée à exporter": "p_050163ec40",
  "aucune donnée bilan → liqN1 null (pas de repli)": "p_c987ca407f",
  "Aucune donnée de bilan pour cette année.": "p_76210bbe36",
  "Aucune donnée financière pour cette année.": "p_ddaa626f04",
  "Aucune donnée pour {{year}}.": "p_4b689d3a79",
  "Aucune donnée pour cette année.": "p_b61a30934e",
  "Aucune donnée prévisionnelle pour cette année.": "p_d7bd3fcec2",
  "Aucune donnée tabulaire dans la sélection.": "p_763eb281ea",
  "Aucune écriture pour {{year}}.": "p_395861a0ef",
  "Aucune embauche/départ planifié dans la fenêtre. Saisie dans": "p_08099df17e",
  "Aucune entreprise sélectionnée.": "p_8b5d241af5",
  "Aucune indemnité reçue pour ": "p_068608629c",
  "Aucune lecture disponible.": "p_183ac0e513",
  "Aucune ligne avec méthode de forecast — configure-les dans Structure.": "p_fc730fae4a",
  "Aucune ligne calculée.": "p_19a0e9bd3e",
  "Aucune ligne de crédit. « + Ajouter » pour en créer une.": "p_fe4b4453de",
  "aucune ligne exploitable → null (pas de défaut silencieux)": "p_d75595830a",
  "Aucune ligne Liquidités au bilan {{year}} — saisis le solde manuellement.": "p_fca7f4aaf1",
  "aucune ligne Liquidités au bilan → initialBalance null": "p_f0b5e73b26",
  "Aucune ligne pour ": "p_df6ffc2ead",
  "Aucune ligne pour {{year}} — choisir un canton ci-dessus pour importer les taux standards.": "p_cffe1b6e73",
  "Aucune ligne sélectionnée. Choisissez-en une dans la liste à gauche.": "p_530df7c093",
  "Aucune ligne. Utilisez le menu « + Ajouter une ligne » ci-dessus.": "p_f9b925a10e",
  "Aucune page. Clique « ＋ » pour créer un tableau de bord, puis ajoute des rapports-cards.": "p_9a9fd2e793",
  "Aucune personne active sur": "p_d6a6f32e9b",
  "Aucune personne active sur {{year}}.": "p_153df931a7",
  "Aucune personne affectée à ce service.": "p_48c95175c3",
  "Aucune personne dans la fenêtre ": "p_0e5f460a04",
  "Aucune personne.": "p_a1eb155b22",
  "Aucune personne. Cliquez « + Ajouter une personne » pour commencer.": "p_470f8993de",
  "Aucune position.": "p_3a48bababc",
  "Aucune valeur saisie — le graphique apparaîtra dès qu'une ligne aura un montant.": "p_af75482205",
  "Audit / contrôle externe": "p_0d8760ec09",
  "Augmentation": "p_fb28e255fc",
  "Autonomie": "p_a138c5cf68",
  "Autonomie (runway)": "p_5afbfcb7db",
  "Autres": "p_2f0dd0426a",
  "Autres charges": "p_5fca3ad3c2",
  "Autres charges d'exploitation (moy. YTD)": "p_6141662598",
  "Autres charges de personnel (moy. YTD)": "p_183693bb6f",
  "Autres coûts": "p_d2fc22d9dc",
  "Autres coûts d'exploitation": "p_d33c34720f",
  "Autres éléments du fonds de roulement": "p_35829e1239",
  "Autres factures à payer": "p_b159d3bdbb",
  "Autres flux (solde non décomposé)": "p_43afb941cb",
  "Autres frais": "p_0018906401",
  "Autres frais de personnel": "p_bc819027a3",
  "Autres frais. Source : Frais.": "p_a61124c786",
  "Autres groupes": "p_cbdbf9262d",
  "Autres paramètres": "p_4c28ed46a3",
  "Autres produits": "p_1c01fa9c6d",
  "Autres revenus": "p_6450904635",
  "Autres variations BFR": "p_011ad0a679",
  "avant épuisement de la trésorerie": "p_5efeef4f03",
  "Avantages fixes annuels (ex. forfait représentation). Source : Frais.": "p_dcda133948",
  "avec des comptes. Les postes ouverts se reprennent depuis le bilan Financials au niveau des comptes — importez ou saisissez le bilan": "p_8869813e1d",
  "avec std": "p_3ea4382e53",
  "avec un coût direct de": "p_71cc83a1e4",
  "Avr": "p_d648a3b79a",
  "avr.": "p_df9c51559f",
  "Avr.": "p_2707c61adf",
  "avril": "p_a028c88282",
  "Basculer l'affichage des montants : milliers (kCHF) ou au franc près (CHF)": "p_15e4e4a269",
  "Basculer structure / direct": "p_79cb780eb7",
  "Base salary + annual extras (assiette CS)": "p_700390f6f7",
  "baseline contrats": "p_7252d03246",
  "Besoin en fonds de roulement (BFRE)": "p_15eb4471d5",
  "Besoin en fonds de roulement d'exploitation (BFRE)": "p_65bc846076",
  "BFR — actifs": "p_f247b582ba",
  "BFR — passifs": "p_c5f4782835",
  "BFRE": "p_2d18db6ec4",
  "BFRE — 12 mois roulants": "p_dc6c69cc47",
  "BFRE + Liquidités": "p_b99b8f862b",
  "BFRE <strong>{{amount}}</strong>": "p_a1ac77774a",
  "Bientôt": "p_a60303f4b2",
  "Bilan": "p_a80c46238b",
  "Bilan · ": "p_3ac09f23a4",
  "Bilan · {{sec}}": "p_6ad0a93de1",
  "bilan absent pour l’année d’arrêté → hasView false": "p_d4475139d0",
  "Bilan d'ouverture repris au": "p_373ed83d1d",
  "Bilan d'ouverture repris au {{period}}": "p_8f1b40df12",
  "Bilan prévisionnel": "p_385bd1f4ad",
  "Bilan, Assurances sociales (comptabilisé)": "p_0654ddc8cd",
  "Billable + Non-billable hours (heures travaillées allouées client)": "p_a75e8cbadc",
  "Bleu saisie (champs de formulaire uniquement)": "p_f573fd8034",
  "bloqué": "p_4c1a1d17d5",
  "Bonus": "p_4d963cfab7",
  "Bonus + autre rémunération (jetons CA, etc. — annuel + soumis CS)": "p_b8f8ec5412",
  "Bonus + board fees + other remuneration (soumis CS)": "p_4f8700cb72",
  "Bonus + jetons de présence + autre rémunération (soumis CS)": "p_b9a7ff468c",
  "Bonus, prime, gratification… pour des collaborateurs existants.": "p_34e6a7e5f2",
  "Bordure (filet général)": "p_30cc68809a",
  "Bordure interne (tuiles de card)": "p_bb42d8685f",
  "Browse…": "p_c1b20f5242",
  "brut mensuel lissé (13e/14e et compléments répartis) · 24 mois": "p_ca87faff4e",
  "buildVatMonthRates — report par année calendaire": "p_4227490e23",
  "burn": "p_03b5db720e",
  "Burn / mois": "p_3f3cfe92ae",
  "Burn rate": "p_6f0294e5ec",
  "Burn rate / mois": "p_0c8501ca96",
  "Burn rate <strong>{{amount}}/mois</strong>": "p_b2b9bb66df",
  "C. spéc.": "p_0d4d69c983",
  "CA / EPT": "p_b34bba20b1",
  "CA 12 mois roulant": "p_adec66bf36",
  "CA cumulé / EPT capa": "p_03eab03a1a",
  "CA HT annuel": "p_dea646ba87",
  "CA net": "p_b7263d35bb",
  "CA net 12 mois glissant": "p_a42a88db8e",
  "CA net 12 mois glissant & EPT mensuel": "p_742f2f0244",
  "CA net par EPT": "p_57127c32f0",
  "CA net par EPT moyen": "p_99227c8bed",
  "CA par EPT": "p_9178fcb785",
  "CA total": "p_c324bfa243",
  "CA TTC annuel": "p_ca01fc7e5a",
  "Calcul indisponible (scénario vide ?).": "p_7ec79b3d72",
  "Calculation unavailable (empty scenario?).": "p_60061a754b",
  "calculée": "p_7e3031fe22",
  "Calculée = Coût des ventes − Achats − Sous-traitance": "p_48957ea693",
  "Calculée = taux d'amortissement × valeur brute (prorata dès l'activation)": "p_fe81b8c3cf",
  "Calculs": "p_009b0e4feb",
  "Calé sur l'annuel (Annuel − Σ Jan..Nov)": "p_ffa236c278",
  "Calendrier ": "p_93d09d17e1",
  "Calendrier d'entreprise": "p_e40134a466",
  "Cancel": "p_77dfd2135f",
  "Canton": "p_0d54881f07",
  "Canvas (fond, derrière les panneaux)": "p_b2be7e0d19",
  "Capacité — du temps payé à la capacité inutilisée (N-1 / N)": "p_2387ff3098",
  "Capacité (EPT)": "p_907509dc4e",
  "Capacité (TR)": "p_91644115a8",
  "Capacité d'autofinancement": "p_4544d7142a",
  "Capacité disponible (TR)": "p_8178f61626",
  "capacité disponible (TR) en EPT": "p_24fb799e4a",
  "Capacité horaire (CCR) · Détail par personne": "p_7861f51087",
  "Capacité horaire (CCR) · Synthèse": "p_af97dba81c",
  "Capacité inutilisée": "p_474ce92d9c",
  "capacité non utilisée": "p_0270cf52e2",
  "Que voulez-vous faire ?": "p_0a93e0ecd0",
  "Mettre à jour le réel": "p_efcdb7f855",
  "Planifier & simuler": "p_29317465f1",
  "Quoi de neuf dans People": "p_330a44ede4",
  "Importer des collaborateurs": "p_259b936ac8",
  "Une personne, à l'écran": "p_c5b30f5790",
  "Plusieurs, par fichier Excel": "p_f540edabd5",
  "Bonus, primes, gratifications": "p_524671f6fb",
  "Remboursements aux collaborateurs": "p_ddb1144550",
  "APG, maternité, accident": "p_a2e4a26805",
  "Lire le résumé de l'année": "p_0de8f4e5a5",
  "Arrivée, départ, changement de taux": "p_207cb506eb",
  "Planifier la masse salariale": "p_237eabc3e6",
  "Le prévisionnel de l'exercice": "p_f279678cc6",
  "Tracer la trajectoire": "p_04bfc10f18",
  "Au-delà de l'exercice, pluriannuel": "p_680074ddf7",
  "Voir la synthèse des effectifs": "p_528ffcb2e2",
  "Présentation exécutive": "p_3353bd85e6",
  "Échec de l'enregistrement": "p_f21d2b1c48",
  "Nouvelle entrée…": "p_94b6e967c7",
  "Le « Quoi de neuf » affiché sur les pages d’accueil des modules.": "p_a3ce7e2ab6",
  "Nouveautés": "p_f2af3c640b",
  "Salaires et charges sociales": "p_5f1dd38e31",
  "Trajectoire des effectifs": "p_8439119ef6",
  "brut planifié × taux": "p_563e02fa3b",
  "majoration": "p_6cdd748695",
  "Travail productif": "p_90e4cb3c41",
  "coût d’une heure disponible": "p_ab0a34d45a",
  "Voir le détail": "p_c6565c1527",
  "du CCR": "p_9821b936d5",
  "Lecture du panneau": "p_6128093754",
  "Charges indirectes et frais alloués": "p_64da37362c",
  "Heures disponibles": "p_117b8015f9",
  "Voir la cascade": "p_816bc60950",
  "majoration moyenne": "p_c5c1ef8d99",
  "Coûts indirects": "p_a8f0eb6095",
  "capacité pratique (TR)": "p_55bf1b28a4",
  "Aucun changement de contrat en {{month}}.": "p_f443fcef57",
  "à confirmer": "p_39fb23cb23",
  "1 mouvement": "p_66937c5a7a",
  "Résumé de": "p_6da392f253",
  "l’activité": "p_adb8db774e",
  "fin de contrat": "p_0a8346e7d2",
  "Mettre à jour {{month}}": "p_945a2803e2",
  "Lire le résumé": "p_71811a1223",
  "augmentation": "p_14672c927c",
  "Réel clôturé jusqu’à {{month}} {{year}}.": "p_725f00e28d",
  "position ouverte": "p_da1aaa884f",
  "{{n}} simulés": "p_7f3a28f3a8",
  "salaire": "p_8851815c38",
  "Aucun mouvement simulé.": "p_4a28e2ce25",
  "Réel à fin {{month}}, prévisionnel à décembre": "p_260997af4b",
  "réduction générale": "p_e27fa41f55",
  "{{k}} mouvements simulés démarrent en {{month}}, à confirmer avant la saisie.": "p_eba069ceeb",
  "{{month}} est ouvert.": "p_b7567d3017",
  "Exercice {{year}}, effectifs, rémunération et capacité": "p_2afe618263",
  "1 mouvement simulé démarre en {{month}}, à confirmer avant la saisie.": "p_b3fb3395e7",
  "départ": "p_dc5fd7f6e0",
  "{{n}} mouvements": "p_1ae2acb279",
  "arrivée, {{pct}} %": "p_fbcae6e5c8",
  "Mouvements non actés": "p_e518c9ec88",
  "Simuler les mouvements": "p_83f45fea98",
  "+ {{n}} autres": "p_f399cc25de",
  "{{month}} {{year}}, dernier mois clôturé": "p_160408ed8b",
  "Tous les contrats": "p_a80d2c8c2e",
  "Ce qui a bougé": "p_08b7b160e0",
  "Aucun mois clôturé pour cet exercice.": "p_84744c9a07",
  "À confirmer": "p_b4dfe32c72",
  "baisse de salaire": "p_43dd819275",
  "{{n}} collaborateurs, {{ept}} EPT au {{day}} {{month}}.": "p_9d0512aae1",
  "Synthèse impact employeur": "p_91c1c9c75f",
  "Masse": "p_a5d4c9da46",
  "constaté {{year}}, appliqué au-delà": "p_cea0c195d6",
  "Répartition EPT": "p_8267609004",
  "Évolution des EPT": "p_6f900838ac",
  "Indexation annuelle des salaires": "p_13430357fb",
  "Récit de l’activité et des effectifs": "p_9da6d79530",
  "Simulations & mutations": "p_d1488edf1e",
  "Voir tout": "p_7b7d86e8ab",
  "Bonjour,": "p_fe5709d59f",
  "Voir la présentation": "p_2cb9014093",
  "Bonjour {{name}},": "p_e67d34ed54",
  "Pilotez vos effectifs et vos coûts salariaux.": "p_28e64b9bc2",
  "Changements dans les contrats": "p_5453234339",
  "Effectifs (EPT) et masse salariale": "p_b547e8f872",
  "contrats jusqu’à {{year}} · à poser au-delà": "p_acb02f7a3f",
  "Les chiffres en récit": "p_f9261fcfff",
  "Effectifs, mouvements, recul et perspectives · exercice {{year}}": "p_ff7c089b24",
  "Effectifs, mouvements, recul et perspectives": "p_a19f067e70",
  "taux TF (÷ TR)": "p_876eafa5b3",
  "heures NF × CCR moyen": "p_ba7684b310",
  "NF client + projets + absences + solde": "p_0ad334ebf6",
  "Capacité non utilisée": "p_a39039b6d7",
  "↳ Capacité non utilisée": "p_c13fa79927",
  "Capacité pratique": "p_5a62e73013",
  "Capacité pratique — TO moins Gestion entreprise, Supervision et Congés spéciaux = TR (dénominateur du CCR)": "p_788353d68f",
  "Capacité pratique (référence)": "p_f8d284d2bc",
  "Capacité pratique (TR)": "p_35b83cce91",
  "Capacité pratique en EPT = TR ÷ TO d'1 EPT @100 %": "p_c0d76f0a00",
  "Capacité présente non facturée (TR − TF)": "p_ee023d55f8",
  "Capacité prévue": "p_b3b5595001",
  "Capacity Analysis · {{year}} · {{count}} {{pools}}": "p_366f125f52",
  "Capital protégé (capital-actions + réserves légales)": "p_a491fd5aac",
  "Capitaux propres": "p_4245faa74e",
  "Capitaux propres (cash)": "p_413aa5056a",
  "Carnet d'heures": "p_a5479753e0",
  "Cascade :": "p_3d165ba295",
  "cascade des composantes (liquidités → + créances → + stocks) · soldes mensuels YTD": "p_4269be261f",
  "Cascade du coût de personnel": "p_72a379e606",
  "Cash d'exploitation projeté (fin année)": "p_85af6e70db",
  "Cash flow des investissements": "p_9f2d47364a",
  "Cash flow du financement": "p_2859d033d6",
  "Cash flow opérationnel": "p_513cb9f305",
  "Cash flow prévisionnel": "p_96e08a3b9f",
  "Cash ratio · liquidités ÷ DCT": "p_bb7a4c4a2c",
  "cashSeries — trajectoire Liquidités N-1": "p_6ff6ad06fd",
  "Catégorie": "p_6b38300a25",
  "CCR — coût direct à la capacité (indirect inclus) ; ne reste que la sous-activité": "p_52ec2c3dbb",
  "CCR (Capacity Cost Rate) = LCR + Indirect personnel + Overhead (mark-up du pool)": "p_de4edd9c44",
  "CCR + capacité non vendue, CHF par heure facturable": "p_d32a3652f4",
  "CCR × (Billable + Non-billable) — coût de production servi au client": "p_792e75b48e",
  "CCR × Idle (Idle = TR − Billable − Non-billable). Le coût d'absence est mutualisé dans la QP.": "p_a2e767f9cb",
  "CCR moyen": "p_807357aff5",
  "Ce qui le compose": "p_75a8479ee9",
  "Cession (sortie d'actif → cash)": "p_a5e2819181",
  "Cession…": "p_d5182a203c",
  "Cette action est irréversible et impacte tous les scénarios sur": "p_99af51e85e",
  "Cette vue affecte chaque personne à son groupe ressources. Active le ": "p_4c6d70028e",
  "Ch. sociales employé": "p_40163a8ac9",
  "Ch. sociales employeur": "p_36d7ff84d7",
  "Champ": "p_e1472010c6",
  "Changement de taux": "p_cdf764c19d",
  "Chaque ligne est ": "p_da8a7c2a8e",
  "Chaque ligne est ajoutée ; montant vide = ignoré.": "p_779f25cab4",
  "Charge de personnel": "p_2924c57923",
  "Charge indirecte hypothétique": "p_bfda4a2b59",
  "Charge mensuelle fixe (kCHF) · N-1/N-2 = charges annuelles ÷ 12": "p_ee8d741d1f",
  "Chargement ({{done}}/{{total}})…": "p_ef586b3fe3",
  "Chargement de la synthèse…": "p_b3ed290109",
  "Chargement du cockpit…": "p_2750a21633",
  "Chargement…": "p_01cba1dfba",
  "Charger des données — collaborateurs existants": "p_5ab1e49404",
  "Charger l'exemple": "p_b4c10ee2ed",
  "Charger la structure standard de « {{label}} » ? Les lignes actuelles seront remplacées.": "p_2627e5269a",
  "Charger la structure standard de « {{label}} » ? Les lignes du bloc sont remplacées ; les comptes sont re-mappés par libellé quand ils correspondent.": "p_32e62985f7",
  "Charger le jeu standard": "p_e9310a546a",
  "Charger le standard": "p_d871754b8a",
  "Charger un fichier Excel exporté depuis Palestre (CHR, personnel…).": "p_003605ad6a",
  "Charger un fichier Excel exporté depuis Palestre.": "p_8b1dc28297",
  "Charger un fichier Excel exporté depuis Palestre. L'export couvre désormais ": "p_8fb7989791",
  "Charger un fichier Excel exporté depuis Palestre. L'export couvre toutes les tables de saisie du tenant, un onglet par table. Seuls les onglets présents sont traités. Mise à jour par ligne (id) : les lignes existantes sont mises à jour, les nouvelles ajoutées, rien n'est supprimé et une cellule vide ne remplace jamais une valeur existante.": "p_e1ff0f7659",
  "charges": "p_c758ce5194",
  "Charges calculées (dues)": "p_38220d83d6",
  "Charges calculées (Empl+Empr)": "p_ab5f44755c",
  "Charges d'exploitation (HT)": "p_c37bc2c4be",
  "Charges de matières & marchandises": "p_54448eb93d",
  "Charges de personnel": "p_8f7d854255",
  "Charges de personnel totales": "p_1d2cec4d11",
  "Charges employeurs": "p_f4e24c28fa",
  "Charges fixes": "p_c94297648a",
  "Charges fixes annuelles, loyer, abonnements": "p_763f8c0d2f",
  "Charges fixes récurrentes": "p_43547aa349",
  "Charges indirectes": "p_592ec7ba35",
  "Charges matières": "p_ac86ed0c8c",
  "Charges non récurrentes": "p_61b74e2ed8",
  "Charges op.": "p_2847e9bf8c",
  "Charges op. 12 m": "p_1c2722f3b6",
  "Charges personnel — connecté à People": "p_3889c07832",
  "Charges personnel — saisie manuelle": "p_059666d6de",
  "Charges salarié": "p_0834336deb",
  "Charges sociales": "p_421ae40abb",
  "Charges sociales ({{month}})": "p_9225eb0e44",
  "Charges sociales ({{pct}} % du brut)": "p_5202a9f6d8",
  "Charges sociales décaissées": "p_61bfef5eb5",
  "Charges sociales employé": "p_ef15d2ec91",
  "Charges sociales employeur": "p_95c53a0fb9",
  "Charges sociales employeur + LPP": "p_af6eca7961",
  "Charges sociales hors LPP · {{year}}": "p_73f36360b0",
  "Charte graphique": "p_8d7e7546f2",
  "CHB, CHP, CHR par collaborateur et période": "p_d3cf1e39a8",
  "Chercher un poste — agrégat, compte, sous-total…": "p_61c5756f0e",
  "CHF / mois": "p_162234f271",
  "Chgt de taux": "p_2a34e8ef1d",
  "chiffre d'affaires · réel": "p_5bd894fd54",
  "Chiffre d'affaires (cumulé)": "p_2a30e6a012",
  "Chiffre d'affaires annualisé": "p_b8b4656416",
  "Chiffre d'affaires cumulé": "p_d9cb9fd8f9",
  "Chiffre d'affaires net": "p_d1bc74fc51",
  "Chiffre d’affaires net": "p_fe15fd593f",
  "Chiffre d'affaires net : {{a}} vs {{b}} — cumulé à fin {{month}} vs {{year}} même période · {{pct}}": "p_f035aa819a",
  "Chiffre d’affaires net (12 mois glissants)": "p_eb00c56ae4",
  "Chiffre d'affaires net (annualisé)": "p_0b24a01002",
  "Chiffre d'affaires, clients, catégories": "p_93ab401a43",
  "Chiffre d'affaires, marge directe, marge sur coût total": "p_bf57bbe89a",
  "Choisis d'abord une reporting line (le pinceau).": "p_90722559f8",
  "Choisis d'abord une reporting line.": "p_d7de1ef161",
  "Choisis une reporting line :": "p_36e6706c92",
  "cible": "p_729adf403c",
  "Cible annuelle": "p_5211f0e5bc",
  "Cible annuelle de consommation (CHF), répartie également sur les mois restants": "p_970e088a58",
  "Cible d'heures productives (standard)": "p_2b21c89d8a",
  "Cible facturable (min)": "p_b5b0dc0630",
  "Classer →": "p_2421af10ce",
  "Classer les lignes du bilan": "p_e65adb174f",
  "Click to edit — hypothèse annuelle qui pilote le CCR": "p_9c8bb9fde8",
  "clique un compte": "p_2a4795fe89",
  "Cliquer pour ajuster à partir de ce mois": "p_f9cb1f2421",
  "Cliquer pour armer — puis cliquer les lignes à désaffecter": "p_75262828f5",
  "Cliquer pour changer : Prestation → Marchandise → Mix": "p_96ad71a493",
  "Cliquer pour changer la catégorie": "p_498c7ed16e",
  "Cliquer pour décrire…": "p_a99a001e3c",
  "Cliquer pour figer ce taux comme saisie de l'exercice {{year}}": "p_13c07fc9f7",
  "Cliquer pour modifier": "p_8c6575979a",
  "Cliquer pour modifier (CHF)": "p_a0cfc8e328",
  "Cliquer pour regrouper": "p_430d11fc5f",
  "Cliquer pour relâcher → revenir au report automatique": "p_5c4b117085",
  "Cliquer pour saisir": "p_b4a1d1730a",
  "Cliquer pour saisir le produit de cession": "p_204cbd22b4",
  "Cliquer pour saisir le produit de cession ({{unit}})": "p_84dc4245d9",
  "Cliquer pour trier": "p_1b7f2f0eb6",
  "Cliquer pour voir le détail par compte": "p_ab4b0a09a1",
  "Cliquer un groupe ressources ci-dessus pour armer le pinceau, puis cliquer les lignes pour affecter en un clic.": "p_7243569b6a",
  "Cliquer une cellule de compte pour ajouter / éditer une note": "p_545988f9d8",
  "Cliquer une valeur de ligne pour passer une écriture d'ajustement (reclass / report)": "p_4700de4a24",
  "Cliquez un focus pour voir le détail mensuel.": "p_a213cf1254",
  "Cliquez un indicateur pour creuser": "p_b062fea9f3",
  "Cliquez un indicateur pour le détail.": "p_23a1fe5261",
  "Close": "p_bbfa773e5a",
  "Clôture": "p_eb133909be",
  "Cockpit": "p_b56631bc88",
  "coefficient de variation": "p_b9b7c12cde",
  "collaborateur": "p_232aaadbdf",
  "Collaborateur": "p_a66377cf86",
  "Collaborateur *": "p_ee160068ec",
  "collaborateurs": "p_74ac84f5ca",
  "Collaborateurs": "p_7eb2cd0eef",
  "Collaborateurs, salaires, taux d'activité": "p_1a8e8e3749",
  "Collage appliqué.": "p_f46320cf64",
  "Colonnes affichées (mois).": "p_4e35b7a246",
  "Commentaire": "p_bcb916abdb",
  "Commentaire…": "p_7e79260694",
  "Commission": "p_4bfc46bc92",
  "Commissions / Apporteur": "p_22a0185ec2",
  "Comparatif indisponible — il faut l'historique mensuel de l'année précédente.": "p_9e91aa541b",
  "Comparer avec": "p_27ff30e2d3",
  "Compléments (13e/14e)": "p_b19f4ef2b2",
  "Compléments (Extras)": "p_aad0f37111",
  "Compléments (soumis aux charges sociales)": "p_44042e63d5",
  "Composante": "p_c6cbd086f0",
  "Composante BFRE obligatoire": "p_aa34187dff",
  "Composition BFRE — 12 mois glissants (réalisé)": "p_d381389713",
  "Composition du passif — réel vs prévision fin d'année": "p_ac82d32486",
  "compte": "p_892038174e",
  "Compte": "p_c45740bbe9",
  "Compte (à)": "p_90519c5f02",
  "Compte (de)": "p_dc90b65964",
  "Compte / désignation": "p_9011954282",
  "Compte de résultat": "p_a292527bbe",
  "Compte de résultat prévisionnel": "p_8e0f28455c",
  "Compte de résultat simplifié": "p_9d447db908",
  "compte(s) non mappé(s)": "p_65af42086d",
  "comptes": "p_4d778c4769",
  "Comptes": "p_f778ac95e1",
  "Comptes → lignes de reporting": "p_cd3a8b64c9",
  "Comptes de liquidités au {{period}}": "p_8f47c6a00c",
  "Comptes non alloués": "p_a272281cda",
  "Comptes non alloués — aucun": "p_ad4ad4b4c9",
  "Comptes non classés dans les flux": "p_4483f7865c",
  "congé offert": "p_8e5c6d7c31",
  "Congé offert": "p_33c7decdf0",
  "Congé offert : se comporte comme un férié (déduit des jours ouvrés).": "p_0dd4d1a8ad",
  "congé rattr.": "p_6867994a06",
  "Congé rattrapé": "p_dbcd0bfd3c",
  "Congé rattrapé : déduit des jours travaillés, le volume horaire annuel ne change pas.": "p_2aa4b579af",
  "Congés offerts": "p_f75024cd87",
  "Congés offerts (an)": "p_6e5b435b25",
  "Congés rattrapés": "p_604bc8904e",
  "Congés rattrapés (an)": "p_14cebd751a",
  "Congés spéciaux": "p_a5fc105a5b",
  "Congés spéciaux (heures)": "p_faf617277d",
  "Congés spéciaux (maternité / paternité / militaire) — carve TO→TR, saisie manuelle": "p_661d4b056a",
  "Connecté à People": "p_cfb504bbbd",
  "Connecté à People — onglet <b>Charges personnel</b> s'ouvre pour éditer.": "p_94df974a0f",
  "Conseil (régie)": "p_174d305a9c",
  "Constaté : ": "p_f85006b0e2",
  "Construire": "p_a43f22b3a9",
  "contrat": "p_ac1198b357",
  "Contrat": "p_d008bdd9b9",
  "contrat × calendrier": "p_e740e59f13",
  "contrats": "p_1389c6fa35",
  "contrats — exacte": "p_7697069d09",
  "contrats + overlay mouvements · ✎ taux · ⏻ départ · lignes synthétiques = positions / réductions": "p_bfbaa785a4",
  "Contrats à 13 salaires": "p_6922255986",
  "Contrats à 14 salaires": "p_3379e573eb",
  "Contrepartie": "p_3dc41f7675",
  "Contrôle : ouverture + accrual − décaissement = dette fin": "p_8d5c0963be",
  "Contrôles 725": "p_b75dc54860",
  "Copié.": "p_0883815322",
  "Copie…": "p_4baaec2a82",
  "Copier": "p_cdd28e1a69",
  "Copier {{from}} → {{to}}": "p_a851b4018b",
  "Copier {{fromYear}} → {{toYear}}": "p_8b1f945a91",
  "Copier l'année…": "p_6a281cd62f",
  "Copier les compléments — année à année": "p_04bdef5088",
  "Copier les compléments d'une année vers une autre": "p_a8766751c3",
  "Copier les frais — année à année": "p_f4362e547d",
  "Copier les frais d'une année vers une autre": "p_ddc911001e",
  "Copier les saisies CHR (tarif, absences, etc.) d'une année vers une autre": "p_0bd2fe0a02",
  "Copier les saisies temps — année à année": "p_9ae20b0796",
  "Copier les saisies temps d'une année vers une autre": "p_d0c6ec0635",
  "Copier toutes les lignes depuis {{year}}": "p_63eac97748",
  "Copier une année": "p_82c280c4d1",
  "Copier une année…": "p_680ed56f3b",
  "Copier…": "p_d18a6d524f",
  "Copy CHR inputs — année à année": "p_7f4a427976",
  "Corporate + supervision + congés spéciaux (TO − TR)": "p_4e99241635",
  "Corrections et suppressions à l'écran.": "p_b80bb0940f",
  "Cost pool TDABC de la personne (vue Cost Pool assignment)": "p_8c8f1e5d03",
  "Cotisation annuelle = mensuel × 12 (lecture seule)": "p_c9726fae72",
  "Cotisations de base": "p_364b12a8c1",
  "Cotisation total (%)": "p_f7d45244b6",
  "Cotisations — part employeur": "p_6af34033ac",
  "Cotisations AVS/AC, assurances, LPP par canton": "p_316c22f042",
  "Cotisations de base": "p_a62e6150dc",
  "Courbe = trésorerie + créances clients + stocks − dettes fournisseurs · barres : trésorerie + créances clients + stocks (au-dessus de 0), dettes fournisseurs (en-dessous).": "p_188eab34ef",
  "Courbe = trésorerie + créances clients + stocks − dettes fournisseurs · barres : trésorerie + créances clients + stocks (au-dessus de 0), dettes fournisseurs (sous 0) · traitillé = charge de personnel mensuelle": "p_54195ec9eb",
  "Coût": "p_4a4aa395e8",
  "Coût / EPT": "p_1943c277cd",
  "coût annuel moyen par plein temps": "p_a190d6f369",
  "Coût au salaire (LCR), à la capacité idle à part (CCR) ou coût de production (PCR)": "p_d6090ea52c",
  "Coût au salaire (LCR), à la capacité idle à part (CCR) ou coût de production idle alloué (PCR)": "p_c1206b5197",
  "Coût complet @ CCR": "p_fa61fcd69e",
  "Coût complet ÷ TR — coût horaire de capacité": "p_a8b1f1f8cd",
  "Coût de capacité": "p_ab3b49387e",
  "Coût de capacité horaire (CCR) par collaborateur et son cost pool, le Total Capacity cost ramené aux heures facturables (BCR), puis ce coût ventilé par usage des heures (facturable / non facturable / idle).": "p_727b62698d",
  "Coût de l'inutilisé": "p_a43688d547",
  "Coût de production": "p_6edef097ac",
  "Coût de production @ PCR": "p_0dbe2ab6ca",
  "Coût de production = coût capacité (CCR×TR) ÷ TF": "p_f12c4e8c95",
  "Coût des marchandises vendues (12 mois glissants)": "p_1adb65c3e7",
  "Coût des ventes — cible": "p_f45563e2b3",
  "Coût direct (% des revenus marchandise)": "p_356a6992b8",
  "Coût du non-facturable": "p_7ef7d6e21c",
  "Coût employeur": "p_99313d1f57",
  "Coût employeur :": "p_779eaacfbd",
  "Coût employeur / EPT": "p_21c92dab87",
  "Coût employeur & EPT": "p_a3c2216481",
  "Coût h. moyen": "p_2aaef0efac",
  "Coût h. non-prod.": "p_1c48702043",
  "Coût heure TF": "p_00470b3945",
  "Coût horaire": "p_211337f294",
  "Coût horaire (CCR)": "p_b9fa3a5448",
  "Coût horaire de capacité": "p_97d2fd0afd",
  "Coût horaire de capacité · par personne": "p_c959a6abfc",
  "Coût horaire de capacité (CCR)": "p_267a83ecb1",
  "Coût indirect horaire du pool TDABC (cascade Cost Assignment, mode courant) — CHF/h": "p_60de09548b",
  "Coût inutilisé": "p_a0fba8f8b1",
  "Coût marchandise": "p_736897949d",
  "coût moyen par plein temps": "p_8ea5dadc32",
  "Coût par EPT": "p_a52b96aae8",
  "Coût par groupe": "p_13939133c3",
  "Coût par personne": "p_41680a5fa2",
  "Coût personnel indirect": "p_338788f988",
  "Coût productif": "p_6844eb74ca",
  "Coût produit @ CCR": "p_7f7997832f",
  "Coût produit @ LCR": "p_bc7392667f",
  "Coût produit @ PCR": "p_41d13f4261",
  "Coût salarial chargé par heure travaillée disponible (TO) — la brique de base du coût horaire, hors frais et charges indirectes.": "p_9280b93357",
  "Coût spécifique": "p_dad9451843",
  "Coût total": "p_004b64cd2b",
  "Coût total employeur": "p_4ff08f6137",
  "Coût total employeur ": "p_4570d66f04",
  "Coût total employeur · à date": "p_5c46c3e159",
  "Coût total employeur (brut) — depuis People cost synthesis": "p_055548c150",
  "Coût total entreprise": "p_a0ab0d88da",
  "Coût variable —": "p_1c459ba416",
  "Coûts de personnel": "p_6e207a8a45",
  "Coûts directs (matières & march.)": "p_a92c676527",
  "Coûts fixes / mois": "p_8c94fdd695",
  "coûts fixes mensuels": "p_0e566492c3",
  "Coûts fixes mensuels (burn)": "p_219bfebd93",
  "Coûts variables @ LCR": "p_eec2fc7233",
  "Couverture des immobilisations ((FP + dettes LT) / immo.)": "p_b31c67eaab",
  "créances + stocks − dettes fourn. − acomptes · 12 mois glissants (réalisé)": "p_4cd1b51727",
  "Créances clients": "p_036e9d357b",
  "Créances clients ouvertes": "p_da91b8df8e",
  "Créances clients recouvrées (postes ouverts)": "p_203346b884",
  "Créances-clients": "p_6e20fbea0b",
  "Créanciers": "p_09068194b9",
  "Created": "p_accf40c89b",
  "Création…": "p_2a06d14f75",
  "Créées :": "p_34e90dda58",
  "Créer": "p_1a6861723c",
  "Créer la page": "p_50167e8253",
  "Créer un nouveau scénario de travail à partir d'une copie du scénario courant": "p_f2de537580",
  "créés": "p_103b6c31af",
  "Croissance CA vs": "p_c4f7322928",
  "croissance sur 12 mois glissants": "p_d838448c51",
  "CS empl. % + LPP empl. % (taux employé global, LPP comprise).": "p_8789a30c91",
  "CS employé": "p_01fde2f758",
  "CS employeur": "p_18acebc443",
  "CS empr. % + LPP empr. % (taux empr global, LPP comprise).": "p_a1222592d3",
  "CS forecast — correction {{amount}} kCHF sur {{months}} mois.": "p_6ee8e2a208",
  "Cumulé": "p_39d4fcc686",
  "Cumulé ": "p_333d97753a",
  "Cumulé · {{closed}} mois": "p_cfb83eaabb",
  "Cumulé · {{n}} mois": "p_3a68582ba3",
  "cumulé à fin": "p_c8127fb2b8",
  "Current ratio · actifs circulants ÷ DCT": "p_fba94d874e",
  "d'EBIT sur 12 mois": "p_5c2659fc54",
  "Data exchange": "p_fb127fcb18",
  "Date": "p_eb9a4bc1c0",
  "Date d'entrée": "p_74ec72cc90",
  "Date de début": "p_706438abfd",
  "Date de début *": "p_b8a1b42187",
  "Date de fin": "p_716a6d8d5e",
  "Date de fin ": "p_ba4b7337f4",
  "Date de naissance": "p_8851f385b2",
  "Date de sortie": "p_a963425d47",
  "Date fixe": "p_5f81342261",
  "de la VA": "p_0f269ffb14",
  "de salaire": "p_25d76f62f7",
  "Déb": "p_83e5ea73e9",
  "Débiteur soldé": "p_20481cf7be",
  "Débiteurs": "p_faa5e468f7",
  "Débiteurs clients": "p_cd8d2989ce",
  "Début": "p_f0955314c5",
  "Début *": "p_2fbcb42f84",
  "déc": "p_bc67e4249c",
  "Déc": "p_2bc2249a06",
  "déc.": "p_4870a46801",
  "Déc.": "p_cbfb817ab4",
  "Décaissement": "p_de3611cade",
  "Décaissement moyen": "p_280bfa2283",
  "Décaissement selon annonce": "p_64add885ad",
  "Décaissements": "p_566a79f10a",
  "Décaissements (−)": "p_bbb23ac8bb",
  "décembre": "p_b8a91577f0",
  "Décembre": "p_03bcd9b0a7",
  "Découvert": "p_b5d15cfc78",
  "découvert autorisé · les lignes actives se cumulent": "p_11b75112b7",
  "dédié, qui utilise la table centrale Palestre par tenant + année.": "p_13aea15604",
  "défaut": "p_f9dfdb914b",
  "Défini dans Costing → Indirect costs": "p_1ddfb0cd87",
  "Définis d'abord des services dans ": "p_c29fa18835",
  "Définis d'abord le canton du tenant pour charger les fériés automatiquement.": "p_202b627808",
  "Définis d'abord un canton dans Paramètres.": "p_e944fc6460",
  "Définitions": "p_3ab3248337",
  "Degré 1 — Liquidité immédiate": "p_865113c71e",
  "Degré 2 — Liquidité réduite": "p_6649e3787e",
  "Degré 3 — Liquidité générale": "p_19537d50ff",
  "Degré 3 — Liquidité générale = FRN": "p_438ab1e828",
  "Degré d'endettement (dettes / fonds propres)": "p_5bb2b41891",
  "degrés 1 / 2 / 3 · curseur = référence suisse": "p_587c4f7002",
  "Degrés de liquidité · curseur = référence": "p_9acedb4da0",
  "Délai": "p_be9a940328",
  "Délai (jours)": "p_8c106e9fd5",
  "Délai = Créances-clients moyennes (TTC, moyenne 12 mois) ÷ (CA net × (1 + TVA)) × 365   ·   Rotation = 365 ÷ Délai": "p_e11fdce665",
  "Délai = Dettes fournisseurs moyennes (TTC, moyenne 12 mois) ÷ (Coût des marchandises × (1 + TVA)) × 365   ·   Rotation = 365 ÷ Délai": "p_920fe09f52",
  "Délai = Stocks moyens (moyenne 12 mois) ÷ Achats × 365   ·   Rotation = 365 ÷ Délai": "p_2a59fed141",
  "Délai acomptes clients (jours)": "p_8dc37bf98f",
  "Délai d'encaissement": "p_513c139876",
  "Délai de paiement": "p_87dcb60ef0",
  "Délai moyen pondéré": "p_5a00925a98",
  "Delta alerte (terracotta · rare)": "p_fd854b0d58",
  "Delta favorable (sage)": "p_9935b9f228",
  "Delta mensuel": "p_ffcee5b410",
  "Delta neutre (défaut · + flèche)": "p_f32303e5b3",
  "dénouement dans le temps · clic sur le badge pour régler la réalisation": "p_253a8bcbf7",
  "Départ": "p_2fb998a9c5",
  "Départ {{name}}": "p_e05b1670c8",
  "Départ du plan": "p_8f0bdf84e8",
  "départ en cours d’année (straddle) : chaque point tire de son year-1": "p_bc0e1c48b7",
  "Départ planifié": "p_528c5129ea",
  "Départ prévu ": "p_f817087895",
  "Départ prévu {{date}}": "p_6e6c50c5c2",
  "Département": "p_3d7c87c2af",
  "département · salaire 100% · entrée / sortie": "p_742a0174ac",
  "Départements": "p_7e23b1c090",
  "Départs": "p_58d0d1e64a",
  "Déplier": "p_4603a1c718",
  "Déplier / replier": "p_74bc369a78",
  "Dépt": "p_8edfc89203",
  "Depuis": "p_a93a213c55",
  "depuis 31.12.{{year}}": "p_3ccf817a89",
  "depuis 31.12.{{yy}}": "p_aabc2774eb",
  "depuis le 31.12": "p_7b5fded181",
  "Depuis Synthèse annuelle · Absenteism": "p_e1976700a1",
  "Depuis Synthèse annuelle · Billable hours (TF, base BCR)": "p_cd877bd2dc",
  "Depuis Synthèse annuelle · Corp hours": "p_ae29fc0ff0",
  "Depuis Synthèse annuelle · Team Mgt hours": "p_758fe93b20",
  "Dérivé des contrats : début du 1er contrat": "p_8c43b4b948",
  "Dérivé des contrats : fin la plus éloignée (vide tant qu'un contrat est ouvert)": "p_53528a365b",
  "Dernier contrat terminé le": "p_3fccdccf19",
  "Dernier mois réel clôturé — la planification commence le mois suivant. Indépendant de l'année affichée.": "p_fff4b9014c",
  "derniers jours": "p_9708ff02a3",
  "des": "p_e9d596e780",
  "Désactiver le mode affectation (retour au filtre)": "p_3410f20c90",
  "Désactiver le module {{label}}": "p_4c3bb90d3d",
  "Désaffecter": "p_c3920efd8d",
  "Descendre": "p_383f2e3e0b",
  "Descendre la ligne": "p_9ce7fc417e",
  "Description": "p_55f8ebc805",
  "Description (facultative)": "p_bbdebe488d",
  "Désélectionner": "p_bdc31a7262",
  "Désignation": "p_63a9062c64",
  "Désignation et comptes": "p_458363f4c7",
  "Désignation…": "p_bd1ca05924",
  "Désinvestissement": "p_e6a9f1464d",
  "Détail": "p_7ce06afc7d",
  "Détail des charges": "p_06e3aaf141",
  "DÉTAIL DU PERSONNEL · ": "p_f7b90ff0ce",
  "Détail par personne": "p_da35212827",
  "DÉTAIL PAR PERSONNE · ": "p_1c33b904a4",
  "Dettes à court terme": "p_323c4b8082",
  "Dettes à long terme": "p_ea7f187ecc",
  "Dettes court terme": "p_af5e4fbb8d",
  "Dettes CT": "p_1bda2be1e4",
  "Dettes financières": "p_3f812841bd",
  "Dettes fournisseurs": "p_573a205416",
  "Dettes fournisseurs réglées (postes ouverts)": "p_665577977e",
  "Dettes long terme": "p_025e39d855",
  "Dettes LT": "p_4d8cb46818",
  "Dettes ouvertes": "p_599b41fa65",
  "Déverrouiller le total": "p_c102e3b112",
  "Devise, exercice fiscal, informations de l'entreprise": "p_f21ad5fb8f",
  "dimanche": "p_786dc31c2e",
  "Diminution (−)": "p_5a8ee786b1",
  "DIO, écoulement stock": "p_b10a902fc1",
  "Direct": "p_bc81524a55",
  "Direct cost = CCR × (Billable + Non-billable) — coût de production servi au client": "p_5275b8a577",
  "Données": "p_e3e0c5ec8a",
  "Données de base": "p_6f1650acf8",
  "Données LPP": "p_7d8a22fc23",
  "Données People": "p_6408203489",
  "dont estimé {{amount}}": "p_23134d2a8b",
  "dont LPP estimée": "p_665714163b",
  "dont volume ": "p_63cd22641f",
  "DPO — paiement fournisseurs": "p_7517535a1c",
  "DPO, paiement fournisseurs": "p_1e46cae3d1",
  "Driver": "p_b5c7d8b545",
  "Droit @100% — proratisé par le taux dans la Synthèse annuelle.": "p_5d8f36e88c",
  "DSO — recouvrement clients": "p_a753317fa4",
  "DSO <strong>{{days}} j</strong> &gt; objectif 45 j": "p_88b2739939",
  "DSO, recouvrement client": "p_e37004549c",
  "du": "p_fa114377ef",
  "du bilan": "p_a289cfea68",
  "du CA": "p_4353075748",
  "du CA net": "p_69088daa8a",
  "Du chiffre d'affaires à l'EBITDA — cascade à ce jour": "p_4dec589873",
  "Du coût de production au coût total (incluant la capacité inutilisée), puis ramené aux heures facturables pour obtenir le taux de revient facturable (BCR).": "p_b881741225",
  "Du coût salarial productif au coût de capacité complet par heure disponible (CCR) : on ajoute le coût indirect alloué par pool (Cost Assignment).": "p_c32ed89c78",
  "Durée de projection": "p_278f072906",
  "Durée de projection (mois)": "p_6050b9bd69",
  "EBITDA": "p_268aab575c",
  "EBITDA : {{amount}} à ce jour": "p_3b3bda19c6",
  "EBITDA mensuel": "p_319b193e8e",
  "EBITDA mensuel (absolu) & cumul": "p_1ee7391e95",
  "écart": "p_83c32d50b0",
  "Écart": "p_6ae8dce865",
  "écart !": "p_02784a9a8e",
  "Écart %": "p_44487f6b50",
  "Écart CHF": "p_f43df0b0b1",
  "Écart N / N-1": "p_c45c3e48bb",
  "Échange de données": "p_03d8ba4b4b",
  "échéancier de paiement": "p_44ce650c19",
  "Échéancier de paiement": "p_1626c3ec5f",
  "Échéancier de paiement des charges sociales": "p_54346c0843",
  "Échéancier trimestriel": "p_0de09d5391",
  "Échec de création": "p_f486b6aa4c",
  "Échec de l’enregistrement": "p_03c3dea33e",
  "Échec de l'import : ": "p_52965a036a",
  "Échec de la création de la personne": "p_fa4cad04be",
  "Échec de la création du groupe ressources": "p_8828ce999d",
  "Échec de la saisie mensuelle": "p_9e296f5957",
  "Échec de la suppression du groupe ressources": "p_f35f4f5e50",
  "Échec du chargement": "p_85188c49ba",
  "Échec du chargement comparatif": "p_ca1436a3fe",
  "Échec du chargement de l’affectation": "p_164dbb7ac1",
  "Échec du chargement de l’audit capacité": "p_8dc405de39",
  "Échec du chargement de la vue d’ensemble": "p_f0c5042ff4",
  "Échec du chargement des données": "p_06d7bc01c1",
  "Échec du chargement des groupes": "p_a3cbad1292",
  "Échec du chargement des groupes ressources": "p_22044cb296",
  "Échec du chargement des services": "p_ed2114eb27",
  "Échec du chargement mensuel": "p_193efc6e5b",
  "Échec du téléchargement : ": "p_b32d3b2a22",
  "Échec enregistrement": "p_46543eda5e",
  "Échec enregistrement heures": "p_fed11b9875",
  "Échec suppression": "p_cf5a27791a",
  "Écraser l'année {{year}} (déjà saisie). Les fériés manuels sont conservés.": "p_f143bcbc6f",
  "Édité le ": "p_c6d6bd016a",
  "Éditer (révèle Ajuster · Brush · Structure · Notes)": "p_e6af50cfa2",
  "Éditer (révèle Brush mode · Structure)": "p_f219c5d49a",
  "Éditer les valeurs directement dans le tableau": "p_5406ad274c",
  "Édition groupée": "p_a28f0a738c",
  "Édition groupée — compléments ": "p_3ccf84e498",
  "Édition groupée — frais ": "p_fc03e28748",
  "Édition groupée — indemnités reçues ": "p_44d5632b70",
  "Eff. · moy. ": "p_c39c9159a9",
  "Effacer": "p_fe23de7b57",
  "effectif": "p_f88272fe6b",
  "Effectif": "p_bbfbd27560",
  "Effectif — grille mensuelle par personne": "p_33765d1959",
  "Effectif (têtes moy.)": "p_3fb134ce5f",
  "effectif {{eff}} · réel {{months}} mois": "p_79a3bb83e2",
  "EFFECTIF & ROTATION · ": "p_5a6678af3a",
  "effectif moyen": "p_a29b898a42",
  "Effectif moyen": "p_f65754a0b8",
  "Effectif moyen (EPT)": "p_bae00c8ee9",
  "Effectif total": "p_8b6fb10c90",
  "Effectifs": "p_129c494793",
  "Effectifs & capacité": "p_62cec15329",
  "Effectifs, capacité & productivité": "p_700b48682c",
  "Effectifs, salaires, capacité par cost pool": "p_0e93798b48",
  "Effective time — Recap (saisi vs théorique)": "p_e8f4c4db60",
  "Effet charges (Δ 12 m)": "p_18c50b17e6",
  "Effet prix": "p_06e9b9a826",
  "Effet revenus (Δ 12 m)": "p_650abd3b8e",
  "Effet volume": "p_98582f82f3",
  "Embauche": "p_5660c937a3",
  "Employé": "p_7700787d4d",
  "Employeur": "p_d8e8959d43",
  "en cours": "p_db22a78656",
  "Encaissé année 1": "p_e44110f377",
  "Encaissement": "p_b71c74588f",
  "Encaissement intégral dans l'année.": "p_45964fdac4",
  "Encaissement moyen": "p_b97f4baf97",
  "Encaissements": "p_598f53c95e",
  "Encaissements (+)": "p_04380ac2de",
  "Encaissements & décaissements mensuels": "p_61252d5efe",
  "encaissements et décaissements totaux — snapshot au centime": "p_7030cf6e53",
  "Encaissements marchandises": "p_da84e8b7a0",
  "Encaissements prestations": "p_be347c10c9",
  "Enregistré au fur et à mesure.": "p_b7675c2c29",
  "Enregistrement…": "p_e7d5f232d8",
  "Enregistrer le profil": "p_f563d0a1ef",
  "Entrée": "p_0ab59cb968",
  "Entrées / sorties": "p_4da41c0fc5",
  "entrées − sorties": "p_22751805f9",
  "Envoyer": "p_e9ce243b4a",
  "EPT · moy. ": "p_622ad51841",
  "EPT (équiv. plein temps)": "p_7a1ec63cd7",
  "EPT %": "p_3bc5229c7d",
  "EPT capa": "p_817da20b1a",
  "EPT capacité moyen": "p_75c6ea1166",
  "EPT de capacité": "p_749dfebee0",
  "EPT de capacité — effectif (TT ÷ TT pour 1 EPT) moins vacances puis structure = capacité pratique (TR) en EPT": "p_70bc5fedb0",
  "EPT mensuel": "p_43836e43f2",
  "EPT moyen": "p_7611b7c504",
  "EPT total (effectif)": "p_07c6e981ca",
  "Équilibre": "p_9f5b5fc0e9",
  "Équilibré": "p_4e3141e019",
  "Équilibre — ": "p_5a95123f3c",
  "Équilibre — écart": "p_a486b452a9",
  "Équilibre — OK": "p_7af3490f28",
  "Équipe support sans travail productif facturable (administration, comptabilité, paie, etc.).": "p_3a383957b3",
  "Équivalent mensuel moyen": "p_a7e1814a71",
  "équivalents plein temps": "p_07ac9b1ed8",
  "Erreur": "p_ab546c237a",
  "Erreur à la suppression.": "p_114fecabd0",
  "Erreur affectation": "p_b5d5d21926",
  "Erreur ajout": "p_e43cbddfe8",
  "Erreur ajout compte": "p_a178c53aa8",
  "Erreur assistant.": "p_93a1f2939a",
  "Erreur BFRE": "p_d99cc62b99",
  "Erreur chargement Bilan": "p_c3c1da46ed",
  "Erreur chargement charges sociales": "p_30c42a7777",
  "Erreur chargement lignes de crédit": "p_bb8c4e1a2c",
  "Erreur chargement mapping": "p_17e76b0fcc",
  "Erreur chargement mapping bilan": "p_4a15f1a079",
  "Erreur chargement P&L": "p_9cd7cad61a",
  "Erreur chargement standard": "p_b28fda260c",
  "Erreur chargement structure Bilan": "p_65909c7866",
  "Erreur chargement structure P&L": "p_ba52f6370c",
  "Erreur cible coût des ventes": "p_8c10d9df88",
  "Erreur clôture.": "p_ccb7c9628b",
  "Erreur copie": "p_e9ef0b40b2",
  "Erreur création": "p_a3d3d25cbb",
  "Erreur création écriture": "p_1dda5a54ab",
  "Erreur création ligne": "p_05667600b5",
  "Erreur d'export": "p_56b6d1dcd8",
  "Erreur de chargement.": "p_168d094292",
  "Erreur écriture": "p_e04f5c62ee",
  "Erreur export : ": "p_1e53efd9f2",
  "Erreur export Excel": "p_8d33251b01",
  "Erreur forecast": "p_b4fe8085d8",
  "Erreur forecast CS": "p_00aaba9f48",
  "Erreur forecast IS": "p_f6b6355e00",
  "Erreur génération forecast": "p_81d14137b5",
  "Erreur import": "p_3e0023cb76",
  "Erreur import : ": "p_fb72c0bd73",
  "Erreur import : {{detail}}": "p_860acf2e2b",
  "Erreur lien stock": "p_524956ef17",
  "Erreur masquage": "p_5e824c262c",
  "Erreur méthode forecast": "p_cae52f5e20",
  "Erreur mise à jour": "p_cb37730d45",
  "Erreur note": "p_319e649016",
  "Erreur passage manuel": "p_203d827b84",
  "Erreur renommage": "p_7b53749b97",
  "Erreur renommage bloc": "p_0f1a4a9f48",
  "Erreur réordonnancement": "p_350b99c2c6",
  "Erreur réseau": "p_0683007f98",
  "Erreur reset : ": "p_bc5f121742",
  "Erreur sauvegarde": "p_fddba013f3",
  "Erreur suppression": "p_19ede99752",
  "Erreur sur le taux.": "p_ad24feb56c",
  "Erreur TVA": "p_ce0b1b1b90",
  "Erreur type de revenu": "p_c1d1e246ad",
  "Évolution": "p_58d5412ae0",
  "Évolution {{year}}": "p_5ee9bde133",
  "Évolution de la masse salariale": "p_1ba775f80d",
  "Évolution des charges": "p_9c18ffd89b",
  "Évolution des charges : revenus {{rev}} vs charges {{chg}}": "p_ee7d33d7cb",
  "Évolution des effectifs et de la masse salariale": "p_e110cc8699",
  "Évolution du burn rate — charge mensuelle fixe": "p_da5649e6e3",
  "ÉVOLUTION DU PERSONNEL · ": "p_6970065536",
  "Evolution masse salariale": "p_53f9d2a3c6",
  "Évolution personnel": "p_052301441f",
  "Evolution pluriannuelle": "p_5ded0c6348",
  "ex. 184963.65 (négatif pour diminuer)": "p_5770233fd5",
  "ex. Carnet d'heures Q2 + Q3": "p_96ba84a894",
  "ex. Privé": "p_5f984d60ca",
  "ex. Report résultat 2025": "p_bc57aa2e32",
  "Exclu": "p_6f88fb8e78",
  "Exercice ": "p_32371cf181",
  "Exercice précédent": "p_b34f817280",
  "exonéré": "p_83c9d35d2c",
  "Exonéré": "p_5d577ae906",
  "Exonéré de LPP pour cette année": "p_06f6b16cdd",
  "Exonérer la sélection (cotisation nulle)": "p_b6d9723fd2",
  "Exploitation": "p_3097d1ee1b",
  "Export Excel": "p_4a245944ef",
  "Export Excel — données des tables, 1 onglet par rapport": "p_82564c23e6",
  "Export PowerPoint — 1 slide par rapport": "p_ea6fb812a4",
  "Export tenant data": "p_1b6342f8aa",
  "Exporter les données de l'entreprise": "p_426a5a9ebc",
  "Extrapolation d'atterrissage": "p_1e67259fda",
  "Extras": "p_3b7782ff05",
  "Extras (compléments & bonus)": "p_c018e36570",
  "Extras (rémunération suppl.)": "p_72f30fbd7c",
  "Extras annuels": "p_f71b475c1a",
  "Facturable": "p_6313423701",
  "Facturable (heures)": "p_9b78feaf92",
  "Facturation": "p_04716c6bbb",
  "Facturation {{label}}": "p_2e15b919da",
  "Facturé": "p_55e253e608",
  "facturé ÷ capacity FTE": "p_1b5356c3e2",
  "Faire démarrer le plan au mois suivant le dernier mois clôturé": "p_e9a49f07ca",
  "Favorable": "p_a4357786a2",
  "Fenêtre définie dans Set up": "p_69d9d4840c",
  "Férié officiel": "p_d3a104761b",
  "Férié officiel : déduit des jours ouvrés.": "p_457b9bdebb",
  "férié.": "p_a08a55bbf9",
  "Fériés": "p_1c23bf1663",
  "Fériés en semaine": "p_829234990c",
  "Fériés et Congés": "p_af53f21b9a",
  "Fériés et Congés ": "p_3cf06aac65",
  "Fermer": "p_5ab4ec640d",
  "Fermer le détail": "p_37e25cbf53",
  "fév": "p_5c6cb2f667",
  "Fév": "p_7b8852ec47",
  "Févr": "p_9c9ea8b366",
  "févr.": "p_7287991cef",
  "Févr.": "p_f1e984a1de",
  "février": "p_4da5618d9a",
  "Février": "p_63fc18037b",
  "Fichier": "p_f0fa5745cc",
  "Fichier HTML autonome de la sélection": "p_60d5bd0bf8",
  "Figer une copie nommée du plan de référence (lecture seule)": "p_ae0b5d6021",
  "File": "p_2c3cafa4db",
  "Filet rail ↔ contenu": "p_145b475bed",
  "filtrées sur": "p_fbafc11a55",
  "Filtrer ": "p_999f1e1e86",
  "Filtrer : personne, groupe ou taux…": "p_e3a26c9e6d",
  "Filtrer : service, segment, personne, groupe…": "p_7a67e88918",
  "Filtrer (personne ou dépt.)…": "p_224c3d8b39",
  "Filtrer (personne ou groupe)…": "p_19b06895cb",
  "Filtrer les non affectés": "p_2b0e904506",
  "Filtrer par section du bilan": "p_e4cebad260",
  "filtrés sur": "p_31c41a37e1",
  "Fin": "p_4251065f15",
  "Fin de contrat": "p_e681005858",
  "fin de période": "p_e1f859f1f3",
  "Finance": "p_1b48d3f014",
  "Finance · annexe": "p_e5180d37b2",
  "Finance · points d'attention": "p_170328c5bf",
  "Finance · prévisionnel": "p_6ac06e4cde",
  "Financement": "p_e1282d3276",
  "Financement…": "p_210614d154",
  "Fixed + paid indemnities + other expenses (frais directs individuels)": "p_0579d35543",
  "Flux d'investissement": "p_855597c006",
  "Flux de financement": "p_754800fd27",
  "Flux de trésorerie": "p_b60dc8b60a",
  "Flux de trésorerie d'investissement": "p_af3b9472a8",
  "Flux de trésorerie de financement": "p_392ab550d2",
  "Flux de trésorerie opérationnel": "p_1b2b335f80",
  "Flux net": "p_1fc309e56a",
  "Flux net de trésorerie": "p_93f91360d1",
  "Flux opérationnel": "p_1afaae4215",
  "Flux opérationnel = variation de la Liquidité du Bilan": "p_dbed9e0f06",
  "Fonction": "p_30153102eb",
  "Fonds propres": "p_09cdff9ffd",
  "Fonds propres &#8805; 50 % du capital protégé (seuil <b>{{threshold}}</b>)": "p_6b495cb1d8",
  "Fonds propres &gt; 0 (les actifs couvrent les dettes)": "p_a255be13af",
  "Fonds propres > 0 (les actifs couvrent les dettes)": "p_47e4cf42b0",
  "fonds propres négatifs": "p_1c08c089d7",
  "Forecast — cliquer pour saisir": "p_133166922d",
  "Forecast = base × taux. Taux négatif pour une charge calculée sur un produit (ex. −80).": "p_71c2a7fe81",
  "Forecast coherence": "p_dc3c8d6d0d",
  "Forecast généré : {{n}} ligne(s) × {{mois}} mois. Relance les % CS / impôts si besoin.": "p_148d4e4334",
  "forfait": "p_1756fa5190",
  "Forfait (CA)": "p_5a519bf8df",
  "forfait + indem. payées + autres (brut)": "p_7dfd49b76b",
  "Forfait global réparti à parts égales sur les mois choisis.": "p_89b2d48974",
  "Forfait projet": "p_81716c8378",
  "Forfait projet (jalons)": "p_15d4bd71da",
  "Forfait représentation": "p_6a7ce522f8",
  "Format": "p_041a5dec48",
  "Formations / sessions": "p_d65960e750",
  "Formule, ex. [l1] + [l2]": "p_e9bdf12439",
  "Forte fin année": "p_83d74bffe6",
  "FP": "p_7def6da18b",
  "frais": "p_aa5de87b9c",
  "Frais": "p_d83e7c36c7",
  "Frais (non soumis aux charges sociales)": "p_837f20a4e9",
  "Frais & débours": "p_5c65373f2e",
  "Frais de personnel": "p_d13c61c1ce",
  "Frais de représentation": "p_4dc73156d0",
  "Frais de véhicule": "p_679625d389",
  "Frais de voyage, conseils à la clientèle": "p_f7214195d0",
  "Frais du personnel": "p_ff7a69fcef",
  "Frais et débours": "p_7ebab2c01e",
  "Frais généraux": "p_eb0ea9791d",
  "Frais généraux — saisie bloquée": "p_7a5dd57fa1",
  "Frais pour des collaborateurs existants.": "p_9aa02154cd",
  "Free cash flow": "p_46d4aee4ce",
  "FTE = activité × mois/12": "p_db91bf06be",
  "FTE moyen annuel": "p_f56cb15b56",
  "FTE total": "p_d809310e5a",
  "Générale": "p_787e6d0b34",
  "Générale<br>(3ᵉ degré)": "p_e8aa130cc6",
  "Générer": "p_bd221c0787",
  "Genève": "p_ea6c4889b5",
  "Genre": "p_2aa31fca5e",
  "Gestion entreprise": "p_af6c32a92d",
  "Gestion entreprise (heures)": "p_1cc77bd307",
  "Glisse chaque ligne dans sa catégorie. « À classer » = non prises dans les flux.": "p_7dcf2967c6",
  "Glisse chaque ligne vers sa catégorie de flux de trésorerie.": "p_0082626c81",
  "glisse un compte ici": "p_9d550ab707",
  "gras": "p_c3f7fafe95",
  "Gratification": "p_04c3efdfd2",
  "Grille mensuelle par collaborateur, FTE et headcount cumulés.": "p_5c70e35c7f",
  "Gross salary + SC Empr. (= numérateur du LCR)": "p_ba9ccd2a4b",
  "Gross salary = Base salary + Annual extras (soumis aux charges sociales)": "p_1c32ea9aa6",
  "Groupe": "p_1026d22e2a",
  "Groupe de structure": "p_3a24499343",
  "Groupe ressources": "p_1784bde909",
  "groupe(s)": "p_848b1f1dec",
  "Groupes de ressources : Engineering, Support, Overhead…": "p_77b304bc53",
  "Groupes ressources": "p_c67f82e53d",
  "h — dérivé du contrat": "p_3dafb625cc",
  "H. / jour avec rattrapage": "p_3a92a8fdb2",
  "H. / jour standard": "p_e8b96dc19f",
  "H. non-prod.": "p_3359b1c087",
  "H. productives": "p_c544633b6a",
  "Hardware / Software (revente)": "p_325a218a18",
  "Headcount fin": "p_791ecdfeac",
  "Heures": "p_b4448c06da",
  "Heures ↔ % du TO": "p_571ccd9f44",
  "Heures contractuelles / semaine (décimal)": "p_16a2be9d71",
  "Heures de capacité pratique disponible": "p_1ae916ee30",
  "Heures de consulting au taux horaire — saisie libre.": "p_6be9e9acf6",
  "Heures inutilisées × CCR individuel": "p_a50fe322dd",
  "Heures théoriques, vacances, absences, FTE par personne": "p_d681846cbb",
  "Heures travaillées disponibles, nettes des congés payés": "p_084f7110a7",
  "Historique mensuel": "p_b2e6d99fca",
  "Historique mensuel & tendance": "p_2e5d72b32d",
  "horaire": "p_7850f61412",
  "Horaire": "p_db0addb39f",
  "horizon démarrant en juillet 2026 → bascule au taux 2027 en janvier": "p_17382ff830",
  "hors horizon": "p_9269a12838",
  "HT · moyenne mensuelle": "p_eeb24dd56b",
  "ℹ Aucun mois clos pour ": "p_9bd6f21e3a",
  "Idle": "p_cc1ebdd04e",
  "idle × CCR": "p_c0a96452f0",
  "idle × CCR — capacité disponible non utilisée": "p_f4ed828b4c",
  "Idle cost = CCR × Idle (capacité disponible non utilisée)": "p_47128146f4",
  "Idle cost = CCR × Idle (capacité disponible non vendue)": "p_bf3605ed75",
  "Ignorées :": "p_df0ba017d2",
  "il manque": "p_7878c3af08",
  "Immédiate": "p_4bce6c0d33",
  "Immédiate<br>(1ᵉ degré)": "p_0c8190624d",
  "Immo. financières": "p_aa995b92ef",
  "Immobilisations (CAPEX)": "p_cf8bb4a4d9",
  "Impact EBIT": "p_9629ef5bf5",
  "impact EBIT ≈": "p_6d8755c1fb",
  "Impact EBIT total": "p_0049ea7510",
  "Import": "p_d6fbc9d2bd",
  "Import {{year}} OK : {{accounts}} comptes, mois {{months}}.": "p_f3762e381f",
  "Import data": "p_d82c9379e1",
  "Import en cours…": "p_2357d6a41c",
  "Import Excel": "p_009cae7008",
  "Import…": "p_4834caf8f5",
  "Importer des données": "p_a92c608596",
  "Importer Excel": "p_3c0905e595",
  "Importer les taux": "p_fad02463bc",
  "Importer les taux {{canton}}": "p_3f47e649c9",
  "Importing…": "p_820599da89",
  "Impôt source mensuel": "p_54404b5c95",
  "Impôts": "p_1fab29b875",
  "Imprimer / PDF": "p_2dd09ec2f2",
  "Imprimer Cash forecast · A4 paysage, tous les groupes dépliés": "p_9152db9911",
  "Imprimer ou enregistrer en PDF": "p_a6ad2ff766",
  "Imprimer ou sauvegarder en PDF": "p_f10da3b8c8",
  "Imputation overhead, coûts spécifiques, résiduel + CCR": "p_44aeef63c3",
  "inactif": "p_3e1d24c540",
  "inchangé": "p_f94c4f7d80",
  "inchangés": "p_d30d2e96e1",
  "Inclure": "p_eca2de5998",
  "Inclure ce compte dans le forecast": "p_59bce8ce24",
  "Inclure dans le plan": "p_6da981de35",
  "Indem. reçues": "p_fe6550e5b1",
  "Indem. versées": "p_973ea451b5",
  "Indemnité journalière": "p_286e93a687",
  "Indemnité maladie": "p_c7906c2b20",
  "Indemnité versée": "p_2770b3a37e",
  "Indemnités reçues": "p_a3924bf10f",
  "Indemnités reçues (hors charges sociales)": "p_4a92ae95c5",
  "Indemnités reçues (produit déduit du coût employeur)": "p_9712623ec4",
  "Indemnités reçues pour des collaborateurs existants.": "p_237f4d8941",
  "Indemnités versées. Source : Frais.": "p_da311dea84",
  "INDICATEURS · ": "p_619075a612",
  "Indicateurs-clés": "p_02359e2c26",
  "Indirect burden rate × TR personne": "p_d8db34ffbc",
  "Indirect cost (QP entreprise)": "p_7d413fb7f9",
  "Indirect non affecté": "p_f4b38f9b2a",
  "Indirect personnel": "p_00b2aec853",
  "Indirect personnel = (Absenteism + Corporate + Supervision − Indemnités) ÷ TR · Overhead = (Specific indirect + Indirect costs résiduel + Expenses) ÷ TR": "p_77e46e1b8f",
  "Inducteur": "p_1f7d9a520b",
  "initial": "p_8ad7d21c71",
  "Instantané enregistré.": "p_866a77c89a",
  "Instantané figé — non modifiable": "p_ba94ed5b27",
  "Interne": "p_ef73fa64a4",
  "interne · réel": "p_8b984f0fa2",
  "Inutilisé": "p_6b5c86659a",
  "Investissement": "p_ba3f6f4e01",
  "IS forecast — décembre {{amount}} kCHF.": "p_b6f4c46406",
  "isLiquidityLabel reconnaît trésorerie/liquidités": "p_65d73c64d9",
  "j": "p_5c2dd944dd",
  "j × ": "p_6160fac9bb",
  "J. ouvrés": "p_f82f0e02d4",
  "J. sem.": "p_826858402c",
  "J. travaillés": "p_281ef53933",
  "jan": "p_14e793d896",
  "Jan": "p_efed3690ea",
  "Jan → Déc de l'année sélectionnée. Mois non clôturés laissés vides.": "p_8078d6c6a8",
  "Janv": "p_1b68e19926",
  "janv.": "p_d8cb16f77c",
  "janvier": "p_2d1cc489ce",
  "Jetons de présence": "p_c7b6f12fe8",
  "jeudi": "p_86bdcfaadb",
  "Jours": "p_57960dfb40",
  "Jours de stock (DIO)": "p_a1f316c73d",
  "Jours de vacances": "p_a06317e1e1",
  "Jours de vacances / an @100%": "p_1c68eb116a",
  "Jours dus": "p_74d4027771",
  "Jours ouvrés bruts": "p_f296a4c334",
  "Jours semaine annuels": "p_335b8c50fc",
  "Jours travaillés (net)": "p_01e4656afc",
  "jours, base 360": "p_f73835a62d",
  "Juil": "p_190b5d60f7",
  "juil.": "p_25ef9cdc09",
  "juillet": "p_10bdde9a4a",
  "juin": "p_ea31a84e72",
  "Juin": "p_8b1e84b62a",
  "Jul": "p_b737558468",
  "Jun": "p_6d90df3be4",
  "kCHF/mois": "p_770f2359a7",
  "La valeur doit être un nombre.": "p_be557717a6",
  "Labor Cost Rate = Loaded payroll ÷ TO (coût salarial chargé / heure travaillée)": "p_fa398e4148",
  "Last month — reporte le dernier mois réel sur tous les mois à venir.": "p_9dcc2d776d",
  "LCR — analyse contributive : variable = salaire chargé, fixe = indirect → seuil de rentabilité": "p_2abfb987b3",
  "LCR + Indirect burden rate du pool — coût de capacité horaire": "p_e27aef81dd",
  "LCR × idle (capacité non vendue, absorbable)": "p_c110601eae",
  "LCR × Practical Capacity (TR) — salaire chargé imputé aux heures disponibles (hors expenses)": "p_f889eebca9",
  "LCR moyen": "p_437606c3dd",
  "le 13e peut être payé en une fois ou scindé": "p_cc47298ff6",
  "Le collaborateur et la date de début sont requis.": "p_a6c1b0e302",
  "le mois 2026 facture à 8.1 %, le mois 2027 à 8.5 %": "p_9e3a2dc4f0",
  "le serveur n'a pas répondu — réessaie dans un instant": "p_588b7ac362",
  "Lecture": "p_3bdb363e1c",
  "Lecture seule · 12 mois à venir (dérivé des contrats / plan RH)": "p_73addca95d",
  "Lecture sur une seule photo des fonds propres, réel et projeté.": "p_c41e15ec6e",
  "Les 12 derniers mois clôturés (peut franchir l'année).": "p_447df0f063",
  "Les années doivent différer.": "p_b0525f74d6",
  "Les années source et cible doivent différer.": "p_def531cc22",
  "Les contrats, compléments annuels et taux LPP seront supprimés en cascade. Action irréversible.": "p_ca0e73ba08",
  "Les fériés cantonaux sont recalculés pour {{year}} (Pâques etc. décalés).": "p_7425729fd8",
  "Les fériés officiels du canton {{canton}} seront chargés automatiquement.": "p_e58d7d6611",
  "Les mois ouverts sont remplis pour atteindre la cible (− le réel déjà saisi), répartis selon la saisonnalité N-1. Charge = cible négative.": "p_619b5c0e88",
  "libellé": "p_89031778fa",
  "Libellé": "p_f5485bbae8",
  "Libellé (ex. départ, prime)": "p_4b75a802c7",
  "Libellé (ex. Marge)": "p_587f6cc827",
  "Libellé de la ligne manuelle :": "p_93723d3ed7",
  "Licences / Royalties": "p_df5f15c5a0",
  "Licences / Royalties (annuel)": "p_c80086e2db",
  "Lié au stock": "p_35719743fd",
  "Lié au stock — obligatoire": "p_58c815ac38",
  "Lié au stock (alimente la variation de stock)": "p_c6d4521ee2",
  "ligne": "p_a47313275a",
  "Ligne": "p_5f02383a9b",
  "Ligne ajoutée": "p_c0e28e6707",
  "Ligne calculée": "p_047f01d756",
  "Ligne de crédit": "p_c616874d65",
  "Ligne de flottaison — facturable en % de la capacité disponible (TR) vs cible": "p_c79a4c58e3",
  "Ligne de flottaison · facturable / capacité disponible (TR)": "p_c660348ec4",
  "Ligne de reporting": "p_2116c6904f",
  "Ligne masquée": "p_5ca4963e1d",
  "ligne non classée": "p_c4466e7e20",
  "Ligne protégée — non supprimable": "p_27523c6220",
  "Ligne standard — libellé verrouillé": "p_84dccb9e61",
  "Ligne standard — non supprimable": "p_f24e34d831",
  "Ligne supprimée": "p_68daf495b6",
  "Ligne vierge": "p_ab60582646",
  "Ligne visible": "p_201debd01b",
  "ligne(s)": "p_abab0289ca",
  "ligne(s) dépassent la capacité : Gestion entreprise + Supervision + Congés spéciaux excèdent le Temps ouvert (TO) → capacité pratique (TR) négative. Réduis ces saisies pour cette (ces) personne(s).": "p_9bbaa16b18",
  "ligne(s) existent déjà pour": "p_08a0cda373",
  "ligne(s) pour": "p_79e6170581",
  "ligne(s) sélectionnée(s). Le total annuel est recalculé.": "p_efe92a2200",
  "lignes": "p_5471634712",
  "lignes ? Cette action est irréversible.": "p_e1162f343d",
  "Lignes actives": "p_9d2887ebf1",
  "Lignes calculées à partir des postes ci-dessus (formule libre).": "p_8a38f68554",
  "Lignes de crédit": "p_e07f1a0d76",
  "lignes non classées": "p_420523bdd1",
  "Liquidité": "p_e7efbf0caf",
  "Liquidité & soutenabilité": "p_9e05697304",
  "Liquidité et fond de roulement": "p_77accebaee",
  "Liquidité générale <strong>{{val}} &lt; réf 1,5</strong>": "p_79c84740a2",
  "Liquidité prise de facto → solde initial, pas dans les groupes": "p_2963cd11bc",
  "Liquidité réduite": "p_aa7b84ffba",
  "Liquidité réduite {{ratio}}× : il manque <strong>{{amount}}</strong> pour atteindre 1,0×": "p_26a70f7f5a",
  "Liquidité réduite {{ratio}}× : marge de sécurité <strong>{{amount}}</strong> au-dessus de 1,0×": "p_9b35055376",
  "Liquidité réelle": "p_0487931328",
  "Liquidités": "p_ad7d8bcd38",
  "Liquidités (disponibilités)": "p_1b2c78120d",
  "Liste des services": "p_0dbece3bb1",
  "Loaded payroll = Gross salary + charges sociales employeur (CS + LPP)": "p_83e6f77cc2",
  "Loyer, abonnements, charges fixes à répartir": "p_2250bf7d87",
  "Loyers, abonnements, fournitures, honoraires…": "p_58f27f7a6f",
  "LPP (exacte + estimée)": "p_3de41d3cf0",
  "LPP empl (CHF/mois)": "p_3582ec4998",
  "LPP empl CHF ÷ rémunération.": "p_daefff70ba",
  "LPP employé (CHF/mois) *": "p_ad21a1e7d6",
  "LPP employeur (CHF/mois) *": "p_09a771f0e6",
  "LPP employeur et employé sont obligatoires — ou cochez « Pas de LPP ».": "p_9065518ade",
  "LPP empr (CHF/mois)": "p_28b9c59887",
  "LPP empr CHF ÷ rémunération. Surligné si valeur de repli depuis charges_sociales_lignes.": "p_50c93ae037",
  "lu du bilan": "p_bdb75c22e9",
  "lundi": "p_de23adaa61",
  "mai": "p_ea4440bd94",
  "Mai": "p_afe526a6c9",
  "Majoration frais généraux": "p_dde4e0b84d",
  "Majoration frais généraux (par heure de capacité pratique)": "p_cae174c071",
  "Majoration personnel indirect": "p_9932dbd857",
  "Majoration personnel indirect (÷ TR)": "p_b9307ecff7",
  "maladie · réel": "p_ad72cd9bb6",
  "Mandat fixe, SaaS, maintenance.": "p_87c9753456",
  "manuel": "p_adc16fa41a",
  "Manuel — aucune génération, saisie libre des mois futurs.": "p_be44bafe20",
  "Mapping Bilan": "p_6b8f94dbc6",
  "Mapping comptes": "p_5d15aeaf6b",
  "Mar": "p_c4ba082246",
  "Marchandise": "p_fff117d516",
  "Marchandises": "p_3b80732656",
  "mardi": "p_912a883ea5",
  "Marge %": "p_143c267061",
  "Marge % cumulée": "p_8b00e53339",
  "marge +{{amount}}": "p_8647a8c659",
  "Marge brute": "p_72223e53da",
  "Marge brute : {{pct}} % du CA": "p_50cd5135bf",
  "Marge brute (% du CA net)": "p_4b03c7976e",
  "Marge de chaque groupe sur chaque service (revenu pro-rata − coût au mode choisi).": "p_fd37835abe",
  "marge de sécurité": "p_654c4f7c81",
  "Marge des services": "p_82b74dbbdd",
  "Marge directe": "p_8355e0fdbc",
  "Marge marchandises": "p_82b55db658",
  "marge moyenne": "p_fe6b75d4f6",
  "Marge par groupe": "p_ec0871e7a8",
  "Marge prestations": "p_0c1a299149",
  "Marge s/ coûts variables": "p_86ff859120",
  "Mark-up overhead = (Specific indirect + Indirect costs résiduel + Expenses) ÷ TR — CHF/h": "p_8de024ef07",
  "Mark-up personnel indirect = (Absenteism + Corporate + Supervision − Indemnités) ÷ TR — CHF/h": "p_7c4c7a0a94",
  "Marketing & publicité": "p_6f8e12f55c",
  "Marquer comme BFRE (besoin en fonds de roulement)": "p_83d022c729",
  "mars": "p_44a07a1c8c",
  "Mars": "p_1778011d76",
  "Masqué": "p_6a53bd8e2c",
  "Masquer": "p_adb05f2ba3",
  "Masse déclarée assurances": "p_f07d366978",
  "MASSE SALARIALE · à date → atterrissage ": "p_3c7d85bd9c",
  "Masse salariale annoncée (an)": "p_32123a2440",
  "Masse salariale annuelle": "p_6b5adae805",
  "Masse salariale brute": "p_7083b52567",
  "MASSE SALARIALE MENSUELLE · ": "p_27d107c3b8",
  "Masse salariale planifiée": "p_3ca05e75ef",
  "Masse salariale prorata temporis de l'année": "p_111b8f1ea8",
  "Masse salariale, primes/bonus, charges sociales cantonales et assurances suppl.": "p_32a4718c93",
  "Matériel de bureau": "p_0c477f5f99",
  "Maximum 2 scénarios comparés": "p_0f7a484c0d",
  "Membres de la direction, non affectables à un groupe de compétence spécifique.": "p_7a7aed0615",
  "Même montant tous les mois (mandat fixe, SaaS, maintenance).": "p_8f77509eb0",
  "même période": "p_158dba8ce7",
  "Mémo — {{month}}": "p_4d57342eb5",
  "Mensuel": "p_272c1b22fe",
  "Mensuel — réel / projection & moyenne mobile 12 mois glissants": "p_a5bef5af29",
  "Mensuel · usage de la capacité (TR) · ": "p_15aa8855d7",
  "mercredi": "p_a6bbc9bcd5",
  "méthode TDFN résolue séparément": "p_2bcab59faf",
  "Mettre à jour": "p_e97e6c66c3",
  "mis à jour": "p_cc882068d8",
  "Mise à jour groupée": "p_814020289e",
  "Mises à jour :": "p_f1e247c17a",
  "Mix": "p_fd7391b672",
  "Mix N-1": "p_c33ce80ca7",
  "Mode": "p_a7b93d2128",
  "Mode / an = montant annuel réparti sur les mois actifs.": "p_3156c2e028",
  "Mode / mois = montant identique chaque mois actif.": "p_d8f2ef6bbf",
  "mode affectation": "p_ae12760b3b",
  "Mode de prévision par ligne — clic sur le badge pour passer au suivant": "p_9ab6215ea3",
  "Modifier \"{{label}}\"": "p_290292f9de",
  "Modifier (supprimer et dupliquer à l'intérieur)": "p_fe5a5d48ef",
  "Modifier {{label}}": "p_f5215d0ec5",
  "Modifier la clôture": "p_2b7f996efe",
  "Modifier le contrat": "p_2ed431bd91",
  "Modifier le profil": "p_8f51146b2f",
  "Module": "p_b8ff028929",
  "mois": "p_339528c893",
  "Mois": "p_0d304bea4c",
  "Mois de départ": "p_212a06376e",
  "Mois de paiement": "p_1961a2c3ae",
  "Mois de paiement (échéancier) — janvier à décembre": "p_ea99c4c8f8",
  "mois de runway": "p_b504c99968",
  "Mois de versement": "p_d19605e1a0",
  "Mois en cours · cumulé · cumulé N-1 · variation": "p_e2164ca69a",
  "Mois où chaque assurance est facturée (sortie de trésorerie). Les": "p_25d079c213",
  "mois planifiés. Les coûts variables en % d'une ligne de revenu s'éditent désormais directement sur la ligne (onglet Revenus).": "p_70cd6c0e0d",
  "Montant": "p_4adcd9fc48",
  "Montant (CHF)": "p_3f11e2a0e9",
  "Montant (signé : positif = encaissement, négatif = décaissement) :": "p_e4a4c93a71",
  "Montant / mois": "p_54101d4b59",
  "Montant HT": "p_3df1d6fed8",
  "Montant par mois (CHF)": "p_2d441db88b",
  "Montant par mois × nombre de mois cochés (non soumis aux charges sociales)": "p_03869d699f",
  "Montant par mois × nombre de mois cochés (produit déduit du coût employeur)": "p_451b9716f1",
  "Montant par mois × nombre de mois cochés (soumis aux charges sociales)": "p_5c23dff793",
  "montant vide = ignoré": "p_27ac1cac0b",
  "montant vide = ignoré.": "p_d2e7b8eb58",
  "Monter": "p_dd1b79d91c",
  "Monter la ligne": "p_52a510d23f",
  "moteur — TVA appliquée au taux du mois": "p_31ac449793",
  "Mouvements (": "p_4c9d884d3d",
  "Mouvements ({{count}} total — toutes années)": "p_ee9d0b53c9",
  "Mouvements (fenêtre)": "p_4a7defada8",
  "mouvements {{delta}}": "p_5a07cc4d99",
  "Moy. encaissée / mois": "p_2f3997d9d1",
  "Moy. facturé / mois": "p_66a744c812",
  "Moy. pondérée par rem. effective": "p_2168a00a4b",
  "moyen mensuel (contrats)": "p_7b19c2477e",
  "moyenne": "p_cafc11ed3f",
  "moyenne ": "p_10ea2560b0",
  "moyenne 12 mois": "p_06442413cf",
  "Moyenne entreprise": "p_1636607ae8",
  "moyenne mensuelle": "p_91479cebb7",
  "Moyenne mensuelle": "p_21b23a5299",
  "Moyenne mobile 12 mois": "p_cf2784d55e",
  "Moyenne N-1": "p_07c868f4ee",
  "Moyenne pondérée par H. contractuelles": "p_3525dd1a94",
  "Moyenne pondérée par H. prod": "p_f18ed5d0b0",
  "Moyenne pondérée par H. TF": "p_6af9093cfc",
  "Moyenne pondérée par H. TF (lignes avec tarif > 0)": "p_c720053dab",
  "moyenne sur les mois clos": "p_7dcce4d834",
  "Moyenne YTD — moyenne des mois réels de l'année, appliquée aux mois restants.": "p_660962befb",
  "N-1": "p_4f927fbfe4",
  "N° compte": "p_bfe0128148",
  "N° compte · désignation": "p_9030a26644",
  "N−1": "p_2992953fee",
  "N−1 ({{year}})": "p_376b6331cd",
  "Nature": "p_bddc7adb12",
  "Navy (primaire · titres, KPI, totaux)": "p_cd8f2c9da2",
  "Nb": "p_18f3daebd4",
  "Nb de salaires": "p_ce940bcf9b",
  "Nb mois (12 ou 13)": "p_0afce1cef4",
  "négatif": "p_2e2d55f11c",
  "Net margin unitaire = Hourly rate − CCR (CHF/h et %)": "p_3fed5388e0",
  "Neuchâtel": "p_469f13a451",
  "NF productif": "p_55c11b790a",
  "Niveau de lecture — cliquer pour dérouler : synthétique → ouvert → tout ouvert": "p_48a792a833",
  "No file selected": "p_f76f1c1c65",
  "No productive pool with data for {{year}}.": "p_6db6e8ff80",
  "Nom": "p_7ff20370c8",
  "Nom / Prénom": "p_984f5046d6",
  "Nom de l'instantané :": "p_1ced58e1db",
  "Nom de la page": "p_6d4d29fddb",
  "Nom de la personne (ex. Alice Dupont)": "p_dec69c086c",
  "Nom du groupe (ex. Ingénierie)": "p_d6c5a0e034",
  "Nom du profil": "p_f5ebf62e8d",
  "Nom du rapport": "p_63b37dac03",
  "Nom du rapport.": "p_38c97c45f1",
  "Nombre de jours indemnisés": "p_fa8822c9da",
  "Nombre de jours indemnisés (facultatif)": "p_4b865ebcca",
  "Non affecté": "p_3a823a4b21",
  "non classé": "p_ed7f5a64cd",
  "non classés": "p_1e1ffe1bde",
  "Non facturable (heures)": "p_b3af70bce2",
  "Non mappé — ": "p_cf367f2794",
  "Non productif (h)": "p_be36c57881",
  "Non-billable hours — saisie dédiée dans Synthèse annuelle (hors idle)": "p_695aef3209",
  "Non-fact.": "p_e319fa3845",
  "non-fact. × CCR": "p_b125c6c63d",
  "Non-facturable": "p_10b32b0a0d",
  "Normalisé à 100% EPT (effectif ÷ taux d'activité).": "p_5a326f78f7",
  "Note libre pour ce mois (ex. dates de fermeture d'entreprise).": "p_332be69321",
  "Notes": "p_70440046a3",
  "Nouveau bloc": "p_8963ec054d",
  "Nouveau poste": "p_03005c4d76",
  "Nouveau profil de saisonnalité": "p_4c15f3906e",
  "Nouveau rapport": "p_98bed007da",
  "Nouveau scénario": "p_1d18b30ca3",
  "Nouveaux actifs (acquisitions)": "p_0eecef3ef6",
  "Nouveaux actifs (dépenses d'investissement)": "p_12385a88a5",
  "Nouveaux collaborateurs": "p_db11c848e7",
  "Nouvel actif…": "p_4b5ccc5c88",
  "Nouvelle année": "p_39bcceafa7",
  "Nouvelle catégorie": "p_8c5f928e20",
  "Nouvelle charge": "p_3208db5046",
  "Nouvelle charge en %CA": "p_5569918562",
  "Nouvelle charge manuelle": "p_9115da58db",
  "Nouvelle ligne": "p_2195728669",
  "Nouvelle valeur": "p_a56dea7bb2",
  "Nouvelles lignes de financement": "p_0eb92c3900",
  "Nov": "p_bb9bfefd53",
  "nov.": "p_a28a131c6c",
  "Nov.": "p_b04658d444",
  "novembre": "p_9072c55d36",
  "o/w Billable / Non billable / Idle = CCR × heures correspondantes (somme = Total Capacity cost)": "p_ee80a58c26",
  "Obligatoire = clôture N-1": "p_64931c29cc",
  "Occupation par personne": "p_e4a7edd945",
  "Oct": "p_51327aef98",
  "oct.": "p_d70389c74e",
  "Oct.": "p_fb769c2f3a",
  "octobre": "p_1a4f501b71",
  "openingPeriod : mois précédant le début": "p_8cc022c3f2",
  "Operational time (practical) — heures travaillées disponibles": "p_04f21e94ed",
  "Opérationnel": "p_f4036a90f7",
  "ou": "p_d5f10c9bc8",
  "Où va le temps payé": "p_2b7cb35542",
  "Outsourced services": "p_ce59479bb9",
  "ouverture": "p_a64df9f267",
  "Ouverture (31.12)": "p_0fafe56f44",
  "ouverture + cumul (charges calculées − décaissement) — égale la ligne Assurances sociales du bilan": "p_7c073c49ad",
  "Overwrite existing rows in {{year}} (sinon : ignorées par personne)": "p_5b4d657a20",
  "Overwritten": "p_a912c8a22b",
  "P&L · {{sec}}": "p_4cbfd12321",
  "Page vide. Clique « + Rapport » pour ajouter un rapport.": "p_94d8128e83",
  "par ligne (id)": "p_89a27b849d",
  "Par occ.": "p_df0d456051",
  "Paramètres": "p_ef8f01219a",
  "Paramètres globaux": "p_67600c22ae",
  "Parcourir…": "p_acf9070425",
  "Part de marchandises :": "p_29b4d7c25d",
  "Part de marchandises (%)": "p_2d34a8fa98",
  "Part des salaires bruts annuels": "p_9211ce7113",
  "Part employeur (%)": "p_37c96a45d0",
  "parti": "p_8ac7b64e28",
  "Parti": "p_1911afc1ab",
  "Pas de LPP": "p_6cc9050ebe",
  "Pas de LPP (exonéré)": "p_dddd5d28d6",
  "Pas de supervision — inclus dans Gestion entreprise": "p_88d0638afe",
  "passé": "p_1a79c7314a",
  "Passer l'écriture": "p_890e0cdc2b",
  "Passif": "p_1eede0cb94",
  "Passif CT": "p_5a207af003",
  "Passifs circulants": "p_9961bbaa29",
  "Patientez…": "p_506f342d3e",
  "Pause juil-août": "p_78f0f414a7",
  "payé non dispo · carve · effectif": "p_4e53de103b",
  "PCR — coût de production, sous-activité répartie dans le coût des services": "p_3c676819de",
  "PCR − CCR = (TR − TF) × CCR ÷ TF": "p_9310a24577",
  "People · Coût horaire (CCR)": "p_fb8b772ea1",
  "People plan — masse salariale issue des contrats, mouvements et 13": "p_0178435e5e",
  "Période": "p_de2110b7a0",
  "Période affichée (colonnes mensuelles)": "p_f7696073a2",
  "Période du plan (modifiable dans Set up)": "p_617e2472f5",
  "périodes TVA — réconciliation trimestrielle": "p_2231962bb8",
  "pers.": "p_3851d0481d",
  "personne": "p_d3101676be",
  "Personne": "p_6691d67aa4",
  "Personne / libellé": "p_ae06e809bf",
  "Personne non assujettie à la LPP (cotisation nulle)": "p_12bbf60ea3",
  "Personne sans lien mensuel (tdabc) — saisie mensuelle indisponible.": "p_685f33f8cc",
  "personne(s)": "p_aa0393a7c2",
  "Personnel": "p_87eecd7729",
  "Personnel — Salaires, cotisations & assurances": "p_fd76894c9d",
  "Personnel charges": "p_ffd4f0886f",
  "Personnel indirect": "p_83655b093f",
  "personnel indirect · charges · frais": "p_1bedb5fd9f",
  "personnes": "p_8dcc18678d",
  "Perte & profit": "p_36c10cd34b",
  "Perte & Profit": "p_156f643344",
  "perte de capital": "p_5067b8a355",
  "Perte de capital": "p_a74dd6b074",
  "Perte de gain": "p_0cbe5b4310",
  "Pessimiste : revenus × 0.90, achats Section B identiques à Base": "p_8c06ab1e73",
  "Phasing du paiement — charges sociales (assurances)": "p_922cac4ae0",
  "Pic Q4 par défaut ; alternatives : creux estival, ramp-up.": "p_1cbf692716",
  "Pilote le décaissement des assurances (prime = masse × taux). Défaut = brut de janvier × 12 =": "p_3ae513845b",
  "Piloté par People (taux / départ nominatif)": "p_11fd809c6d",
  "Pinceau :": "p_ececdc789d",
  "Pinceau : clique les comptes pour les affecter à la ligne sélectionnée.": "p_156d263973",
  "Pinceau armé : ": "p_8e139eec33",
  "Plan de liquidité": "p_85d0a5fd4a",
  "Plan de liquidité (direct)": "p_446d6f8d03",
  "Plan de référence": "p_7f37f301e8",
  "Plan de trésorerie · kCHF": "p_15662109d1",
  "Plan des liquidités": "p_496402a468",
  "Plancher": "p_677246671c",
  "Planification — évolution du personnel": "p_ee273ce260",
  "Planification — synthèse & mouvements": "p_fdb24f2ea7",
  "Planification du personnel": "p_c6f7c9c815",
  "Planification financière": "p_b83ae588bc",
  "Planification personnel": "p_eddca907da",
  "Planning des effectifs — évolution du personnel": "p_1d412fdc15",
  "Planning des effectifs — synthèse & mouvements": "p_0adaaec4b8",
  "Plus bas = plus autonome": "p_3dbafe478d",
  "Plusieurs — fichier Excel": "p_4eb5ad38af",
  "plusieurs années possibles": "p_ef9a66e5c5",
  "Plusieurs années possibles": "p_dfa47ccdfa",
  "Point de contrôle — Σ (TR × CCR)": "p_e2c0f7d688",
  "Point de contrôle (new) — Σ (TR × CCR new)": "p_4978b98bc3",
  "point de départ": "p_07fd5ff7aa",
  "Point de départ": "p_93f0a6848c",
  "Point mort, analyse coût-volume-profit": "p_a7c25b3567",
  "pool": "p_51a4b13bc7",
  "Pool": "p_778627418c",
  "pools": "p_3547ddb84c",
  "positif": "p_557f42dd79",
  "Position d'affichage — édite pour déplacer la ligne": "p_9c94162c8d",
  "positionné sur ce mois dans les vues People (pas étalé)": "p_94b180f732",
  "Positions clés au Bilan": "p_c82fe68a49",
  "Positions ouvertes au démarrage. Valeur ouverte (créances = positif, dettes = négatif), puis part encaissée / décaissée en % sur M1-M6.": "p_4d41248cb3",
  "poste": "p_a28abde6e5",
  "Poste": "p_86abf0cd8a",
  "Poste ouvert": "p_444310cfcb",
  "postes": "p_d950226dcf",
  "Postes à afficher — cherche un agrégat, un compte ou un sous-total.": "p_fad2a52c22",
  "Postes ouverts": "p_291f609322",
  "Postes ouverts (PO)": "p_8c57d64507",
  "pour ": "p_7ea42e7a2e",
  "pour atteindre 1,0×": "p_e213627982",
  "Pourcentage (%)": "p_d73e0ae7aa",
  "Pourcentage entre 0 et 100 (ex. 50 pour 50 %)": "p_fba46c4900",
  "Practical Capacity − Production hours (capacité disponible non utilisée)": "p_86299d5771",
  "Prénom": "p_e4387ade0f",
  "Prénom *": "p_72fe35057a",
  "Prénom, nom et date de début de contrat sont requis.": "p_49cba89eec",
  "Prépayé : encaissement à la vente du carnet.": "p_53234cff37",
  "présent, sans production": "p_9912b8424a",
  "Presets de revenus": "p_ac9ae96773",
  "Prestation": "p_b51f479f4c",
  "Prestations": "p_0370136a74",
  "prév.": "p_c177c4172d",
  "Prév.": "p_850ac9fd0b",
  "Prévision": "p_a153d367ca",
  "Prévision · déc.": "p_5327e8e6f1",
  "Prévision des ventes": "p_96faa5a482",
  "prévisionnel": "p_8a91c41a97",
  "Prévisionnel": "p_0995a40774",
  "Prévisionnel 12M": "p_5931b1f1d2",
  "PRÉVISIONNEL CHARGES SALARIALES · {{year}}": "p_d17cfed89c",
  "Prévisionnel de trésorerie": "p_a5643f4671",
  "Prime": "p_2533d6c74e",
  "Primes & bonus": "p_aa53f720b7",
  "Primes & Bonus": "p_c5fb644703",
  "Principe directeur : toute couleur nomme son rôle en un mot — ardoise = accent, sage = favorable, terracotta = alerte, bleu = saisie. Une couleur sans rôle n’entre pas dans la charte.": "p_8f1dea9d3e",
  "Print": "p_5b221e9c2a",
  "Print reports": "p_9545608514",
  "print:categories.Coût horaire": "p_af25309127",
  "print:categories.Planification financière": "p_63ad984027",
  "Prix effectif réalisé = Revenue (billed) ÷ Billable hours (TF). Pied de table = Σ billed ÷ Σ TF.": "p_46936a2c38",
  "Prix standard — saisi dans Input Analytics (lecture seule ici)": "p_14a8e86bcd",
  "Prix/h · ou CA": "p_e6ded666de",
  "Productif (h)": "p_07c1d04028",
  "Production mesurée ÷ TR": "p_6687186fe6",
  "Productivité": "p_04a291c68d",
  "Productivité — valeur ajoutée 12 mois glissants par EPT": "p_f594b118c7",
  "Produit (APG, maternité, accidents) — info séparée, non déduite des charges de personnel totales ni du salaire net.": "p_d8451f1175",
  "Produit (APG, maternité, accidents) — info séparée, non déduite.": "p_6591b0ef8c",
  "Produit, déduit du coût d'absence net": "p_132c050b47",
  "Produits encaissés": "p_03670b3817",
  "Produits encaissés (HT)": "p_f075b7f3ce",
  "Produits encaissés {{year}}": "p_c7dec733d4",
  "Profil d'encaissement des postes ouverts (M+1, M+2, M+3)": "p_7f9f35f899",
  "Profil de facturation (saisonnalité)": "p_f400f3cfcb",
  "Profit/an": "p_210e4b9fa9",
  "Projection": "p_8aa49fe840",
  "Projection : coûts fixes vs trésorerie": "p_c59483eb06",
  "Projection 12M": "p_59859443b2",
  "Projection de trésorerie sur 12 mois": "p_a5548f5c27",
  "Projection fin année": "p_2ecec92601",
  "Projection fin d'année": "p_0e1c8edd17",
  "Projeté fin année": "p_30827af276",
  "protégé": "p_80b35f5745",
  "Protégé (système) — non supprimable": "p_c99bb10b36",
  "Prototype en lecture seule — pose une question sur le P&L, par ex. « quel est l'EBITDA {{year}} ? » ou « comment évoluent les salaires mois par mois ? ».": "p_c2eb81bae2",
  "pt": "p_bc811258ae",
  "pt vs 2025": "p_3816f28228",
  "Publicité": "p_7e96ac1003",
  "QP entreprise × Practical Capacity": "p_76e73204c8",
  "Quatre acomptes égaux (par défaut mars/juin/sept/déc).": "p_cd291de08e",
  "Quick ratio · (liquidités + créances) ÷ DCT": "p_a47e9e023f",
  "quick ratio · réf 1.0": "p_bde3b979da",
  "rapport": "p_d6f772f887",
  "Rapport": "p_f25c405bbb",
  "Rapport personnel": "p_a2cdefc435",
  "Rapport vide — clique « Construire ».": "p_cf470b20e8",
  "Rapport vide.": "p_98ffa08901",
  "rapports": "p_fbf667d8d5",
  "Ratio de liquidité": "p_f6ce00713c",
  "Ratio liquidité": "p_d7d49e2131",
  "Ratios de liquidité": "p_3200297579",
  "Réalisé": "p_eed7fe3aff",
  "Réalisé à ce jour": "p_ef062eb7ae",
  "Réalisé an 1": "p_6a3ef5040c",
  "Réalisé vs Std": "p_b2d66595a9",
  "Recharger": "p_b10ee5111a",
  "Recharger les fériés ": "p_938603725e",
  "Recharger les fériés {{canton}} {{year}} ?\nLes fériés cantonaux actuels seront remplacés (manuels conservés).": "p_5abd5abb33",
  "Rechercher (français, anglais, module, sens)…": "p_82c3f16a25",
  "Rechercher une personne ou un département…": "p_5b69bfb5f8",
  "Réconciliation": "p_cbf70ab998",
  "Réconciliation avec le bilan": "p_157dc4e419",
  "Récurrent / abonnement": "p_0f06ce622a",
  "Réduction générale": "p_b2a060ca5d",
  "réduite": "p_1172eace35",
  "Réduite": "p_d377bbf285",
  "Réduite<br>(2ᵉ degré)": "p_199228128b",
  "réel": "p_964e49c9e4",
  "Réel": "p_963e56fe84",
  "réel · annuel": "p_82f99c1bfd",
  "réel · au dernier mois clôturé": "p_1a28406cca",
  "Réel · clôture": "p_9ddab5c801",
  "réel · dernier mois clôturé · Δ vs mois précédent · {{unit}}": "p_a48c34da6c",
  "réel · dernier mois clôturé · Δ vs mois précédent · Δ vs 31.12.{{year}}": "p_0953a7cfe8",
  "Réel · mois en cours {{month}} {{year}} · cumulé {{closed}} mois vs {{yearPrev}} · {{unit}}": "p_6a91975ef6",
  "Réel · mois en cours {{month}} {{year}} · cumulé {{n}} mois vs {{yearPrev}} · {{unit}}": "p_9979ee7ae7",
  "réel · YTD annualisé": "p_741be36983",
  "Réel (mois clôturé)": "p_e168dc68a5",
  "réel {{year}} vs {{yearPrev}}": "p_960974be00",
  "réel + prév.": "p_df81be29bf",
  "Réel clôturé jusqu'à": "p_2a9196055b",
  "réf": "p_a8ee11be07",
  "réf {{value}}": "p_c2daf67c9a",
  "réf 1,3×": "p_faba169dea",
  "réf 1.0×": "p_15b78e6dfa",
  "réf 1.3×": "p_cb27b6644a",
  "Réf. salaire (an)": "p_7ea2a02098",
  "Référence · 1.3×": "p_0d4be11b74",
  "Référence du décompte, période, assureur…": "p_f781d72856",
  "Référence une autre ligne par son jeton, ex.": "p_ec9c89ed1e",
  "Référence, justificatif, période…": "p_9f6de6be34",
  "Régie (heures variables)": "p_b61feed78b",
  "Règle d'allocation des temps indirects": "p_ff4064cdac",
  "Règle d'or ≥ 1,0×": "p_c61e71bb49",
  "Régler la réalisation": "p_4b7ac8a0f2",
  "Relatif (M+n)": "p_8a6e1cd100",
  "Remplacer ce bloc par les lignes standard (comptes re-mappés par libellé)": "p_4ddd0f4125",
  "Remplacer les {{count}} ligne(s) existantes pour {{year}} par les taux {{canton}} ?": "p_5639b9873b",
  "Remplacer les compléments existants de ": "p_721bba361b",
  "Remplacer les frais existants de ": "p_a67856e105",
  "Remplacer les mois de versement": "p_4ec1866bfb",
  "Remplacer les taux existants par le modèle ": "p_93146cc0b8",
  "Remplir, puis réimporter": "p_a24bae5103",
  "Remplit les mois ouverts selon le mode de chaque ligne": "p_2e226aee6d",
  "Rémunération + total des frais − charges sociales employé (cash net + avantages + indem. versées, avant impôt sur le revenu)": "p_e418864ba6",
  "Rémunération effective × CS empr. % + LPP employeur CHF (charges sociales employeur)": "p_68b486b80c",
  "Rémunération, charges sociales, LPP, coût employeur par personne.": "p_0009f8c546",
  "Rémunérations supplémentaires soumises aux charges sociales": "p_dd46280847",
  "Rendement": "p_30d52cf8d1",
  "Rendement masse salariale": "p_f349ae08f0",
  "Rendement masse salariale : {{ratio}}×": "p_d8df9cddb6",
  "Renommer le bloc": "p_0f6f321b4d",
  "Renommer le scénario": "p_99c21710b6",
  "Renseigne d'abord un total annuel.": "p_a392a25ccf",
  "Renseignez au moins un taux, ou cochez « exonérer ».": "p_4be1e3bd3d",
  "Renseignez un montant et/ou les mois.": "p_b4a4ba768a",
  "Renseignez une désignation, un montant et/ou les mois.": "p_cbf95b9cbb",
  "Rentabilité": "p_e794877616",
  "Rentabilité · Coût de production": "p_1995f795ba",
  "Rentabilité par collaborateur : revenu réel facturé (billed) face au coût de production servi, net margin (avant capacité inutilisée) puis profit (après idle).": "p_5b8e8e2bcc",
  "Rentabilité service": "p_cf601e597b",
  "Répartition constante (8,33 %)": "p_1d92be78e8",
  "Répartition des heures : billable, pool mgmt, idle, corp": "p_ada4cadc2b",
  "Repas & déplacement": "p_fab3675739",
  "Replier": "p_cc1ff83372",
  "Report": "p_ee45c30326",
  "Report {{year}}": "p_1801ea6ef3",
  "Report à plat (dernier solde connu)": "p_003bcdaa18",
  "report arrière : année avant la 1re ligne → plus ancien taux connu": "p_0a5f45a0fe",
  "Reporting line · n° compte / désignation": "p_0b70cdfff9",
  "Reprendre du bilan N-2 (31.12)": "p_7cf198e46f",
  "Reprendre la somme des liquidités du bilan": "p_76cf68845e",
  "repris de facto": "p_6ab09b8d24",
  "Repris du bilan Financials, soldes au": "p_907360cab6",
  "rés. net + amort. − résultat financier": "p_c41d7ef7c9",
  "Réserves & report (hors flux)": "p_1e8845ab58",
  "Reste {{amount}} CHF à encaisser en année 2 (effet du délai de paiement).": "p_40cf27cd50",
  "Résultat (hors flux)": "p_ad48ed2b4d",
  "Résultat cumulé du compte de résultat": "p_bad47fb969",
  "Résultat financier neutralisé": "p_f16a7facc1",
  "Résultat net": "p_1bbe6f47b1",
  "RÉSULTAT NET": "p_413699efe3",
  "Résultat net (à ce jour)": "p_667be72252",
  "Résultat net + amortissements + variation du BFR — aligné sur l'onglet Flux de trésorerie": "p_93e60247c3",
  "Résultat net de l’exercice": "p_70bdf80021",
  "Résultat net de l'exercice cumulé": "p_8e8541254b",
  "Retirer": "p_54ec24a19c",
  "Retirer (non mappé)": "p_f50434dc82",
  "Retirer du BFRE": "p_3bde9d344c",
  "Retirer du plan": "p_c13be51748",
  "Retirer l'affectation": "p_f4c5feaa61",
  "Revenu": "p_f9854fcc0e",
  "Revenu réel facturé (billed_amount, saisi page Revenues).": "p_17f0e9c778",
  "Revenu/EPT à fin": "p_b89acbff0b",
  "Revenu/EPT à venir": "p_436f756485",
  "Revenu/EPT moyenne annuelle": "p_14a2ca186e",
  "Revenue (billed) − Direct cost (coût complet servi au CCR)": "p_61a90db185",
  "Revenue = revenu réel facturé (billed, page Revenues) · Avg hourly rate = Revenue ÷ Billable hours": "p_a030ea8f5a",
  "revenus": "p_e9a34280c8",
  "Revenus": "p_a08a099a37",
  "Revenus & charges — 12 mois glissants": "p_992f468183",
  "Revenus & charges op. — 12 mois glissants (effet ciseaux)": "p_1ee98f1ff3",
  "Revenus 12 m": "p_f0123a36f6",
  "Revenus des prestations": "p_feb205daaf",
  "Revenus et charges mensuels groupés, marge cumulée en pourcentage sur axe droit": "p_7ad4d1bd1b",
  "Revenus par mois": "p_2097ff3949",
  "RHT": "p_bcd6ecbcef",
  "Rotation (brute)": "p_ae1f2b6d35",
  "Roulement : stock du mois précédent + variation de stock (P&L)": "p_b8da2d14e3",
  "run rate · charges op. jusqu'à l'EBITDA": "p_af382b698d",
  "runway": "p_e967caa40b",
  "Runway": "p_80a63a7686",
  "sain": "p_0e0b220e0a",
  "Sain": "p_0de13ff438",
  "Sain PME ≈ 30–40 %": "p_810da8ed2e",
  "Sain PME ≈ 30–40 %": "p_40a790ec10",
  "saisi": "p_5070ee02c1",
  "saisi — aucune ligne Liquidités au bilan": "p_3007e6eeea",
  "Saisi manuellement": "p_4252156480",
  "Saisie d'un seul, à l'écran": "p_195bedd9d6",
  "saisie en {{year}}": "p_9537cefc35",
  "Saisie libre — commissions sur encaissement client final, primes, etc.": "p_46028e0456",
  "Saisie libre des 12 cellules (consulting au temps passé).": "p_61a3f783a6",
  "Saisie manuelle —": "p_f08269aa56",
  "Saisie manuelle sur les": "p_b55f3154a9",
  "Saisir le pourcentage attribué à chaque mois calendaire (Janvier → Décembre). La somme doit être proche de 100 %. La vue est fixe pour éviter les confusions avec le mois de début du scénario.": "p_84b40d9784",
  "Saisir le taux accordé par l’AFC ; reporté (en gris) vers les années suivantes.": "p_4801f3ac90",
  "Saisir un nouveau profil mois par mois": "p_a6ece7a0c3",
  "Saisonnalisé N-1": "p_8fd5dff9be",
  "Saisonnalisé N-1 — reprend le profil mensuel de l'an dernier, recalé sur le niveau réel de l'année.": "p_61619c5f05",
  "Saisonnier (modulation calendaire)": "p_5884c4ccfe",
  "Salaire / mois": "p_af8530b0e1",
  "Salaire × Nb sal. — brut annuel réel au taux d'activité courant.": "p_bfa06967ef",
  "Salaire annuel @100%": "p_d9b42debeb",
  "Salaire annuel effectif": "p_60025b2bd6",
  "Salaire brut": "p_e3a6d9f070",
  "Salaire brut + CS empr. (= numérateur du LCR)": "p_8f33ccc6f2",
  "Salaire brut + CS empr. (salaire chargé employeur, avant frais)": "p_d3b5f4afb2",
  "Salaire brut mensuel": "p_41f6019d2b",
  "Salaire brut mensuel total": "p_144a8aba28",
  "Salaire chargé": "p_a2b47f39e5",
  "Salaire chargé + total des frais (BRUT, indem. reçues non déduites)": "p_07f5f6dd25",
  "Salaire chargé ÷ TO": "p_ac2cbd5fd2",
  "Salaire chargé total": "p_18f7843233",
  "Salaire de base": "p_0e34433e9f",
  "Salaire de base + extras annuels (= brut soumis aux charges sociales)": "p_284352c94d",
  "Salaire de base + extras annuels (assiette CS)": "p_dc96268793",
  "Salaire de base annuel (hors extras), assiette CS": "p_f9a7e0914a",
  "Salaire horaire (LCR)": "p_901ba586f1",
  "Salaire horaire (LCR) par personne": "p_320331e7e0",
  "Salaire horaire par personne": "p_4018dd116c",
  "Salaire mensuel (CHF)": "p_35e4cee1a2",
  "Salaire mensuel × Nb de salaires (brut annuel au taux d'activité)": "p_a57fdb4462",
  "Salaire net": "p_6bcd9a22c0",
  "Salaire net annuel": "p_aa84826073",
  "Salaire net total": "p_4d55807a15",
  "Salaires": "p_9855aa5aba",
  "Salaires de base": "p_e8cf7fe733",
  "Salaires bruts": "p_db4008abe9",
  "Salaires bruts ": "p_c2ba5f237e",
  "Salaires bruts (base · {{month}})": "p_d0283e2f15",
  "Salaires bruts {{year}}": "p_1842b6b677",
  "Salaires bruts /an": "p_a1891cf2eb",
  "Salaires bruts 12M": "p_677d3011ad",
  "Salaires nets": "p_1be837ce79",
  "Salaires nets versés": "p_b03c04eee5",
  "Salaires recalculés — 12 mois à venir": "p_09dc40e8ab",
  "samedi": "p_785ee49b7e",
  "sans contrat": "p_7f9f78ae01",
  "Sans groupe": "p_317b40fb8f",
  "sans mouvement": "p_41b95ef843",
  "Sans segment": "p_c567a38732",
  "Sans titre": "p_679c674886",
  "SC employeur": "p_75c31a2624",
  "Scenarii · Trésorerie": "p_a05e1e3473",
  "Scénario": "p_8b9a2a34fe",
  "Scénario dupliqué.": "p_dc63708854",
  "se saisissent dans Input People → Charges sociales ; ici on planifie seulement l'": "p_eb366c7ad3",
  "segment": "p_6a80eba8ec",
  "Segment": "p_44986cef8a",
  "Sélection": "p_ac0002b077",
  "Sélectionne d'abord une entreprise.": "p_4ed2254ad1",
  "Sélectionne des lignes du bilan →": "p_313f4b3b94",
  "Sélectionne une entreprise.": "p_1bd099a227",
  "sélectionne une ligne pour la remonter au plan": "p_be189d99c8",
  "sélectionné(s)": "p_9cb04d32f8",
  "sélectionnée(s)": "p_1daa80ec60",
  "Sélectionner d'abord des lignes": "p_cdf63cb1f9",
  "Sélectionner d'abord une entreprise.": "p_53c4f53f16",
  "Sélectionner un plan ou un instantané": "p_5da700637b",
  "Sélectionner une entreprise.": "p_bfb1fe700a",
  "Sélectionnez au moins un mois.": "p_3790cc5481",
  "Sélectionnez un tenant.": "p_320d865b02",
  "Selon mois de paiement": "p_a6370a040f",
  "Sep": "p_fdd289e370",
  "Sept": "p_2a10c65f87",
  "sept.": "p_22ad8e709d",
  "septembre": "p_9d9d352f05",
  "Série indisponible.": "p_4b01c427b3",
  "Série mensuelle ": "p_0fb60e5852",
  "Service": "p_329cb8b6ba",
  "Services = compétences ou prestations (Géomaticien, Consulting…). Mode ": "p_099207230f",
  "Services managés": "p_3af7f1efc3",
  "Seuil de rentabilité": "p_5d25ea2d1d",
  "Signaux clés": "p_d1782d0ad0",
  "Skipped": "p_5a000ad7bd",
  "Social charges": "p_72d3fc64f7",
  "Social Charges": "p_75e813258b",
  "Socle non distribuable — base du 725a": "p_c72238f559",
  "Solde (vue)": "p_84e166a3f1",
  "Solde à ce jour": "p_a702ea40e9",
  "Solde automatique : TO − Absence − Billable − Non billable (pool overhead pur)": "p_81a6f663c6",
  "Solde bilan": "p_0cec075853",
  "Solde d'ouverture": "p_2118f144b7",
  "Solde de capacité non facturé (TR − TF)": "p_9220fc9f9b",
  "solde de clôture": "p_da385aea0d",
  "Solde de clôture": "p_0b59c4dd16",
  "Solde de clôture · réel + prévisionnel": "p_0fef0e4816",
  "Solde de clôture du bilan · 12 mois roulants": "p_22337fd8a1",
  "solde de clôture du bilan · réel + prévisionnel 12M": "p_a0e90f95c3",
  "Solde de dette au bilan": "p_4d2c7da668",
  "Solde de liquidité": "p_562f678de4",
  "Solde de roulement (déplier pour le détail)": "p_29fe22f677",
  "Solde de trésorerie": "p_2eb9bf52dd",
  "Solde de trésorerie initial": "p_f81450f7c0",
  "Solde de trésorerie projeté · 12 mois roulants": "p_ca881fa2d9",
  "Solde des charges indirectes": "p_9a3fc48edd",
  "solde dette fin": "p_26280dc79c",
  "Solde fin 2025": "p_653504a156",
  "Solde final": "p_eafcc35f43",
  "Solde final de trésorerie": "p_aa9e2afcf7",
  "Solde initial": "p_78a4e543fc",
  "solde initial / burn": "p_3570e51101",
  "Solde initial de trésorerie": "p_aa418bac27",
  "Solde minimum": "p_63bdab3a22",
  "Solde réel sous la <strong>ligne de crédit</strong> sur au moins un mois": "p_fdad444872",
  "Solde théorique": "p_08ce60c45e",
  "soldes au": "p_82903b2c13",
  "soldes de fin de mois · départ 31.12.": "p_0af663eb6e",
  "Sommaire": "p_ad2b581430",
  "Somme :": "p_01700f0d31",
  "Soumis à la TVA (clic pour exclure — export / exonéré)": "p_2f3f7d6770",
  "Soumis aux charges sociales.": "p_fdb59e2bcd",
  "Soumis TVA": "p_1d6f360ccd",
  "source": "p_828d338a9b",
  "Source": "p_6da13addb0",
  "source {{year}}": "p_7168557472",
  "Source des charges de personnel du plan. L'onglet <b>Charges personnel</b> s'adapte au mode choisi.": "p_f1cfc0d490",
  "sous seuil": "p_84aacc2538",
  "sous seuil {{amount}}": "p_15abb4b697",
  "sous-activité": "p_99fc4f71c1",
  "Sous-activité": "p_ca5514f8cd",
  "Sous-activité @ CCR": "p_1dce073b94",
  "Sous-titre (ex. régie, client, description…)": "p_e4d82d4919",
  "Sous-total": "p_306e7e8b4b",
  "Sous-total assurances": "p_1386bcda22",
  "Sous-total charges salarié": "p_e37463cb94",
  "Sous-total charges sociales (salarié + employeur)": "p_1557f3d31f",
  "Sous-total cotisations": "p_cb3cbb5777",
  "Sous-traitance, partenaires.": "p_5f3e290317",
  "stable": "p_4fbacc2fa0",
  "Standard": "p_2dfa66079d",
  "Standard vs Progress côte à côte : utilisation, CCR, CHR, idle": "p_960777d4e1",
  "Statut": "p_659499f38a",
  "Stock": "p_bcecf4562f",
  "Stocks": "p_a037c2c3c8",
  "Structure": "p_9482c5d5bf",
  "structure · carve · effectif": "p_d570d2fdd8",
  "Structure de financement": "p_42d0fba2f4",
  "Structure du Bilan — lignes par bloc": "p_5e5979c257",
  "Structure du Compte de résultat — lignes par bloc": "p_707b22b597",
  "Structure du P&L — lignes par bloc": "p_43711dc04e",
  "Suivant →": "p_ea96c11e6b",
  "Suivi de la liquidité": "p_f8afbebf23",
  "Suivi des liquidités": "p_3c1376b0be",
  "Supervision (heures)": "p_5832d0a552",
  "Supervision H.": "p_d3e8befb3b",
  "Supervision production": "p_9d4e54be79",
  "Supprimer": "p_1acfc1c7d7",
  "Supprimer « {{label}} » ?": "p_c58fbdf8c9",
  "Supprimer « {{label}} » ? Les comptes affectés seront démappés.": "p_3489f6ac73",
  "Supprimer (les comptes seront démappés)": "p_f0efae511f",
  "Supprimer {{count}} collaborateur(s) ?\n{{preview}}\n\n": "p_cf7ffff655",
  "Supprimer {{count}} collaborateur(s) ?\n{{preview}}\n\nLes contrats, compléments annuels et taux LPP seront supprimés en cascade. Action irréversible.": "p_d72d61b84a",
  "Supprimer {{count}} complément(s) ? Action irréversible.": "p_339ede64b0",
  "Supprimer {{count}} contrat(s) ? Action irréversible.": "p_82343930e5",
  "Supprimer {{count}} frais ? Action irréversible.": "p_5febd4a1ff",
  "Supprimer {{count}} indemnité(s) ? Action irréversible.": "p_d2dcd0d1a6",
  "Supprimer {{count}} ligne(s) ? Action irréversible.": "p_1a84c19584",
  "Supprimer {{label}}": "p_d4c3ab6bbe",
  "Supprimer ce contrat ?": "p_d18dfadb81",
  "Supprimer ce contrat de {{name}} ?": "p_158b297a8c",
  "Supprimer ce profil": "p_658f1de06d",
  "Supprimer ce profil personnalisé ?": "p_7c66c5b74a",
  "Supprimer ce scénario et toutes ses données ?": "p_33364ccf0a",
  "Supprimer ce taux ?": "p_0ce7f9bc9b",
  "Supprimer cette année": "p_2a3232f5c1",
  "Supprimer cette assurance ?": "p_652afa3412",
  "Supprimer cette écriture ?": "p_845abdca3f",
  "Supprimer cette ligne": "p_df86a218cc",
  "Supprimer cette ligne ?": "p_4cc8c59fb5",
  "Supprimer cette prime ?": "p_2b6c604a88",
  "Supprimer cette variation ?": "p_0d8e8c23f0",
  "Supprimer l'ajustement": "p_4a3e6bfd04",
  "Supprimer l'instantané": "p_885de7ba7e",
  "Supprimer la catégorie": "p_259713bbe8",
  "Supprimer la ligne": "p_176113680b",
  "Supprimer la page « {{name}} » ? Ses rapports repassent en « à placer » (non supprimés).": "p_9c58a7677d",
  "Supprimer le groupe ressources « ": "p_404f87ef31",
  "Supprimer le rapport": "p_5c49d9a6b9",
  "Supprimer le rapport « {{name}} » ?": "p_59b7d4d017",
  "Supprimer les {{count}} mouvements (toutes années) ?": "p_378eb9710b",
  "Supprimer les collaborateurs sélectionnés": "p_e2afbb3c2b",
  "Supprimer les compléments sélectionnés": "p_387ba9aaf9",
  "Supprimer les frais sélectionnés": "p_e7dc55a567",
  "Supprimer les indemnités sélectionnées": "p_b869c176e1",
  "Supprimer toutes les": "p_b824bc517c",
  "Supprimer toutes les lignes du scénario": "p_53c46986f1",
  "sur 12 mois": "p_7045780dd6",
  "sur la période (YTD)": "p_88bb38e51f",
  "sur les actifs circulants ou les dettes court terme (hors Liquidité, reprise dans le solde initial).": "p_d6376fb96a",
  "surendettement": "p_31f24dd56e",
  "Surendettement": "p_379d8b779e",
  "Surface card (blanc)": "p_1e9fff464c",
  "Surface page (zone contenu)": "p_059f9b761a",
  "Surface rail (navigation)": "p_1b5f3a6ee0",
  "Surfaces — échelle d’élévation": "p_1efc5144fa",
  "Synthèse": "p_ab761b3579",
  "Synthèse — masse salariale (à date → atterrissage)": "p_4aa797884f",
  "Synthèse (fusion paramètres + valeurs calculées)": "p_ee11a5f6a2",
  "Synthèse annuelle": "p_544722d684",
  "synthèse cash flow · 12 mois": "p_954b7a0e2c",
  "SYNTHÈSE CHARGES DE PERSONNEL · ": "p_942388468e",
  "Synthèse coûts & capacité · tous les groupes": "p_04513859f1",
  "Synthèse coûts du personnel": "p_9591d97938",
  "synthèse mensuelle complète — snapshot": "p_6d72b9c090",
  "Synthèse par pool": "p_0e1fcfccf7",
  "Synthèse par service": "p_45261a857c",
  "SYNTHÈSE PERSONNEL · ": "p_08525929ea",
  "Synthèse prévisionnelle": "p_027b635ace",
  "Ta question…": "p_3f9a1a1bc6",
  "Table centrale partagée par tous les scénarios Cash 12M sur l'année": "p_cb061d45a7",
  "Tableau de flux de trésorerie": "p_5581d03326",
  "Tableau mensuel": "p_d177ebd1f0",
  "Tableau mensuel — avec rattrapages éditables + mémo popup": "p_ea89c2f6e9",
  "Tarif": "p_915e818c2e",
  "Tarif de vente cible CHF/h (saisie CHR) — référence vs le réalisé. Pied = moyenne pondérée par H. TF.": "p_c1dffbf379",
  "taux": "p_3b8dd7fecd",
  "Taux": "p_18bc95b8ec",
  "Taux & échéancier": "p_c23dc6d984",
  "Taux & échéancier des charges sociales": "p_33f5593f20",
  "Taux charges sociales employé": "p_49bd6dbf3b",
  "Taux charges sociales employé (hors LPP), du contrat ou valeur de repli de l'entreprise.": "p_fb626f4a26",
  "Taux charges sociales employeur (hors LPP), du contrat ou valeur de repli de l'entreprise.": "p_29097cbcb7",
  "Taux CS constaté (réalisé) — ": "p_dc1e1d1e65",
  "Taux d'activité": "p_a48842269e",
  "Taux d'activité (1.0 = 100%)": "p_ea1e9f934a",
  "Taux d'activité × mois actifs ÷ 12": "p_b74cd5a17f",
  "Taux d'activité × mois actifs ÷ 12 (ex. 80% sur 6 mois = 40%)": "p_5211d393de",
  "Taux d'amortissement annuel (%)": "p_7839ae86d3",
  "Taux d'intérêt annuel (%)": "p_fe4dd1c5cd",
  "Taux d'occupation": "p_b41fa46572",
  "Taux de fonds propres (autonomie financière)": "p_69ac28f489",
  "Taux de rotation": "p_bf17c6ba86",
  "Taux de TVA du tenant absent — délai non calculé (pas de repli silencieux).": "p_6d409c4685",
  "Taux dette fiscale nette (%)": "p_24c0de1ebb",
  "Taux employé (%)": "p_4da80e1e0d",
  "Taux employeur (%)": "p_7c6bae8ea2",
  "Taux et échéancier des charges sociales": "p_9da13c9373",
  "Taux légaux appliqués automatiquement (en gris) ; saisir seulement si taux différent (ex. hébergement 3,8 %).": "p_bc28fd168b",
  "Taux mensuel en % du CA net": "p_a3393f06d2",
  "Taux mutualisé (identique pour tous)": "p_b60a9b3b86",
  "Taux patronaux et salariaux par scenario": "p_0867701dd4",
  "Taux TVA (%)": "p_64f3f28c2d",
  "Télécharger le fichier": "p_8b67be1c73",
  "Télécharger le fichier Excel": "p_0b18a05eae",
  "Télécharger tous les onglets en Excel (.xlsx)": "p_e05c4bf2d6",
  "Téléphone + internet": "p_46f8b6568c",
  "Temps — de l'opérationnel à la capacité pratique": "p_31bdcc9cd5",
  "Temps de production": "p_8521b0fd13",
  "Temps de production (TF)": "p_40d13bc299",
  "Temps de production annuel réalisé — source du CCR": "p_8b81d6277e",
  "Temps de vacances standard (h)": "p_7d0e1179a7",
  "Temps facturé (TF)": "p_74f32552f3",
  "Temps ouvert": "p_cbbe6b5d7b",
  "Temps ouvert (TO)": "p_dcf6e0e541",
  "Temps ouvert = TT − vacances (réparties linéairement, ÷ 12)": "p_4f7e65b4d8",
  "Temps ouvert cumulé depuis janvier (1 EPT)": "p_23105c4765",
  "Temps ouvert standard (TO, h)": "p_c2be968eda",
  "temps payé": "p_0cf8d85e5b",
  "temps payé total": "p_99ac6a9750",
  "Temps prod.": "p_388cc3797b",
  "temps productif disponible": "p_06674a2aa3",
  "Temps total (TO)": "p_6a07ed3275",
  "Temps total (TT, h)": "p_1bff440270",
  "Temps total (TT)": "p_74e17bec1c",
  "Tendance": "p_add2e69302",
  "Terminer": "p_6bf1bd74a9",
  "Texte": "p_ff9afef1ea",
  "Texte atténué": "p_25692e8021",
  "Texte sur tint": "p_fe4f8a9aca",
  "texte, tables, formulaires": "p_f41090e397",
  "Théo. pro-rata (h)": "p_393ed927ff",
  "Tirer du bilan": "p_e6bead4942",
  "Titre": "p_eb97899aed",
  "titres de page, en-têtes": "p_23cdc0d219",
  "TO (h)": "p_d4b2ad7417",
  "TO (Operational time) = heures travaillées disponibles, nettes des congés payés": "p_27a0f6db65",
  "Total": "p_b25928c699",
  "TOTAL": "p_5c6505ae3c",
  "Total · ": "p_354d2b684d",
  "Total / an": "p_a6925e9e24",
  "Total / Moy.": "p_0c4626f934",
  "Total / Moyenne": "p_dd286be622",
  "Total / Moyenne · ": "p_a1ad03c258",
  "Total & variations mensuelles": "p_09806c32bd",
  "Total %": "p_7403e47c01",
  "Total 12 m": "p_b5e455a4a7",
  "Total annuel": "p_a28bd8ca6f",
  "Total annuel — {{label}}": "p_12bd2ec427",
  "Total annuel — édition redistribue proportionnellement": "p_3ab8de48be",
  "Total annuel :": "p_13b1bb04dd",
  "Total annuel ÷ nombre de jours indemnisés": "p_1d8c5cdac0",
  "Total bruts": "p_bae1a927c1",
  "Total charges calculées": "p_f952d1d51a",
  "Total charges sociales": "p_e552fdbd8a",
  "Total charges sociales (salarié + employeur)": "p_7f74d4e2a8",
  "Total cumulé": "p_39523e9ef8",
  "Total décaissement": "p_4e9a44e7cf",
  "Total décaissements": "p_4bfd386410",
  "Total décaissements d'exploitation": "p_6e89760b5b",
  "Total des frais": "p_795cbdc76e",
  "Total des postes ouverts (point de départ)": "p_444661227e",
  "Total dette": "p_0aff89b75f",
  "Total empl. %": "p_b121118a3f",
  "Total empr. %": "p_784bdc8089",
  "Total encaissé HT": "p_0659ba617c",
  "Total encaissements": "p_4dbf0d306a",
  "Total encaissements (TVA incl.)": "p_7d91621daf",
  "Total EPT": "p_c1bb204540",
  "Total facturé HT": "p_a5cc1bacce",
  "Total FTE": "p_3d5234346e",
  "Total FTE (somme des FTE annuels)": "p_4fb3fb2c5a",
  "Total heures jours ouvrés (h)": "p_618b52ec56",
  "Total Hors TVA": "p_fd9ac76119",
  "Total libre": "p_0225c28547",
  "Total libre : le drag modifie la valeur sans redistribuer.": "p_cac90c5d51",
  "Total liquidités": "p_296ec9ec38",
  "Total personnel": "p_37246617e0",
  "Total verrouillé": "p_493664be05",
  "Total verrouillé : le drag redistribue proportionnellement sur les autres mois.": "p_de4704c0c0",
  "Tous": "p_b97ae3b4f9",
  "TOUS": "p_be314a133a",
  "Tous les comptes sont mappés": "p_c9875be557",
  "tous les groupes": "p_44fdd123e3",
  "Tous les groupes": "p_f6e8238da0",
  "Tout agréger": "p_1b42aec625",
  "Tout calculé par employé puis agrégé. · ": "p_cd40fa167d",
  "Tout cocher": "p_471e908212",
  "Tout décocher": "p_0757b3a4d2",
  "Tout dégrouper": "p_cd6a99eda8",
  "Tout déployer": "p_0cfb029544",
  "Tout désélectionner": "p_d17ec0b747",
  "Tout effacer": "p_e3b1822fdc",
  "Tout est classé ✓": "p_84af1b40eb",
  "Tout grouper": "p_934bcf4947",
  "Tout sélectionner": "p_06f2c1c0f0",
  "Toutes les années": "p_1a5f0b8c14",
  "Toutes les données de l'entreprise active vers un fichier Excel (.xlsx).": "p_1ea4d8ca75",
  "toutes les tables de saisie": "p_beb9e8ed48",
  "TR ÷ h pour 100 % FTE": "p_f7567232ac",
  "TR × CCR — coût complet de capacité (doit sommer au coût total People/CCR)": "p_645626fcdb",
  "Travail direct": "p_b3b1013e67",
  "Treasury engine — calcSalaires / calcPersonnel cohérents": "p_49f2eeabd8",
  "Treasury engine — non-régression sur scénario canonique": "p_7fdc65b66b",
  "Treasury engine — resolveScenario sur dérivés Optimiste/Pessimiste": "p_c8f7b69729",
  "Trésorerie": "p_e0e75da7e7",
  "Trésorerie — solde de clôture · réel + prévisionnel": "p_58ef733e6a",
  "Trésorerie & placements": "p_7bbdf75922",
  "Trésorerie + créances + stocks − dettes fourn.": "p_f26cb24ead",
  "trésorerie ÷ coûts fixes mensuels": "p_1c57ebaa9c",
  "Trésorerie =": "p_cc21988dc4",
  "Trésorerie = <strong>{{months}} mois</strong> de salaire": "p_2f39161217",
  "Trésorerie = <strong>{{months}} mois</strong> de salaire (&lt; 2)": "p_c2a9deedaf",
  "Trésorerie 12M": "p_b357625a1e",
  "Trésorerie actuelle": "p_e56baa3d53",
  "Trésorerie au bilan (liquidités)": "p_5c1c7fed8e",
  "Trésorerie début de période": "p_4334f990b3",
  "Trésorerie dispo.": "p_9282e742dd",
  "Trésorerie disponible": "p_0e0af55ddf",
  "Trésorerie fin de période": "p_4c1930ead9",
  "Trésorerie N-1": "p_65a3c1b43a",
  "Trésorerie N-1 (bilan, pointillé)": "p_2d723d5922",
  "Trésorerie projetée": "p_ffeb08ea81",
  "Trier par nom": "p_cffdd5bf18",
  "Trier par prénom": "p_26fa7c77ad",
  "Trier par prénom ou nom": "p_341b2d83e7",
  "TVA": "p_fb62cb5dae",
  "TVA à facturer (en sus)": "p_44aab6ef59",
  "TVA à payer (en sus)": "p_88ca633947",
  "TVA déductible (fournisseurs)": "p_0e40378963",
  "TVA déductible sur achats": "p_ce0215edd3",
  "TVA déductible sur charges": "p_2d24a419b8",
  "TVA encaissée": "p_b7f6bbb3e5",
  "TVA nette versée à l'AFC": "p_82436a2d02",
  "TVA nette versée à l’AFC": "p_46a60ed002",
  "TVA récup.": "p_8a8aed0c00",
  "Type": "p_3deb745651",
  "Type de revenu (prestations / marchandises / autres)": "p_0e60e5f61d",
  "Typographie — 2 voix": "p_67cf5c69ac",
  "un seul, à l": "p_26e5d20f7f",
  "Un taux laissé vide conserve la valeur en vigueur de la personne. Le CHF mensuel est recalculé sur le salaire de référence.": "p_089ca462e6",
  "Un taux par ligne de revenu. Coût des ventes = Σ (ligne × taux).": "p_9e7d250efd",
  "une autre ligne — montant dérivé d": "p_b2dd47ceca",
  "Une ligne = un employé : identité + contrat + LPP.": "p_5a525ffbfb",
  "Une ligne par collaborateur, pré-remplie sur l'année de travail.": "p_2b36cdfb63",
  "Une tranche tombe hors de l'horizon": "p_1717c47a98",
  "Unité": "p_388fd9c409",
  "Unité CHF ou kilo-CHF": "p_ddc0626012",
  "Usage capacité (réel)": "p_3b350c81fa",
  "Usage du temps": "p_11a6981d7b",
  "Utilisation globale": "p_a71ecc8b8a",
  "Utilisation, CHC / CHB, coût de l'idle par pool": "p_18854a3b25",
  "Utilise « + Nouvelle » ou « Copier… » pour le créer.": "p_5d0118659a",
  "VA / EPT": "p_2d40ff69ec",
  "VA 12 mois glissants / EPT (kCHF)": "p_b29b1789a4",
  "VA/EPT & Coût/EPT — actuel vs 2025": "p_fd5d143c93",
  "Vacances": "p_18126f6593",
  "Vacances & congés": "p_adb616f8c9",
  "Valeur": "p_68f92b0dd4",
  "Valeur (CHF)": "p_6efc2707d4",
  "Valeur (heures)": "p_e8901deab8",
  "Valeur ajoutée": "p_a372154f84",
  "Valeur ajoutée (% du CA net)": "p_af1d1b540b",
  "Valeur ajoutée par EPT": "p_755b12eddd",
  "Valeur ajoutée par EPT : {{amount}}": "p_ff34e21b6a",
  "Valeur fixe": "p_84e10831ab",
  "Valeur fixe par mois prévisionnel (CHF)": "p_6384b61463",
  "Valeur ouverte": "p_0950e4d1b8",
  "Valeur requise pour ce champ.": "p_3b8b7ffa2e",
  "valeurs en k CHF · axe Y zoomé · base ": "p_8edd8d26e3",
  "Valeurs mensuelles HT (CHF)": "p_8b96f01977",
  "Var. créances-clients": "p_e2b69099d5",
  "Var. fournisseurs": "p_2654b6b312",
  "Var. stocks": "p_0ca3db438c",
  "Variable (commissions, apporteur)": "p_bfb204a1cc",
  "Variation de trésorerie": "p_9fb16e3da2",
  "Variation de trésorerie depuis le 31.12.": "p_22a710a7e2",
  "Variation de trésorerie depuis le 31.12.{{year}} : <strong>{{amount}}</strong>": "p_b4d2fc027f",
  "Variation des actifs existants": "p_e1cebd2399",
  "Variation des lignes existantes": "p_2e5d49e2f7",
  "Variation du besoin en fonds de roulement": "p_2fedabfcb4",
  "Variation nette de trésorerie": "p_00d0cdaf09",
  "Variation nette du BFR": "p_b94d80cebe",
  "Variation totale de trésorerie": "p_93d44da931",
  "Variation vs {{year}} (proj.) : {{signedAmt}} {{unit}} · {{signedPct}}%": "p_29751d6655",
  "Variation vs 2025 (proj.) : {{delta}}": "p_df91b197ab",
  "Variations chiffrées & rôles sémantiques": "p_cf11b86023",
  "Variations cumulées": "p_c0dd159a3f",
  "Variations de masse salariale (embauche / départ / augmentation)": "p_5b6ee75409",
  "vendredi": "p_851996c0dc",
  "vendu · réel": "p_a4670844fa",
  "Ventes": "p_9087fc4f63",
  "Ventes & refacturations IT, modulées sur Q4.": "p_4486dfe2e6",
  "Ventes de marchandises": "p_5ea3dfcedf",
  "Ventes encaissées (HT)": "p_fde1dafd98",
  "Verrouiller le total": "p_42cd243f52",
  "Vers": "p_abd795b01c",
  "versé en": "p_2713343fa0",
  "Versement annuel prépayé en janvier.": "p_f10a189285",
  "Versement annuel prépayé sur un seul mois (Q1 par défaut).": "p_4e6c67beb9",
  "Vider les sous-entités du scénario (paramètres conservés)": "p_dfd91faa76",
  "Vider toutes les charges indirectes pour": "p_336f6f638d",
  "Vider toutes les lignes": "p_866fb79c61",
  "Vider toutes les sous-entités de \"{{name}}\" ? Le scénario et ses paramètres seront conservés.": "p_caeab24aca",
  "Voir le détail complet · {{tab}} →": "p_b71b372954",
  "Voir les contrats": "p_86f82c11c9",
  "Voir les modes de prévision": "p_c99787ac03",
  "Voir les personnes": "p_6d20be4b41",
  "Voyages & déplacements": "p_9acd481e4b",
  "vs 2025": "p_c21205ff0b",
  "vs N−1": "p_ac21cf2074",
  "vs Total cost (synthèse)": "p_dd3939a600",
  "Δ effectif net": "p_d5e3e78282",
  "Δ masse fin / début": "p_bfa72f0664",
  "Δ vs baseline": "p_f9e188f015",
  "Σ des lignes de l’onglet Frais (brut, indemnités reçues exclues)": "p_c6f5a03884",
  "Σ FTE (somme des équivalents temps plein, ex 21.6)": "p_666133fc95",
  // Offre (04.09.2026), ajoutées à la main : clé = sha1 de la phrase.
  "Aucune offre pour ce client.": "p_30b1165125",
  "CA reconnu": "p_45b967b8e1",
  "Catalogue": "p_5a24102340",
  "Choisir un client.": "p_3c4355faa9",
  "Compte de CA": "p_6df15015a4",
  "Modèle": "p_9853170f16",
  "Nouvelle offre": "p_0f8bc7c005",
  "Offre": "p_77583a4d90",
  "Offre supprimée": "p_4f64ae01ab",
  "Offre…": "p_3b2890f08c",
  "Produit": "p_ff673dc28e",
  "Produits": "p_48000473cd",
  "Reprendre les cards": "p_e098d95e49",
  "Reprendre les cards du plan des ventes": "p_8125b65092",
  "Services": "p_5cbd584046",
  "Supprimer l'offre": "p_64f33070d3",
  "Tarif HT": "p_81e46e3237",
  "Tout": "p_6b0b09b8a6",
  "carnet d'heures": "p_b76faf6ce4",
  "ce que l'entreprise vend, et comment chaque offre se facture et se reconnaît": "p_b8880f7c6a",
  "chaque mois": "p_bad248c22c",
  "délai…": "p_ff953be581",
  "heure": "p_0d4da47fa2",
  "jour-homme": "p_897c523bc2",
  "le mois même": "p_92db3ba83f",
  "négoce": "p_e692768b07",
  "offre(s) reprise(s) des cards": "p_21d4737351",
  "prestation": "p_3b72b9d90c",
  "produit (unités)": "p_ebb061846f",
  "préfacturé": "p_4155dde139",
  "récurrent": "p_4bcd772d8d",
  "unité": "p_d48fa2471c",
  "volume annuel": "p_13c99bc706",
  "à attribuer": "p_9012b981bb",
  "à l'échéance": "p_9e60913fe7",
  "à la livraison": "p_0bf67eb530",
  "à la vente": "p_42f0892d92",
  "étalé sur": "p_7796f338a6",
  "Assiette × taux": "p_71e8a75b74",
  "Base × revenu unitaire": "p_90730c43b5",
  "Capacité × occupation × tarif": "p_b754277134",
  "Projet / forfait": "p_084536c7d2",
  "Temps × tarif": "p_29b6754dc9",
  "Volume × prix unitaire": "p_641cd73e3d",
  "assiette à désigner": "p_beed702150",
  "capacité": "p_ae803b5526",
  "montant": "p_aa2789fc53",
  "occupation": "p_75afa87237",
  "par projet": "p_39ea5ac24d",
  "place": "p_9da8f1fa7d",
  "prix unitaire": "p_d10c8cb60f",
  "revenu unitaire": "p_65d2848b1a",
  "selon l'avancement": "p_b5a23e779c",
  "tarif": "p_5c2b41b582",
  "Équation": "p_1cd96e2895",
  "Glisser pour réordonner": "p_c16557a5ed",
  "montant du projet": "p_2d8bdaff3a",
  "prix de référence": "p_c66afbade2",
  "tarif de référence": "p_5411841ded",
  "montant de référence": "p_70eaad9032",
  "Coût direct": "p_855a05d736",
  "Capacité × occupation": "p_9de09e8f62",
  "Coût dir.": "p_ba551edd13",
  "Reconnu": "p_5a9b8bc0aa",
  "Réf.": "p_7f0a8d72da",
  "Volume × prix": "p_a2c2895b69",
  "assiette": "p_3198ebbc11",
  "avancement": "p_3086fce200",
  "jours entre la facture et son encaissement": "p_a1eff3f7c8",
  "mois sur lesquels le CA se répartit quand il est étalé": "p_db59cf5da4",
  "par mois": "p_5f10ecc3dc",
  "par tranches": "p_5e20bc7808",
  "prix": "p_9352ee4da5",
  "projet": "p_0046db513f",
  "règles": "p_ce02b51a38",
  "Étalé": "p_3435747283",
  "à désigner": "p_e932be92e5",
  "étalé": "p_8a5ce1cd83",
  "Prix cible": "p_a4c1a5af21",
  "étalé sur…": "p_7b9c89536e",
  "Changer le pictogramme": "p_6cb744bbed",
  "sur": "p_3d54fd66df",
  "Ouvrir le détail": "p_01ab196c2f",
  "Pictogramme": "p_7b4bdf5ff4",
  "Capacité": "p_25bc0fbf3c",
  "Assiette": "p_de18e968ee",
  "oui": "p_5898fc8603",
  "non": "p_37031f99ac",
  "% occupation": "p_98c7754c58",
  "Aucune offre active : le catalogue de l'Offre est vide.": "p_54c3f4afa3",
  "CA": "p_09acbb7d1d",
  "Compte de CA à attribuer": "p_0175de82cf",
  "Par compte": "p_40fab869b4",
  "Par offre": "p_401cf14252",
  "Plan par offre": "p_18dfb9761f",
  "Prix unitaire": "p_3e848c9611",
  "Total CA": "p_b7fb384e4b",
  "Trajectoire": "p_3a7dd6f408",
  "Volume": "p_3b18e8e332",
  "base": "p_1405df66cb",
  "calculé": "p_2e10e6d78e",
  "heures": "p_d88ed6f697",
  "jours": "p_6abe3deea7",
  "projets": "p_7d5f116421",
  "unités": "p_b2ec0bf5fd",
  "Quantités": "p_5b81b126ed",
  "entières (1 au moins)": "p_24c9c11e13",
  "décimales autorisées": "p_ad867d98c6",
  "produit": "p_0e57b0e7da",
  "service": "p_4cf5bc59be",
  "Abonnement, licence, location": "p_ff05a1c066",
  "Autre": "p_43dacf9e47",
  "Commission, frais sur assiette": "p_cba0a48efd",
  "Conseil, régie": "p_1c3165c1f2",
  "Espace, place, chambre": "p_ea06dcf4c9",
  "Formation": "p_bc0bd86b8f",
  "Produit vendu": "p_102dff6b64",
  "Projet, mandat forfaitaire": "p_0c502ca2d5",
  "Services managés, maintenance": "p_28a71e61b3",
  "Transport, livraison": "p_bfaefd310c",
  "Volume mesuré (énergie, litres, km)": "p_2001a8344e",
  "à la commande": "p_35753d94c7",
  "au début de chaque période": "p_33baa750e9",
  "tous les…": "p_32058a2ac7",
  "tous les": "p_558e594687",
  "Acompte": "p_79f9f1012a",
  "Coût variable": "p_e90f851c98",
  "Coût variable en %": "p_905f6f38bd",
  "Prix indicatif": "p_42fd65471c",
  "Paiement": "p_0564e9bab5",
  "à la facture, selon le DSO": "p_669aa613a2",
  "d'avance, à la commande": "p_c6a18a0f6e",
  "mois après la commande": "p_45ce52b3d5",
  "livraison sous": "p_50bc2cd2df",
  "tranche": "p_65049dada1",
  "reste": "p_49d6710114",
  "participant": "p_7a2110450a",
  "Colonnes": "p_53a2544cac",
  "Prix": "p_2d5eddef33",
  "Grouper": "p_42c8f672af",
  "Aucune offre active dans cette nature.": "p_3669a2a06d",
  "Compte à attribuer": "p_318ac01bb5",
  "Reconnaissance revenu": "p_10bd4fc0d3",
  "à la facture": "p_86fda5bdec",
  "le mois de la facture": "p_6f3dcec10b",
  "à préciser": "p_acda5f1833",
  "Planification": "p_1762431633",
  "par volume": "p_0a267697f0",
  "au montant": "p_202ce8fa19",
  "Montant planifié": "p_a58b7f6542",
  "valeur": "p_4b17ab7b33",
  "n/a": "p_50f013532a",
  "le mois suivant": "p_69ea62b347",
  "mois après": "p_2b38d7abc0",
  "Plan mensuel": "p_594a3513a3",
  "Flux": "p_889e1c2f52",
  "Fenêtre": "p_3d69166531",
  "mensualisé": "p_4c0804021b",
  "linéaire": "p_e9be614956",
  "saisonnalité": "p_600d59380f",
  "profil de l'offre": "p_382ea26ff3",
  "Portefeuille": "p_c230321f37",
  "Couverture de l'objectif": "p_2e0006b37b",
  "Confirmé": "p_5b629ae70c",
  "À gagner": "p_1ae6388135",
  "Atterrissage": "p_9f5fa7c1c0",
  "Objectif": "p_47d1c260dc",
  "Écart à l'objectif": "p_1a6bbef05d",
  "Reste à sécuriser": "p_8fb884ee57",
  "Engagement": "p_4b1f1c7b9c",
  "Nouvel engagement": "p_d4991cfc93",
  "Retirer l'engagement": "p_61c3f704b8",
  "non daté": "p_f4772ccbc5",
  "Couverture": "p_9c9ad4f70e",
  "Commandes": "p_1727597023",
  "Offres remises": "p_5cddfda1fb",
  "Opportunités": "p_0dbfa3c5da",
  "signé, reste à réaliser": "p_67008a1b2d",
  "proposé, pas encore gagné": "p_827defe795",
  "repéré, sans offre remise": "p_79991f0951",
  "Affaire": "p_5063813022",
  "Nouvelle affaire": "p_00c7ac5dce",
  "Retirer l'affaire": "p_23947b54f5",
  "Solde connu": "p_8e05c5f8d7",
  "Retenu": "p_e2ad9bf0d1",
  "À répartir": "p_69fc0f702f",
  "Origine du solde": "p_b837304463",
  "contrat moins livré": "p_82b7afe085",
  "solde saisi": "p_f3a159000f",
  "Montant du contrat": "p_e9a249d614",
  "Livré cumulé": "p_5ca4927dfa",
  "Solde à réaliser": "p_4516b95e56",
  "Retenu après probabilité": "p_8c1cb1a5b5",
  "retenu à": "p_d2eb94cc3c",
  "Prévisionnel identifié": "p_571baa929c",
  "Reste à vendre": "p_0911654733",
  "Aucune affaire dans cette catégorie.": "p_72c2461ec6",
  "total": "p_5a537e2091",
  "à rattacher": "p_edae393ea9",
  "Le catalogue de l'Offre est vide : une affaire s'y rattache.": "p_be09dc5bf2",
  "Aucune commande en carnet.": "p_d17c1bf8e0",
  "Aucune offre remise.": "p_f170c772d0",
  "Aucune opportunité identifiée.": "p_e0c2ac5cd5",
  "Plan des ventes": "p_15c29ad49a",
  "Valeur connue": "p_51e8b4b2e0",
  "Modification": "p_e3ea079ded",
  "Valeur retenue": "p_5c08f4c69f",
  "Reste à délivrer": "p_8b130cec79",
  "Solde à reporter": "p_0425010f24",
  "Reporter sur": "p_c67a95aa9b",
  "sans compte": "p_f4f41c0b5b",
  "Valeur totale": "p_9927915b44",
  "Solde": "p_e5977cf9a9",
  "Solde ouvert": "p_c1c2dd144e",
  "Solde reporté": "p_9d9a4ba89c",
  "À facturer": "p_acd40e67d7",
  "Facturation prévue par offre": "p_7bb06e1e79",
  "Les trois flux, mois par mois": "p_597e76b820",
  "Les trois flux": "p_b937e34301",
  "choisir une offre pour ajuster ses quantités": "p_9ec23bedfd",
  "lecture seule, dépliable par offre": "p_7572785077",
  "Total facturation": "p_bd7c4d9910",
  "quantités à livrer": "p_52be84ab9f",
  "montants à prévoir": "p_218df5b0b1",
  "saisie directe en francs": "p_07fbed5401",
  "prix du plan, sans ressaisie mensuelle": "p_345bfbf62b",
  "Prix du plan": "p_daa483519f",
  "montant hors taxe": "p_e1e552207b",
  "Facturation calculée": "p_ce1a754a67",
  "montant mensuel direct": "p_8bd4c06eed",
  "quantités × prix du plan": "p_5d5afa46e1",
  "Livré": "p_0a1317e96a",
  "réalisé": "p_e3abea940f",
  "prix moyen de la Trajectoire": "p_efb71fd190",
  "prix indicatif de l'Offre": "p_9381882d47",
  "montée en charge": "p_8b68bda6c9",
  "Aucune offre dans cette nature.": "p_32d8ea79f4",
  "Forfait, intervention": "p_920ca2e8d0",
  "Droits & usages": "p_1b19baee28",
  "Droit d'usage": "p_a348fe61e9",
  "Abonnement d'accès": "p_7be1d64eeb",
  "Licence, droit d'exploitation": "p_263c931cdf",
  "Location de matériel": "p_9a102a951c",
  "Volume mesuré (énergie, litres, poids)": "p_380f5b6b63",
  "Modèle personnalisé": "p_c78feaf12d",
  "sur facture": "p_ba6e2f4fae",
  "anticipé": "p_9773205710",
  "Nb de mois": "p_060f6dc05a",
  "Service forfaitaire": "p_ddc7458134",
  "mensuelle": "p_5f4c1a3db4",
  "Produit physique": "p_fc10baf656",
  "Volume mesuré": "p_4645ca64b8",
  "Où en est l'exercice": "p_5a51772f3c",
  "Prévisionnel annuel · CA reconnu": "p_9f2f74d5fc",
  "Exercice": "p_e171e2b01d",
  "Réalisé à fin": "p_bb0b48366b",
  "Futur prévu": "p_b8be2820ed",
  "Prévisionnel annuel": "p_bcf3cbe11d",
  "Dont carnet de commandes": "p_16c96ac1ed",
  "non renseigné": "p_bc09cb635f",
  "Objectif · plan de référence": "p_07a2e3f91d",
  "réalisé + futur prévu": "p_d50cf1af5d",
  "Les": "p_7985fe5134",
  "mois à venir": "p_168db57124",
  "Réalisé séparé du futur prévu": "p_18cd36852f",
  "n.r. = non renseigné, et non zéro. Le futur prévu ne permet pas de déduire le carnet.": "p_028121aea9",
  "Par famille d'offres": "p_af530f3199",
  "Famille": "p_3b0121d325",
  "Facturation, CA & encaissement": "p_ac5c2f0452",
  "Modèles utilisés": "p_f41c839897",
  "cocher ce que l'entreprise vend ; les autres ne seront plus proposés": "p_292aa70fcd",
  "Offres": "p_1b2f74c258",
  "Ce modèle porte déjà des offres.": "p_fbf6b0caab",
  "facturé": "p_aaea9ca5ec",
  "reconnu sur": "p_b7c8916b13",
  "reconnu le mois même": "p_e82f915759",
  "quantités décimales": "p_28d87b5d57",
  "quantités entières": "p_4dab7918c8",
  "Voir le reste": "p_f489855596",
  "un modèle par ligne, avec les valeurs que chaque offre nouvelle recevra": "p_46770af6d6",
  "CA sur n mois": "p_16a9e79f14",
  "entières": "p_5c9322f792",
  "décimales": "p_b65bd476f2",
  "ce que l'entreprise vend, et comment chaque offre se facture": "p_23e1faefa8",
  "Généralités": "p_2e49e62ef7",
  "Prix & marges": "p_f197aed0f6",
  "Conditions": "p_5506eb6161",
  "Échéancier": "p_7930f4ee21",
  "Modèles": "p_0f7183be84",
  "Plan": "p_ae2f98a099",
  "Ponctuel": "p_e290182fb4",
  "Récurrent": "p_7953924520",
  "À l'usage": "p_578b4d19ec",
  "2 mois après": "p_8cfe599799",
  "3 mois après": "p_faaae03b90",
  "6 mois après": "p_646eedf766",
  "Aucun calendrier à saisir ici.": "p_03d0c37b99",
  "CA le mois même": "p_211a62e419",
  "CA reconnu sur": "p_bf9c6ab3fe",
  "CA réparti sur": "p_a15afe6f76",
  "Comment vendez-vous cette offre ?": "p_5c816f4224",
  "Compte de chiffre d'affaires": "p_ae1b19291e",
  "Conditions ajustées": "p_dc9752ca7a",
  "Conditions ajustées pour cette offre.": "p_836822f947",
  "Conditions habituelles proposées pour ce modèle.": "p_d7e44dcc57",
  "Conditions proposées": "p_eb0ae6af55",
  "Créer l'offre": "p_5bb3abb2e9",
  "Dans le plan, vous saisirez": "p_fe19d9496f",
  "Des carnets vendus par mois": "p_37cf524f46",
  "Des contrats et un revenu par période": "p_7c0214b6ea",
  "Des heures par mois, à un tarif": "p_ec95da169f",
  "Des kilomètres par mois": "p_71bfe0e23e",
  "Des licences et un revenu par période": "p_c1eb5facac",
  "Des participants par mois": "p_aa23e55ff8",
  "Des quantités par mois, à un prix": "p_cd30a9255f",
  "Des services par mois, à un prix": "p_aceff8a612",
  "Des unités louées et un loyer": "p_99beee4743",
  "Des volumes consommés par mois": "p_c280538cdd",
  "Donnez un nom à votre offre.": "p_f9df2822e2",
  "Le chiffre d'affaires se calcule": "p_9e8c18d7ba",
  "Les mois viendront de votre plan.": "p_d470de0e69",
  "Montant du projet": "p_ae526bc9a7",
  "Nom de l'offre": "p_20b7c7a114",
  "Par défaut": "p_4550c68ee1",
  "Prix indicatif (CHF)": "p_d8ae1f1bd2",
  "Produit ou prestation": "p_57720218e9",
  "Quantité × prix": "p_d981633c28",
  "Selon l'équation choisie": "p_f097183a26",
  "Taux (%)": "p_bb9a8c5ada",
  "Un montant, un début, une fin": "p_10fa92af71",
  "Un taux d'occupation par mois": "p_1ec9667263",
  "Un taux sur l'assiette choisie": "p_a10b87e7d5",
  "Une base et un revenu par période": "p_2e41b98a7b",
  "Valeur indicative d'un projet (CHF)": "p_6b3957802b",
  "Votre offre est paramétrée ainsi": "p_6ee0e73883",
  "Vous choisirez l'équation et toutes les conditions.": "p_4b6ad15374",
  "Vous saisirez des carnets vendus par mois ; le revenu se répartit ensuite.": "p_170d9e2ac7",
  "Vous saisirez des contrats et un revenu par période.": "p_a304addbd7",
  "Vous saisirez des heures ou des jours par mois, à un tarif.": "p_0b5066d7e0",
  "Vous saisirez des kilomètres par mois, à un prix.": "p_5512a56b49",
  "Vous saisirez des licences et un revenu par période.": "p_7dc5cbf774",
  "Vous saisirez des participants par mois, à un prix.": "p_8407a576f2",
  "Vous saisirez des quantités par mois, à un prix unitaire.": "p_688904c9b2",
  "Vous saisirez des services rendus par mois, à un prix.": "p_2337b9dcbd",
  "Vous saisirez des unités louées et un loyer par période.": "p_1559851fcf",
  "Vous saisirez des volumes par mois, à un prix unitaire.": "p_5fafcc9793",
  "Vous saisirez un montant, un début et une fin par projet.": "p_a995fd0629",
  "Vous saisirez un taux d'occupation par mois.": "p_b692512ff2",
  "Vous saisirez un taux, appliqué au revenu de référence.": "p_0c2572c709",
  "Vous saisirez une base d'abonnés et un revenu par période.": "p_caa919ae09",
  "autrement : je règle tout moi-même": "p_394a4ab3ae",
  "avant la livraison": "p_58a4c4500e",
  "du temps passé : régie, à l'heure ou à la journée": "p_335dd626c9",
  "du transport, au kilomètre": "p_8bdf3baa80",
  "par échéancier": "p_7d7d1b6d3b",
  "tous les n mois": "p_756e1486e7",
  "un abonnement : un droit qui court, par période": "p_8e9e3e4f05",
  "un carnet d'heures, vendu d'avance": "p_c585d29447",
  "un forfait : un montant convenu, un projet, un mandat": "p_6deedcd0df",
  "un produit, à l'unité": "p_e4ea998517",
  "un service managé, facturé par période": "p_f594c506be",
  "un service à la pièce : révision, dépannage, inspection": "p_a31487251e",
  "un volume consommé : kilomètre, litre, kilowattheure": "p_e6b12307c8",
  "une capacité occupée : places, chambres, postes": "p_4da512f127",
  "une commission : un pourcentage d'un autre revenu": "p_8a756d6728",
  "une formation, par participant": "p_f56b251004",
  "une licence, un droit d'exploitation": "p_7d8c7ac30d",
  "une location de matériel": "p_543e5e1da3",
  "à choisir": "p_944e5348f8",
  "du temps de prestation": "p_0c915841dc",
  "du transport": "p_7de718604e",
  "sur demande": "p_765df97780",
  "un abonnement ou une licence": "p_d8bc5afea9",
  "un carnet d'heures": "p_1a4462508b",
  "un mix, sous forme de projet": "p_4d70e21e47",
  "un modèle personnalisé": "p_61ee50ee2d",
  "un produit physique, à l'unité": "p_a0617236a9",
  "un service managé": "p_5526755fa3",
  "un service à la pièce": "p_9d6ac2259c",
  "un volume consommé": "p_32b3af79e5",
  "une capacité occupée": "p_49ca4564d0",
  "une commission": "p_9c6123527b",
  "une formation": "p_1f4e8bcedf",
  "une licence": "p_8b9ba6187f",
  "une location": "p_a5febab72c",
  "Vous vendez autrement ? Écrivez-nous, nous créons le modèle qu'il vous faut.": "p_c3bcea09ca",
  "un service récurrent": "p_814349f461",
  "Vous vendez autrement ? Écrivez-nous : nous créons votre modèle sur demande.": "p_fed76e02a4",
  "Modifier l'offre": "p_74f1a9aa35",
  "Enregistrer": "p_f7c8bcd8b2",
  "Comment le planifiez-vous ?": "p_df5d7ba789",
  "Revenu par période (CHF)": "p_e4d39e6cb4",
  "en base installée, à un revenu par période": "p_6df3e9dce2",
  "en capacité, à un taux d'occupation": "p_fc2d9c94e1",
  "en heures ou en jours, à un tarif": "p_2f1b17a2c6",
  "en montant, tapé tel quel": "p_2ee6f93786",
  "en pourcentage d'un autre revenu": "p_e4bdce091e",
  "en quantités, à un prix unitaire": "p_1817159c65",
  "Des carnets vendus par mois ; le revenu se répartit ensuite.": "p_ace352bc2f",
  "Des contrats et un revenu par période.": "p_1f3b9fbf6e",
  "Des heures ou des jours par mois, à un tarif.": "p_7c74ad2f72",
  "Des kilomètres par mois, à un prix.": "p_40efc698d7",
  "Des licences et un revenu par période.": "p_91d645d16d",
  "Des participants par mois, à un prix.": "p_f5e16b6647",
  "Des quantités par mois, à un prix unitaire.": "p_09bd39590f",
  "Des services rendus par mois, à un prix.": "p_b39ae03de0",
  "Des unités louées et un loyer par période.": "p_9f21fb127e",
  "Des volumes par mois, à un prix unitaire.": "p_419595d3e2",
  "Prix (CHF)": "p_14507806ca",
  "Un montant, un début et une fin par projet.": "p_c38586ed9b",
  "Un taux d'occupation par mois.": "p_d6cfe41c59",
  "Un taux, appliqué au revenu de référence.": "p_272de212bd",
  "Une base d'abonnés et un revenu par période.": "p_ae36ddea9b",
  "des heures par mois, à un tarif": "p_a254a1624d",
  "des quantités par mois, à un prix": "p_529a12d325",
  "un montant par mois, tapé tel quel": "p_a38087de85",
  "un taux d'occupation par mois": "p_b5b09bc7d4",
  "un taux sur l'assiette choisie": "p_ff915c516a",
  "une base et un revenu par période": "p_8522b1569f",
  "Conditions habituelles": "p_fced6674e6",
  "en montant forfaitaire": "p_c3cbcb80f3",
  "un montant par mois": "p_c0f809dd0b",
  "en valeur": "p_e1acf31731",
  "une valeur par mois": "p_b25f8772bf",
  "pièce": "p_a25ed70db2",
  "Reconnaissance des revenus": "p_8cb6334d5c",
  "Facturation et paiement": "p_26b16bb390",
  "Compte de revenu": "p_3885f625e4",
  "Reconnaissance": "p_a9f8c2a8f0",
  "sur plusieurs mois": "p_03ef080dfb",
  "Cliquer pour changer": "p_bc844f509b",
  "Palestre : demande d'un nouveau modèle d'offre": "p_8e99d4a054",
  "des quantités livrées par mois, à un prix": "p_78bd016f4a",
  "Sur": "p_5972a71994",
  "Sur le mois": "p_688cd5c276",
  "des quantités livrées par mois": "p_3bffbee22b",
  "à un prix moyen": "p_d5367fba84",
  "Comptabilisation": "p_87cf8493dc",
  "en heures, à un tarif horaire": "p_eaeadfa0e4",
  "en jours-hommes, à un tarif journalier": "p_f8bb15c4c6",
  "en EPT, à un revenu par EPT": "p_982cbf2479",
  "EPT": "p_ec08f4dd84",
  "du temps par mois": "p_91f2562b43",
  "à un tarif": "p_08566f33f0",
  "Des": "p_0e2b0dbfa1",
  "jours-hommes": "p_134440acb7",
  "une vente sous forme de projet": "p_d1aa02464a",
  "produit physique, vendu à l'unité": "p_bf44d0249e",
  "temps de prestations": "p_41a0c840f4",
  "formation": "p_776c6153e0",
  "service récurrent": "p_714b47e86d",
  "abonnement & licence": "p_7d842182ce",
  "des heures par mois": "p_a0c6109b47",
  "des jours-hommes par mois": "p_140006de9e",
  "des EPT par mois": "p_d2519c8304",
  "en nombre de participants, à un prix unitaire": "p_bbbd9d3ccd",
  "en nombre de formations, à un prix unitaire": "p_8571ec48a0",
  "des participants par mois": "p_30c43b1b87",
  "des formations par mois": "p_c42c4bdf14",
  "Aucune offre active.": "p_bd83f48253",
  "à la commande, renouvelable": "p_9f0fa49aa6",
  "le mois de la livraison": "p_601e23d906",
  "1 mois avant la livraison": "p_f05f5102d2",
  "mois avant la livraison": "p_db5bdfc633",
  "à la commande, tous les": "p_e9d9deaef5",
  "commande": "p_bc007655e6",
  "Délai de livraison": "p_35ac60e9bb",
  "livraisons": "p_53f0716483",
  "temps livré": "p_d288e3d1b5",
  "base installée": "p_2df7b5f324",
  "taux d'occupation": "p_c19898a0d4",
  "valeur livrée": "p_1cb6192cf4",
  "Plan des livraisons": "p_a2a2f302a9",
  "ce que vous livrez chaque mois : quantités, temps, base installée ou valeur ; la facture en découle": "p_641de414ed",
  "chaque offre, ses livraisons, puis ce qu'elles facturent et ce qu'elles reconnaissent": "p_32dd3649ce",
  "Total CA reconnu": "p_dd866502f1",
  "Vous planifiez": "p_003bb2dc35",
  "les livraisons": "p_1944abeed1",
  "les commandes": "p_f276c6aa17",
  "commandes": "p_7cefc05149",
  "des quantités commandées par mois": "p_356cde7751",
  "chaque offre : son CA, sa facture, puis ce qu'on saisit": "p_95d9eb37c4",
  "des carnets vendus par mois": "p_d2114d7d2c",
  "Total encaissement": "p_2b227630f4",
  "ce que vous saisissez, par offre et par mois ; la ligne de l’offre en fait le total et la valeur": "p_ebf3e7c542",
  "Entreprise": "p_d03e74b6f3",
  "l'offre sur laquelle vous êtes, ligne par ligne ; Échap pour revenir à l'entreprise": "p_d140f32be8",
  "l'entreprise ; cliquer une offre en haut pour lire la sienne": "p_45d6025cc7",
  "solde": "p_506c0f1b92",
  "les tranches dépassent 100 %": "p_499961531c",
  "Les tranches dépassent 100 %.": "p_553bbead62",
  "Valeur du plan": "p_bf22710c9f",
  "valeur commandée": "p_0c3991b62a",
  "une valeur commandée par mois": "p_cbb9635402",
  "Tarif horaire (CHF)": "p_7b03259772",
  "Tarif journalier (CHF)": "p_b2721ddcbb",
  "Lire en heures ou en jours-hommes": "p_5506fc4e5c",
  "Livraisons": "p_d92281da18",
  "en heures ou en jours-hommes, à un tarif": "p_e498ad669e",
  "des heures ou des jours-hommes par mois": "p_b1a570afec",
  "Durée (mois)": "p_2e60323180",
  "ce que vous saisissez, par offre et par mois": "p_e57fe5db85",
  "Commandé": "p_e460aa5013",
  "Prix moyen": "p_662b2f9fe2",
  "Reste": "p_68135bb8f1",
  "ce qui est commandé, livré et facturé sur les mois clos ; le portefeuille en découle": "p_aba6421623",
  "Aucun mois clos sur cette année : rien n’y est réalisé.": "p_3382535a66",
  "Reste à faire": "p_712d6e4638",
  "commandé − facturé = portefeuille ; objectif − facturé − portefeuille = à gagner ; portefeuille + à gagner = reste à faire": "p_0e689eb3f9",
  "objectif − CA = reste à faire ; reste à faire − portefeuille = à gagner": "p_808b038d7c",
  "prévision − CA = reste à faire ; reste à faire − portefeuille = à gagner": "p_9fe03a1f1b",
  "CA réalisé": "p_c06b5c0db0",
  "prévision − CA réalisé = reste à faire ; reste à faire − portefeuille = à gagner": "p_28de9e4930",
  "atterrissage − CA réalisé = reste à faire ; reste à faire − portefeuille = à gagner": "p_6acac5f57a",
  "atterrissage = CA réalisé + prévision ; prévision − portefeuille = à gagner": "p_b4b24a1190",
  "atterrissage = CA réalisé + reste à faire ; reste à faire − portefeuille = à gagner": "p_148fb1306c",
  "Dont portefeuille": "p_7d8aece988",
  "Dont": "p_4a4e0ab16f",
  "portefeuille": "p_41bb2f6fee",
  "CA réalisé à fin": "p_3a3f1c8264",
  "CA réalisé + reste à faire, face à l’objectif": "p_2442eeee23",
  "CA réalisé + reste à faire": "p_73e88d7793",
  "Détail par offre": "p_d636f30d0e",
  "Impacts financiers du plan des ventes": "p_2a2c07f7a6",
  "CA planifié": "p_1570dc9665",
  "Chiffre d'affaires": "p_0a341b9fa4",
  "planifié": "p_56fc927c14",
  "Total prévisionnel": "p_3aeca0aa28",
  "les commandes en main, par offre et par mois, dans l’unité du plan": "p_61b5daf301",
  "portefeuille total": "p_bf529ac1b3",
  "Les modèles existants": "p_7807a68fc5",
  "Mes offres": "p_9df336307c",
  "Plan pluriannuel": "p_ab21eb57e9",
  "Modèles sur demande": "p_04f07767cc",
  "Un modèle vous manque ?": "p_7f3902db91",
  "Décrivez votre offre en quelques lignes : nous l'ajoutons à Palestre et vous prévenons dès qu'elle est disponible.": "p_c07afa639e",
  "Demander un modèle": "p_e6c45e0a7c",
  "Des quantités vendues à un prix unitaire": "p_1b3286c545",
  "Des heures ou des jours-hommes à un tarif": "p_09312f1124",
  "Des carnets vendus, consommés sur plusieurs mois": "p_8bad8ddb71",
  "Des contrats facturés à chaque période": "p_1c63fb2115",
  "Un montant global, reconnu sur la durée": "p_4ccdf13395",
  "Des abonnés à un revenu unitaire": "p_f870fb8ca6",
  "Des participants ou des sessions à un prix": "p_45bb89b0fd",
  "Une capacité, un taux d'occupation, un tarif": "p_f168152178",
  "Planifié": "p_172deb1447",
  "Pilotage": "p_a647632d8f",
  "Portefeuille & prévisions": "p_3e6134f4a0",
  "Revenus & Marges": "p_9e15caa125",
  "Sans compte": "p_1aae9ca2e2",
  "Ancienne prévision": "p_252a0aaa48",
  "Prévisions des ventes": "p_27bab99874",
  "Tirer pour élargir la colonne": "p_65809e7e67",
  "Vue par": "p_e9453ae803",
  "Vue groupée": "p_05a60013ab",
  "les créances clients que le plan des ventes génère, mois ouverts": "p_ed531ecce3",
  "Facturation HT": "p_8b871faa7e",
  "Facturation TTC": "p_01889749b3",
  "Encaissements TTC": "p_3fd00cab92",
  "Variation des créances clients": "p_d7384cb8bb",
  "Encaissements HT": "p_8fb6faa611",
  "facturation TTC": "p_f70eaefd9c",
  "encaissements TTC": "p_b9a2519124",
  "Total planifié": "p_19773395bd",
  "3 ans": "p_d12a1e7114",
  "Coût unitaire": "p_3735acf6f4",
  "Connecté": "p_ce09957cfa",
  "Autonome": "p_d194b7a7f5",
  "Connecté au module Ventes : se planifie dans Ventes & Opérations › Impacts financiers": "p_8a5f5c4fcb",
  "Plan du personnel": "p_fe09b7a55b",
  "Connecté au module People : se planifie dans People › Prévisionnel": "p_b312015a27",
  "Ventes & Ops (ancien)": "p_7095dc7598",
  "Variation cumulée des créances clients": "p_afa824ef76",
  "selon les offres": "p_6fdc3d25c4",
  "Encaissé selon les conditions de paiement de chaque offre du plan des ventes": "p_172c6ef56b",
  "encaissé": "p_6b86b7f978",
  "connecté au module Ventes : facturation et encaissements TTC selon les conditions de chaque offre": "p_66cf7715dc",
  "CA prévisionnel avec la TVA selon les comptes, encaissé au DSO": "p_bd3b42f78e",
  "achats prévisionnels avec la TVA, payés au DPO": "p_f464863db8",
  "Nouvelles ventes": "p_265d6e1ebf",
  "Nouveaux achats": "p_4c2e045aa7",
  "le délai ne s'applique pas aux ventes du plan": "p_ebab3b9275",
  "nouvelles ventes": "p_e840544e3a",
  "nouveaux achats": "p_28a225ec51",
  "Source 01 · Comptabilité": "p_122cd5751d",
  "Lecture seule": "p_a958270ca5",
  "de postes ouverts": "p_13efa063df",
  "Solde au": "p_125c98c3c3",
  "point de départ du prévisionnel": "p_b14655f941",
  "Hypothèse": "p_774781693e",
  "encaissement hors arrangements": "p_87d525e671",
  "paiement hors arrangements": "p_7b2fb590fa",
  "en arrangements": "p_50552db44a",
  "soumis à cette répartition.": "p_a3ff6f4214",
  "Source 02 · Plan des ventes": "p_9eea5a6c8d",
  "Source 02 · Compte de résultat": "p_abe179c3a2",
  "Facturation TTC prévue": "p_9ca7c9e69e",
  "CA prévisionnel + TVA": "p_6509d5babc",
  "Achats TTC prévus": "p_e8f7ac874d",
  "Les nouvelles factures augmentent les créances, pas le CA reconnu.": "p_fa85457a42",
  "Le CA du compte de résultat, augmenté de la TVA selon les comptes.": "p_194537adc9",
  "Les nouveaux achats augmentent les dettes fournisseurs.": "p_b3a5ba2fc0",
  "paiement des nouvelles factures": "p_6e38ee9fe2",
  "paiement des nouveaux achats": "p_ab03297c7e",
  "Règle appliquée": "p_ff4c03917d",
  "Délais des offres": "p_f3ab67927d",
  "Encaissements repris du plan des ventes. Aucun DSO global ajouté.": "p_6f401a2787",
  "Délai moyen de règlement, base 360 jours.": "p_7fa76a3660",
  "Départ au dernier réel :": "p_2cd6f25b43",
  "montants TTC en": "p_cd13d8ea7c",
  "Source :": "p_2d3dff2c72",
  "module Ventes, facturation et encaissements planifiés": "p_44a1e98903",
  "compte de résultat, CA prévisionnel et TVA": "p_40dac56b64",
  "compte de résultat, achats prévisionnels et TVA": "p_c92789d8c2",
  "Encaissement hors arrangements": "p_184506c17e",
  "Paiement hors arrangements": "p_a01c870fdd",
  "Délai de paiement des fournisseurs": "p_c827aa1a70",
  "Connecté au module Ventes": "p_7dc6426477",
  "Non connecté au module Ventes": "p_ea18ab7174",
  "Connecté au module Ventes : cette ligne se tape, le coût des produits vendus vient du plan": "p_e619de5324",
  "Reprise en chiffre d'affaires": "p_b50f571886",
  "Facturé d'avance − reconnu (plan des ventes)": "p_2baccc9e4a",
  "Nouveaux acomptes encaissés": "p_7ec031516a",
  "Reprise des nouveaux acomptes": "p_9055a035fd",
  "d'acomptes clients": "p_d914ac36de",
  "linéaire, sur": "p_157cc6d1dc",
  "Facturé d'avance − reconnu": "p_8786fa8957",
  "Nouveaux acomptes": "p_c46eae9160",
  "module Ventes, facturation et CA reconnu planifiés": "p_38e69204cf",
  "compte de résultat, règles d'acomptes par ligne de revenus": "p_c0d1a3cc40",
  "Reprise du solde d'acomptes clients, réglée dans Trésorerie › Acomptes clients": "p_6a1f1ca517",
  // Prévisions des ventes (10.10.2026) : clé = sha1 de la phrase.
  "Aucun plan": "p_806619065a",
  "Aucun profil.": "p_67ecc768de",
  "Cible": "p_bebdb9b898",
  "Cible des ventes": "p_cca9c4b14d",
  "Comparer à": "p_1d2f40f57d",
  "Couleur": "p_145c4326e9",
  "Courante": "p_a0bd6ae644",
  "Créée le": "p_c4dc9951a9",
  "Dupliquer": "p_c5e1d3f16f",
  "Définir courante": "p_b087c2000f",
  "Impacts financiers": "p_b761adc80a",
  "Mensualisation": "p_2d95ad4c88",
  "Montants": "p_6b312baa12",
  "Non rattaché à une offre": "p_80fcfc2c2c",
  "Nouvelles": "p_f441d8e4a2",
  "Ouverte": "p_61589002cf",
  "Profil": "p_669fe25a32",
  "Profils de saisonnalité": "p_d8bac5d4e8",
  "Rendre tous les mois à la règle": "p_986876316c",
  "Réalisé lu de la comptabilité": "p_614bebdedc",
  "Supprimer cette ligne et tout ce qu’elle porte, réalisé compris ?": "p_88a868edb4",
  "Supprimer cette version et tout ce qu’elle porte ?": "p_77cb5aa938",
  "Utilisé par": "p_9c8d7f4c67",
  "Verrouillée": "p_af1427755a",
  "Version": "p_2da600bf94",
  "Versions de plan": "p_ca7d0c9f28",
  "Volumes": "p_39c0ee03f2",
  "base 100": "p_a9cbef6f24",
  "comparaison": "p_74ced900ea",
  "contre": "p_b50ace6e83",
  "copie": "p_e772852cfd",
  "dont effet": "p_124fb3cde5",
  "dont effet volume": "p_7744fb6eee",
  "dont réalisé": "p_2ad8165ebd",
  "dont à venir": "p_80f556b7c5",
  "détail par offre": "p_69d011f7da",
  "effet prix": "p_4cb6ec64be",
  "facturation": "p_d3e8a126dc",
  "montant planifié": "p_be57ce6b83",
  "offres au montant": "p_63ecc190d4",
  "par offre": "p_3e08200d37",
  "profil": "p_32862cceec",
  "prévu": "p_37c9337b62",
  "selon l'offre": "p_4741d39067",
  "ventes": "p_f38267895b",
  "volume": "p_d387fc8d57",
  "volumes": "p_e44dfa6f66",
  "Écart à la cible": "p_a4ff8b8be9",
  "Étape": "p_13146b48d0",
  "État": "p_d3b28a2adb",
  "à": "p_c34f17a35b",
  "à facturer": "p_a3d3d0ce1c",
  "à fin": "p_a484e2893b",
  "à la cible": "p_60ae916a7c",
  "à ventiler": "p_7cb826ff1d",
  "étape Année": "p_f7ebf13f01",
  "Catégories": "p_d463d7d2a3",
  "Offre · catégorie": "p_411471232c",
  "Facturation 12 mois glissants": "p_4c2efdbe85",
  "Saisonnalité de la facturation": "p_74c2674237",
  "Années retenues": "p_5505b953dc",
  "Part de l'année": "p_87391a7140",
  "non rattachée": "p_dce98eadcb",
  "Profils": "p_f78e0be059",
  "Effacer le réalisé des mois": "p_575747d8be",
  "Offre ou ligne…": "p_de7ba7593c",
  "prévision": "p_b0ff807755",
  "Le total de l'année devient la somme des mois": "p_5739625ba0",
  "Les mois se répartissent à nouveau depuis l'année, selon la règle": "p_dd76641453",
  "Répartir": "p_d7593598d3",
  "Par flux": "p_5c4c75063d",
  "Choisir le mode de saisie": "p_2c98b1c2aa",
  "Écart avec la comptabilité": "p_e11492613d",
  "Prévu à la clôture, pour mémoire": "p_b1931fcac3",
  "Total des ventes": "p_7e8b39e5c0",
  "CA à venir": "p_9ef73aef91",
  "Total des offres": "p_e3450a0f94",
  "Total, aligné sur la comptabilité": "p_97300546e1",
  "Prévisions": "p_78cba23a3f",
  "Trajectoire de ce plan": "p_3fb4cf376b",
  "Répartition": "p_9379f10d35",
  "Ventes par mois": "p_4c51221987",
  "Ouvrir pour retoucher un mois": "p_71808cfbaa",
  "CA du portefeuille": "p_21a80874f8",
  "CA des nouvelles ventes": "p_55f72a5b4c",
  "À venir": "p_5ae4e5874c",
  "Règle": "p_918a896de2",
  "par flux": "p_ad1e1c01d1",
  "à répartir": "p_112088b8a9",
  "Créée par": "p_d6072b98a9",
  "Budget": "p_7aeba4cd15",
  "Budget de référence": "p_eac6394899",
  "Copie de": "p_97b94598ea",
  "Créée": "p_a570b396f9",
  "Exercice de départ": "p_85b3a5b6c3",
  "Horizon": "p_eda24363a2",
  "Modifier la version": "p_a6675a4a75",
  "Nouvelle version": "p_8833189e12",
  "Prévision glissante": "p_6271554be2",
  "an": "p_de73eac0c3",
  "après l’exercice": "p_d84c63b3f0",
  "avance à chaque mois clôturé": "p_4c44e7fb19",
  "mois réalisés": "p_63d9768827",
  "planifiés": "p_289831af54",
  "% cumulé": "p_1c3be77dad",
  "% cumulé · 100 % en décembre": "p_6046657d60",
  "% de l’année": "p_6c2b924b18",
  "% de l’année · total 100 %": "p_6fce71601a",
  "Indices": "p_65e0495e30",
  "Indices · écart à la moyenne, 0 = mois moyen": "p_90599025b0",
  "Ouvrir l'atterrissage": "p_40a58e5ddb",
  "Réduire l'atterrissage": "p_c55a9f9e92",
  "Charger les profils de base": "p_738ef5ce1e",
  "Les profils de base sont déjà tous chargés.": "p_8c79c12fde",
  "Profil d’origine": "p_d0d943b80b",
  "Supprimer ce profil ?": "p_b420e60966",
  "Épingler l'atterrissage": "p_5400e75f1d",
  "Libérer l'atterrissage": "p_fe94e3307d",
  "Comparaison": "p_17198bad62",
  "au plan": "p_f104875626",
  "Atterrissage des offres": "p_3962f6177c",
  "milliers de francs": "p_30ddf3c3ae",
  "francs": "p_6f0b9efccf",
  "Réalisé + portefeuille + nouvelles ventes": "p_3b4db59713",
  "Écart au budget des offres": "p_b891072b74",
  "Écart à la cible des offres": "p_d0b681c873",
  "Chiffre d'affaires reporté en": "p_7b92146c60",
  "Hors atterrissage": "p_fe6e059d47",
  "Modifier la clôture dans Paramètres": "p_2e9d83e8aa",
  "Votre rôle n’a pas accès à ce module": "p_bc903d2ba7",
  "Ouvrir le menu": "p_43c7e150db",
  "Fermer le menu": "p_177b10aa35",
  "Tout déplier": "p_dcb00c011c",
  "Tout replier": "p_cc5dc22336",
  "CHF · %": "p_577a96c513",
  "Supprimer cette ligne de la Trajectoire ? Sa ligne dans les Prévisions part avec elle, portefeuille, nouvelles ventes, coût et réalisé compris.": "p_856a55afba",
  "Selon le plan des ventes": "p_6a50b63bd8",
  "Saisie libre": "p_5632c4869f",
  "Calcul des coûts des produits vendus": "p_fd2764622e",
};
